webpackJsonp([55],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.i18n = undefined;

var _toPrimitive = __webpack_require__(342);

var _toPrimitive2 = _interopRequireDefault(_toPrimitive);

var _keys = __webpack_require__(16);

var _keys2 = _interopRequireDefault(_keys);

var _isFinite = __webpack_require__(337);

var _isFinite2 = _interopRequireDefault(_isFinite);

var _typeof2 = __webpack_require__(27);

var _typeof3 = _interopRequireDefault(_typeof2);

var _classCallCheck2 = __webpack_require__(343);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(344);

var _createClass3 = _interopRequireDefault(_createClass2);

var _lodash = __webpack_require__(1);

var _compile = __webpack_require__(433);

var _compile2 = _interopRequireDefault(_compile);

var _resolve = __webpack_require__(434);

var _resolve2 = _interopRequireDefault(_resolve);

var _en = __webpack_require__(326);

var _en2 = _interopRequireDefault(_en);

var _hk = __webpack_require__(327);

var _hk2 = _interopRequireDefault(_hk);

var _cn = __webpack_require__(325);

var _cn2 = _interopRequireDefault(_cn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var i18n = function () {
  function i18n(options) {
    (0, _classCallCheck3.default)(this, i18n);
    this.lang = { en: _en2.default, hk: _hk2.default, cn: _cn2.default };
    this.local = 'en';
    this.fallbackLocal = 'en';

    if ((typeof options === 'undefined' ? 'undefined' : (0, _typeof3.default)(options)) === 'object') {
      (0, _lodash.merge)(this, options);
    }
  }

  (0, _createClass3.default)(i18n, [{
    key: 's',
    value: function s(key, def) {
      if (typeof key === 'string' || (0, _lodash.isArray)(key)) {
        var _arr = [this.local, this.fallbackLocal];

        for (var _i = 0; _i < _arr.length; _i++) {
          var l = _arr[_i];
          var value = (0, _lodash.get)(this.lang[l], key, undefined);
          if (value !== undefined) {
            return value;
          }
        }
        return def === undefined ? key : def;
      }
      return key;
    }
  }, {
    key: 'S',
    value: function S(dict, def) {
      if (typeof dict === 'string') {
        return dict;
      } else if ((typeof dict === 'undefined' ? 'undefined' : (0, _typeof3.default)(dict)) === 'object' && dict) {
        var _arr2 = [this.local, this.fallbackLocal];

        for (var _i2 = 0; _i2 < _arr2.length; _i2++) {
          var l = _arr2[_i2];
          var value = (0, _lodash.get)(dict, l, undefined);
          if (value !== undefined) {
            return value;
          }
        }
      }
      return def;
    }
  }, {
    key: 'nn',
    value: function nn(literals) {
      for (var _len = arguments.length, substitutions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        substitutions[_key - 1] = arguments[_key];
      }

      var res = literals[0];
      for (var i = 1; i < literals.length; i++) {
        if (arguments[i] != null) res += arguments[i];
        res += literals[i];
      }
      return res;
    }
  }, {
    key: 'f',
    value: function f(translationKey, args, options) {
      translationKey = this.s(translationKey);
      if (typeof translationKey === 'string') {
        var fn = (0, _compile2.default)(translationKey);
        args = args || {};
        if (args['i18n'] === undefined) {
          args['i18n'] = this.dict;
        }
        return this.nn.apply(this, (0, _resolve2.default)(fn, args, options));
      } else {
        return translationKey;
      }
    }
  }, {
    key: 'F',
    value: function F(dict, args, options) {
      dict = this.S(dict);
      if (typeof dict === 'string') {
        var fn = (0, _compile2.default)(dict);
        args = args || {};
        if (args['i18n'] === undefined) {
          args['i18n'] = this.dict;
        }
        return this.nn.apply(this, (0, _resolve2.default)(fn, args, options));
      } else {
        return dict;
      }
    }
  }, {
    key: 'fr',
    value: function fr(translationKey, args, options, maxDepth) {
      if (!(0, _isFinite2.default)(maxDepth)) maxDepth = 2;
      if (!options) {
        options = { partial: true };
      }
      var result = this.f(translationKey, args, options);
      while (maxDepth-- != 0) {
        var newResult = this.f(result, args, options);
        if (newResult == result) {
          break;
        }
        result = newResult;
      }
      return result;
    }
  }, {
    key: 'FR',
    value: function FR(dict, args, options, maxDepth) {
      if (!(0, _isFinite2.default)(maxDepth)) maxDepth = 2;
      if (!options) {
        options = { partial: true };
      }
      var result = this.F(dict, args, options);
      while (maxDepth-- != 0) {
        var newResult = this.f(result, args, options);
        if (newResult == result) {
          break;
        }
        result = newResult;
      }
      return result;
    }
  }, {
    key: 'install',
    value: function install(Vue) {
      var _this = this;

      Vue.mixin({
        computed: {
          i18n: function i18n() {
            return _this;
          }
        }
      });
    }
  }, {
    key: 'dict',
    get: function get() {
      return new Dynamic(this, []);
    }
  }, {
    key: 'langs',
    get: function get() {
      return (0, _keys2.default)(this.lang);
    }
  }]);
  return i18n;
}();

function Dynamic(i18n, path) {
  this.path = path;
  this.i18n = i18n;
  return new Proxy(this, {
    set: function set(self, prop, value, receiver) {
      console.warn('[i18n]', 'Attempted to modify dictionary: { key:', self.path.concat([prop]).join('.'), '}');
      return false;
    },
    has: function has(self, prop) {
      return self.i18n.s(self.path.concat([prop]), null) !== null;
    },
    get: function get(self, prop, receiver) {
      if (self[prop] === undefined) {
        return new Dynamic(self.i18n, self.path.concat([prop]));
      } else {
        return self[prop];
      }
    }
  });
}

Dynamic.prototype[_toPrimitive2.default] = Dynamic.prototype.valueOf = Dynamic.prototype.toString = function () {
  return this.i18n.s(this.path, this.path.join('.'));
};

var _default = new i18n();
exports.default = _default;
exports.i18n = i18n;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formActions = exports.fieldDefaults = undefined;

var _regenerator = __webpack_require__(19);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(18);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _defineProperty2 = __webpack_require__(12);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(345);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _messageBox = __webpack_require__(103);

var _messageBox2 = _interopRequireDefault(_messageBox);

var _base = __webpack_require__(9);

var _base2 = _interopRequireDefault(_base);

var _messageBox3 = __webpack_require__(102);

var _messageBox4 = _interopRequireDefault(_messageBox3);

var _promise = __webpack_require__(7);

var _promise2 = _interopRequireDefault(_promise);

var _taggedTemplateLiteral2 = __webpack_require__(30);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _keys = __webpack_require__(16);

var _keys2 = _interopRequireDefault(_keys);

var _getIterator2 = __webpack_require__(23);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _extends2 = __webpack_require__(22);

var _extends3 = _interopRequireDefault(_extends2);

var _typeof2 = __webpack_require__(27);

var _typeof3 = _interopRequireDefault(_typeof2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['<a title="', '" @click="view" href="javascript:void(0)">', '...</a>'], ['<a title="', '" @click="view" href="javascript:void(0)">', '...</a>']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['<span title="', '">', '...</span>'], ['<span title="', '">', '...</span>']);

exports.columnsFn = columnsFn;
exports.inlineSchema = inlineSchema;
exports.getField = getField;
exports.setField = setField;
exports.displayField = displayField;
exports.findKeyField = findKeyField;
exports.applyFieldDefaults = applyFieldDefaults;
exports.viewFn = viewFn;
exports.createFn = createFn;
exports.exportFn = exportFn;
exports.listFn = listFn;
exports.sanitizeModel = sanitizeModel;
exports.readFn = readFn;
exports.fieldSpecFinder = fieldSpecFinder;
exports.updateFn = updateFn;

var _lodash = __webpack_require__(1);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _vue = __webpack_require__(6);

var _vue2 = _interopRequireDefault(_vue);

var _index = __webpack_require__(2);

var _index2 = _interopRequireDefault(_index);

var _utils = __webpack_require__(15);

var _sweetalert = __webpack_require__(54);

var _sweetalert2 = _interopRequireDefault(_sweetalert);

var _service_location = __webpack_require__(45);

var ServiceLocation = _interopRequireWildcard(_service_location);

var _ExportDialog = __webpack_require__(492);

var _ExportDialog2 = _interopRequireDefault(_ExportDialog);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fieldDefaults = exports.fieldDefaults = {
  string: { component: 'f-input', inputType: 'text' },
  phone: {
    component: 'f-input', inputType: 'text', get: function get(model, spec) {
      return (0, _utils.formatPhone)((0, _lodash.get)(model, spec.prop));
    }
  },
  text: { component: 'f-textarea', list: false },
  number: { component: 'f-input', inputType: 'number' },
  boolean: {
    component: 'f-checkbox',
    filter: [{ label: 'action.yes', value: true }, { label: 'action.no', value: false }]
  },
  date: { component: 'f-datetime', t: 'date' },
  time: { component: 'f-datetime', t: 'time' },
  datetime: { component: 'f-datetime', t: 'datetime' },
  email: { component: 'f-input', inputType: 'email' },
  id: { component: 'f-id', list: false },
  label: { component: 'f-label', readonly: true },
  integer: { component: 'f-input', inputType: 'number', step: 1, validation: { numeric: true } },
  password: { component: 'f-input', inputType: 'password' },
  select: {
    component: 'f-select', postprocess: function postprocess(spec) {
      if ((0, _lodash.isArray)(spec.items)) {
        spec.items = (0, _lodash.map)(spec.items, function (k) {
          if (typeof k === 'string') {
            var v = (0, _lodash.last)(k.split('.'));
            return { label: _index2.default.fr(k), value: v };
          } else if ((typeof k === 'undefined' ? 'undefined' : (0, _typeof3.default)(k)) === 'object') {
            return (0, _extends3.default)({}, k, { label: _index2.default.fr(k.label) });
          }
        });
        spec.filter = (0, _lodash.map)(spec.items, function (x) {
          return { label: x.label, value: x.value };
        });
      }
      return spec;
    }
  },
  radio: { component: 'f-radio' },
  checkbox: {
    component: 'f-checkbox',
    filter: [{ label: 'action.yes', value: true }, { label: 'action.no', value: false }]
  },
  tags: { component: 'f-tags', list: false, hidden: true },
  schema: { component: 'f-schema', list: false, showActions: false },
  array: {
    component: 'f-array', list: false, postprocess: function postprocess(spec) {
      if (spec.itemType) {
        spec.itemType = applyFieldDefaults(spec.itemType);
      }
      return spec;
    }
  },
  link: { component: 'f-link', list: false },
  img: { component: 'f-img', list: false },
  file: { component: 'f-file', list: false },
  button: { component: 'f-button', list: false },
  table: { component: 'f-table', list: false, embed: false },
  i18n: {
    component: 'f-i18n', postprocess: function postprocess(spec) {
      if (spec.itemType) {
        spec.itemType = applyFieldDefaults(spec.itemType);
      }
      return spec;
    }
  },
  json: { component: 'f-json', list: false },
  html: { component: 'f-html', list: false }
};

function columnsFn(dbSchema) {
  return function (model, schema, readonly, table) {
    var temp = [];
    var columns = typeof dbSchema === 'function' ? dbSchema.call(this, model, schema, readonly, table) : dbSchema;

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = (0, _getIterator3.default)((0, _keys2.default)(columns)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var k = _step.value;

        var field = (0, _extends3.default)({}, columns[k]);
        var type = field.type;
        switch (field.type) {
          case String:
          case Number:
          case Boolean:
            type = field.type.name.toLowerCase();
            break;
          case Date:
            type = 'datetime';
        }
        if (fieldDefaults[type]) {
          var spec = {
            label: _index2.default.s('fields.' + (0, _lodash.last)(k.split('.')), k.split('_').map(_lodash.capitalize).join(' ')),
            prop: k,
            type: type,
            display: displayField
          };
          field.type = type;
          if (field.required) {
            spec.validation = { required: true };
          }
          field = (0, _lodash.defaultsDeep)(field, spec);
          field.label = (0, _lodash.isArray)(field.label) ? _index2.default.fr.apply(_index2.default, field.label) : _index2.default.fr(field.label);
          temp.push(field);
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return applyFieldDefaults(temp);
  };
}

function inlineSchema(dbSchema) {
  return {
    columns: columnsFn(dbSchema)
  };
}

function getField(model, spec) {
  return typeof spec.get === 'function' ? spec.get.call(this, model, spec) : (0, _lodash.get)(model, spec.prop);
}

function setField(model, spec, value) {
  var _set = this.$vueSet || this.$set || _lodash.set;
  if (typeof spec.set === 'function') {
    return spec.set.call(this, model, spec, value, _set);
  } else {
    try {
      _set(model, spec.prop, value);
    } catch (e) {
      console.warn(e);
    }
  }
}

function displayField(model, index, fieldSpec, schema, columns) {
  var _this2 = this;

  var value = getField.call(this, model, fieldSpec);
  if (value == null) {
    return { template: _index2.default.f('html.nil') };
  }
  var m = void 0;
  switch (fieldSpec.type) {
    case 'string':
    case 'number':
      return String(value);
    case 'boolean':
    case 'checkbox':
      return value ? { template: '<i class="ti-check"></i>' } : '-';
    case 'date':
      m = (0, _moment2.default)(value).local();
      return { template: '<span title="' + m.fromNow() + '">' + m.format('DD/MM/YYYY') + '</span>' };
    case 'time':
      return (0, _moment2.default)(value).local().format('hh:mm:ss');
    case 'datetime':
      m = (0, _moment2.default)(value).local();
      return { template: '<span title="' + m.fromNow() + '">' + m.format('DD/MM/YYYY HH:mm') + '</span>' };
    case 'id':
      if (typeof schema.view === 'function') {
        return {
          template: _index2.default.nn(_templateObject, value, value),
          methods: {
            view: function view() {
              var _this = this;

              schema.view.call(this.$parent, model, index, schema, columns).catch(function (err) {
                err = (0, _utils.parseError)(err);
                _this.$notify({
                  component: {
                    template: _index2.default.f('alert.html.$err', { err: err })
                  },
                  icon: 'ti-alert',
                  horizontalAlign: 'center',
                  verticalAlign: 'top',
                  type: 'danger'
                });
              });
            }
          }
        };
      } else {
        return { template: _index2.default.nn(_templateObject2, value, value) };
      }
    case 'tags':
      return value ? value.join(', ') : '';
    case 'schema':
      return fieldSpec.schema.title.call(this, value, fieldSpec.schema);
    case 'select':
      if ((0, _lodash.isArray)(fieldSpec.items)) {
        return (0, _lodash.get)((0, _lodash.find)(fieldSpec.items, function (x) {
          return x.value === value;
        }), 'label');
      }
      return '';
    case 'array':
      return (0, _lodash.map)(value, function (x, idx) {
        return displayField.call(_this2, value, 0, (0, _extends3.default)({}, fieldSpec.itemType, { prop: idx }), schema, columns);
      }).join(', ');
    case 'i18n':
      return displayField.call(this, value, 0, (0, _extends3.default)({}, fieldSpec.itemType, { prop: _index2.default.local }), schema, columns);
  }
  return value;
}

function findKeyField(columns) {
  return (0, _lodash.find)(columns, function (x) {
    return x.type === 'id';
  });
}

function applyFieldDefaults(spec) {
  if ((0, _lodash.isArray)(spec)) {
    return (0, _lodash.map)(spec, applyFieldDefaults);
  }
  var defaults = fieldDefaults[spec.type];
  if (defaults) {
    var clone = (0, _extends3.default)({}, defaults);
    var fn = clone.postprocess;
    delete clone['postprocess'];
    spec = (0, _lodash.defaultsDeep)(spec, clone);
    if (typeof fn === 'function') {
      spec = fn(spec);
    }
  }
  return spec;
}

function viewFn(urlTemplate) {
  return function (model, index, schema, columns, newWindow) {
    var url = void 0;
    var id = void 0;
    if (typeof model === 'string') {
      id = model;
    } else {
      var field = findKeyField(columns);
      if (field) {
        id = getField.call(this, model, field);
      }
    }
    if (id) {
      if (urlTemplate != null) {
        url = urlTemplate.replace(':id', id);
      } else {
        url = (0, _lodash.trimEnd)(this.$route.path, '/') + '/' + id;
      }
      if (newWindow || window.event && (window.event.ctrlKey || window.event.shiftKey || window.event.metaKey)) {
        var a = document.createElement("a");
        a.target = "_blank";
        a.href = url;
        document.body.appendChild(a);
        a.click();
        setTimeout(function () {
          document.body.removeChild(a);
        }, 100);
      } else {
        this.$router.push(url);
      }
    }
    return _promise2.default.resolve();
  };
}

function createFn(urlTemplate) {
  return function (schema, columns) {
    var id = 'create';
    var url = void 0;
    if (urlTemplate != null) {
      url = urlTemplate.replace(':id', id);
    } else {
      url = (0, _lodash.trimEnd)(this.$route.path, '/') + '/' + id;
    }
    this.$router.push(url);
    return _promise2.default.resolve();
  };
}

function exportFn(fields, processRow) {
  return function (schema, columns) {
    var self = this;
    return (0, _messageBox4.default)({
      title: _index2.default.fr('action.export_$obj', { obj: schema.title.call(self, null, schema) }),
      type: null,
      showCancelButton: false,
      showConfirmButton: false,
      closeOnPressEscape: false,
      closeOnClickModal: false,
      message: self.$createElement(_ExportDialog2.default, {
        key: +new Date(),
        props: {
          schema: schema,
          columns: columns,
          fields: fields,
          processRow: processRow,
          $rootTable: self
        }
      })
    }).then(function () {}, function () {});
  };
}

function listFn(endpoint, preprocess, httpOptions, postprocess) {
  return function list(_ref, schema, columns) {
    var skip = _ref.skip,
        limit = _ref.limit,
        status = _ref.status,
        options = (0, _objectWithoutProperties3.default)(_ref, ['skip', 'limit', 'status']);

    if (!skip || skip < 0) skip = 0;
    if (!limit || limit < 0) limit = 9999;
    if (status === undefined) status = 'active';

    var payload = (0, _extends3.default)({ endpoint: endpoint, skip: skip, limit: limit, status: status }, options);
    var _httpOptions = void 0;
    if (typeof httpOptions === 'function') {
      _httpOptions = httpOptions.call(this, payload, schema, columns);
    } else {
      _httpOptions = httpOptions;
    }
    if (typeof preprocess === 'function') {
      payload = preprocess.call(this, payload, schema, columns);
    }
    var p = _vue2.default.http.post('', payload, _httpOptions);
    if (typeof postprocess === 'function') {
      return postprocess.call(this, p);
    } else {
      return p.then(function (response) {
        var result = response.body;
        if (!(0, _lodash.isArray)(result.data)) {
          result.data = [];
        }
        if (result.total == null) {
          result.total = result.data.length;
        }
        return result;
      });
    }
  };
}

function sanitizeModel(model, columns) {
  var wait = [];
  var self = this;
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    var _loop = function _loop() {
      var col = _step2.value;

      var value = getField.call(self, model, col);
      if (value == null && col.default != null) {
        var def = typeof col.default === 'function' ? col.default.call(self, model, col) : col.default;

        if ((typeof def === 'undefined' ? 'undefined' : (0, _typeof3.default)(def)) === 'object' && typeof def.then === 'function') {
          wait.push(def.then(function (x) {
            return setField.call(self, model, col, x);
          }));
        } else {
          setField.call(self, model, col, def);
        }
      } else {
        if (col.type === 'array' || col.type === 'tags' || col.type === 'select' && col.multi) {
          if (!(0, _lodash.isArray)(value)) {
            setField.call(self, model, col, []);
          }
        } else if (col.type === 'schema' && !col.external) {
          if ((typeof value === 'undefined' ? 'undefined' : (0, _typeof3.default)(value)) !== 'object' || value == null) {
            if (col.readonly && value == null) {
              return 'continue';
            }
            setField.call(self, model, col, {});
            value = getField.call(self, model, col);
          }
          var temp = typeof col.schema.columns === 'function' ? col.schema.columns.call(self, model, col.schema, col.readonly, false) : col.schema.columns;
          wait.push(sanitizeModel.call(self, value, temp));
        } else if (col.type === 'i18n') {
          if ((typeof value === 'undefined' ? 'undefined' : (0, _typeof3.default)(value)) !== 'object' || value == null) {
            setField.call(self, model, col, {});
          }
        } else if (col.type === 'json') {
          if (typeof value === 'undefined') {
            setField.call(self, model, col, null);
          }
        }
      }
    };

    for (var _iterator2 = (0, _getIterator3.default)(columns), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var _ret = _loop();

      if (_ret === 'continue') continue;
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  return _promise2.default.all(wait).then(function () {
    return model;
  });
}

function readFn(endpoint, keyName, preprocess, httpOptions, postprocess) {
  return function read(id, schema, columns) {
    var payload = (0, _defineProperty3.default)({ endpoint: endpoint }, keyName, id);
    var _httpOptions = void 0;
    if (typeof httpOptions === 'function') {
      _httpOptions = httpOptions.call(this, payload, schema, columns);
    } else {
      _httpOptions = httpOptions;
    }
    if (typeof preprocess === 'function') {
      payload = preprocess.call(this, payload, schema, columns);
    }
    var p = _vue2.default.http.post('', payload, _httpOptions);
    if (typeof postprocess === 'function') {
      return postprocess.call(this, p);
    } else {
      return p.then(function (response) {
        var result = response.body;
        if (!result.data) {
          console.error(response);
          throw new Error(_index2.default.f('alert.invalid_response', { response: response }));
        }
        return result.data;
      });
    }
  };
}

function fieldSpecFinder(model, schema, readonly) {
  var _this3 = this;

  var map = {};

  var walkColumn = function walkColumn(path, _model, spec, target, cacheOnly) {
    var key = path.join('.');
    map[key] = spec;
    if (target === key || cacheOnly) {
      return true;
    }
    if (spec.type === 'array') {
      var _value = getField.call(_this3, _model, spec);
      if ((0, _lodash.isArray)(_value)) {
        var found = false;
        for (var i = 0; i < _value.length; ++i) {
          var p2 = path.concat([i]);
          found |= walkColumn(p2, _model, spec.itemType, target, found);
        }
        return found;
      }
    } else if (spec.type === 'schema') {
      var _value2 = getField.call(_this3, _model, spec);
      if (walkSchema(path, _value2, spec.schema, target)) {
        return true;
      }
    }
  };
  var walkSchema = function walkSchema(path, _model, _schema, target) {
    var columns = typeof _schema.columns === 'function' ? _schema.columns.call(_this3, _model, _schema, readonly) : _schema.columns;
    columns = columns || [];
    var found = false;
    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
      for (var _iterator3 = (0, _getIterator3.default)(columns), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
        var spec = _step3.value;

        var p2 = path.concat([spec.prop]);
        found |= walkColumn(p2, _model, spec, target, found);
      }
    } catch (err) {
      _didIteratorError3 = true;
      _iteratorError3 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion3 && _iterator3.return) {
          _iterator3.return();
        }
      } finally {
        if (_didIteratorError3) {
          throw _iteratorError3;
        }
      }
    }

    return found;
  };

  return function (targetPath) {
    if ((0, _lodash.isArray)(targetPath)) {
      targetPath = targetPath.join('.');
    }

    if (targetPath === '') {
      return undefined;
    }

    if (!map[targetPath]) {
      walkSchema([], model, schema, targetPath);
    }

    return map[targetPath];
  };
}

function updateFn(endpoint, keyName, props, preprocess, httpOptions, postprocess) {
  return function () {
    var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(model, schema, columns) {
      var payload, specFinder, _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, path, spec, parentPath, parentSpec, parent, _iteratorNormalCompletion5, _didIteratorError5, _iteratorError5, _iterator5, _step5, key, _spec, _httpOptions, p;

      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              payload = {};
              specFinder = fieldSpecFinder(model, schema, false);

              if (!props) {
                _context.next = 46;
                break;
              }

              if (!(0, _lodash.isArray)(props)) {
                _context.next = 25;
                break;
              }

              _iteratorNormalCompletion4 = true;
              _didIteratorError4 = false;
              _iteratorError4 = undefined;
              _context.prev = 7;

              for (_iterator4 = (0, _getIterator3.default)(props); !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                path = _step4.value;

                path = (0, _lodash.toPath)(path);
                spec = specFinder(path);
                parentPath = path.slice(0, -1);
                parentSpec = specFinder(parentPath);

                if (parentSpec && parentSpec.type === 'schema') {
                  parent = (0, _lodash.get)(model, parentPath);

                  (0, _lodash.set)(payload, path, getField.call(this, parent, (0, _extends3.default)({}, spec, { prop: path.slice(-1) })));
                } else if (spec) {
                  (0, _lodash.set)(payload, path, getField.call(this, model, (0, _extends3.default)({}, spec, { prop: path })));
                } else {
                  (0, _lodash.set)(payload, path, (0, _lodash.get)(model, path));
                }
              }
              _context.next = 15;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context['catch'](7);
              _didIteratorError4 = true;
              _iteratorError4 = _context.t0;

            case 15:
              _context.prev = 15;
              _context.prev = 16;

              if (!_iteratorNormalCompletion4 && _iterator4.return) {
                _iterator4.return();
              }

            case 18:
              _context.prev = 18;

              if (!_didIteratorError4) {
                _context.next = 21;
                break;
              }

              throw _iteratorError4;

            case 21:
              return _context.finish(18);

            case 22:
              return _context.finish(15);

            case 23:
              _context.next = 44;
              break;

            case 25:
              _iteratorNormalCompletion5 = true;
              _didIteratorError5 = false;
              _iteratorError5 = undefined;
              _context.prev = 28;

              for (_iterator5 = (0, _getIterator3.default)((0, _keys2.default)(props)); !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                key = _step5.value;
                _spec = specFinder(props[key]);

                if (!_spec) {
                  (0, _lodash.set)(payload, key, (0, _lodash.get)(model, key));
                } else {
                  (0, _lodash.set)(payload, key, getField.call(this, model, _spec));
                }
              }
              _context.next = 36;
              break;

            case 32:
              _context.prev = 32;
              _context.t1 = _context['catch'](28);
              _didIteratorError5 = true;
              _iteratorError5 = _context.t1;

            case 36:
              _context.prev = 36;
              _context.prev = 37;

              if (!_iteratorNormalCompletion5 && _iterator5.return) {
                _iterator5.return();
              }

            case 39:
              _context.prev = 39;

              if (!_didIteratorError5) {
                _context.next = 42;
                break;
              }

              throw _iteratorError5;

            case 42:
              return _context.finish(39);

            case 43:
              return _context.finish(36);

            case 44:
              _context.next = 47;
              break;

            case 46:
              payload = model;

            case 47:
              payload.endpoint = endpoint;
              if (keyName) {
                payload[keyName] = (0, _lodash.get)(model, keyName);
              }
              _httpOptions = void 0;

              if (typeof httpOptions === 'function') {
                _httpOptions = httpOptions.call(this, model, schema, columns);
              } else {
                _httpOptions = httpOptions;
              }

              if (!(typeof preprocess === 'function')) {
                _context.next = 57;
                break;
              }

              _context.next = 54;
              return preprocess.call(this, payload, schema, columns);

            case 54:
              payload = _context.sent;

              if (!(payload === false)) {
                _context.next = 57;
                break;
              }

              return _context.abrupt('return', _promise2.default.resolve(false));

            case 57:
              p = _vue2.default.http.post('', payload, _httpOptions);

              if (!(typeof postprocess === 'function')) {
                _context.next = 62;
                break;
              }

              return _context.abrupt('return', postprocess.call(this, p));

            case 62:
              return _context.abrupt('return', formActions.postprocess.notify(true).call(this, p));

            case 63:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this, [[7, 11, 15, 23], [16,, 18, 22], [28, 32, 36, 44], [37,, 39, 43]]);
    }));

    function update(_x, _x2, _x3) {
      return _ref2.apply(this, arguments);
    }

    return update;
  }();
}

var formActions = exports.formActions = {
  get back() {
    return {
      label: _index2.default.fr('action.back'),
      class: 'btn-info',
      validation: false,
      action: function action(model, schema) {
        this.$router.back();
        return _promise2.default.resolve();
      }
    };
  },
  delete: function _delete(endpoint, key, redirect) {
    var fn = updateFn(endpoint, key, [], null, null, formActions.postprocess.redirect(typeof redirect === 'function' ? redirect : function () {
      return redirect;
    }));

    return function (model, schema, columns) {
      var args = arguments;
      var self = this;
      var keyField = findKeyField(columns);
      return (0, _sweetalert2.default)({
        title: _index2.default.fr('alert.html.confirm_delete_$str', { str: schema.title.call(this, model, schema) }),
        text: keyField ? '(' + getField.call(this, model, keyField) + ')' : null,
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: _index2.default.fr('action.yes'),
        cancelButtonText: _index2.default.fr('action.cancel'),
        confirmButtonClass: 'btn btn-danger btn-fill',
        cancelButtonClass: 'btn btn-fill',
        buttonsStyling: false
      }).then(function () {
        return fn.apply(self, args);
      }, function () {});
    };
  },

  postprocess: {
    notify: function notify(reload) {
      return function (p) {
        var self = this;
        return p.then(function (response) {
          if (self.$notify) {
            self.$notify({
              component: {
                template: _index2.default.fr('alert.html.record_saved_successfully', { response: response })
              },
              icon: 'ti-info',
              horizontalAlign: 'center',
              verticalAlign: 'top',
              type: 'success'
            });
          }
          return reload;
        });
      };
    },
    redirect: function redirect(link) {
      return function (p) {
        var _this4 = this;

        return p.then(function (response) {
          if (!response.body) {
            throw new Error(_index2.default.f('alert.empty_response'));
          }
          var result = response.body;
          if (!result.success) {
            console.error(response);
            return _promise2.default.reject(result.err.hk || result.err);
          }
          if (_this4.$notify) {
            _this4.$notify({
              component: {
                template: _index2.default.f('alert.html.record_saved_successfully')
              },
              icon: 'ti-info',
              horizontalAlign: 'center',
              verticalAlign: 'top',
              type: 'success'
            });
          }
          _this4.$router.push(link.call(_this4, result));
          return false;
        });
      };
    }
  }
};

/***/ }),
/* 4 */,
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = __webpack_require__(15);

exports.default = {
  DEBUG: (0, _utils.getCookie)('debug'),
  API_HOST: (0, _utils.getCookie)('api')
};

/***/ }),
/* 6 */,
/* 7 */,
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = __webpack_require__(3);

exports.default = {
  props: {
    spec: { type: Object, required: true },
    model: {},
    $parentForm: {},
    rootModel: {},
    $rootForm: {},
    readonly: {},
    name: { type: String }
  },
  computed: {
    value: {
      get: function get() {
        return _utils.getField.call(this, this.model, this.spec);
      },
      set: function set(v) {
        return _utils.setField.call(this, this.model, this.spec, v);
      }
    },
    _name: function _name() {
      return this.name || this.spec.prop;
    },
    _readonly: function _readonly() {
      return (typeof this.readonly === 'function' ? this.readonly.call(this) : this.readonly) || (typeof this.spec.readonly === 'function' ? this.spec.readonly.call(this) : this.spec.readonly);
    }
  }
};

/***/ }),
/* 9 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.edit = exports.create = exports.read = exports.view = exports.list = exports.columns = undefined;

var _extends2 = __webpack_require__(22);

var _extends3 = _interopRequireDefault(_extends2);

var _getIterator2 = __webpack_require__(23);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _keys = __webpack_require__(16);

var _keys2 = _interopRequireDefault(_keys);

var _regenerator = __webpack_require__(19);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(18);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _promise = __webpack_require__(7);

var _promise2 = _interopRequireDefault(_promise);

var _datePicker = __webpack_require__(53);

var _datePicker2 = _interopRequireDefault(_datePicker);

var _base = __webpack_require__(9);

var _base2 = _interopRequireDefault(_base);

var _datePicker3 = __webpack_require__(49);

var _datePicker4 = _interopRequireDefault(_datePicker3);

exports.title = title;
exports.tableFilters = tableFilters;
exports.formActions = formActions;
exports.listActions = listActions;

var _lodash = __webpack_require__(1);

var _utils = __webpack_require__(3);

var utils = _interopRequireWildcard(_utils);

var _sample = __webpack_require__(17);

var _membership_db = __webpack_require__(278);

var _membership_db2 = _interopRequireDefault(_membership_db);

var _subprofile = __webpack_require__(32);

var Subprofile = _interopRequireWildcard(_subprofile);

var _order = __webpack_require__(39);

var Order = _interopRequireWildcard(_order);

var _profile = __webpack_require__(44);

var Profile = _interopRequireWildcard(_profile);

var _i18n = __webpack_require__(2);

var _i18n2 = _interopRequireDefault(_i18n);

var _sweetalert = __webpack_require__(54);

var _sweetalert2 = _interopRequireDefault(_sweetalert);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function title(model) {
  var a = (0, _lodash.get)(model, 'details.profile');
  if (!a) {
    return _i18n2.default.fr('schema.member');
  }
  var out = Profile.title.call(this, a);
  if (!out || !out.trim()) {
    out = _i18n2.default.fr('no_name');
  }
  return out;
}

var columns = exports.columns = utils.columnsFn(_membership_db2.default);

var list = exports.list = utils.listFn('getMembers', function (payload) {
  if ((0, _lodash.get)(this, 'schemaParams.created_at')) {
    payload.created_at = {
      $gte: +(0, _moment2.default)(this.schemaParams.created_at).startOf('month'),
      $lte: +(0, _moment2.default)(this.schemaParams.created_at).endOf('month')
    };
  }
  return payload;
});
var view = exports.view = utils.viewFn('/admin/members/:id');
var read = exports.read = utils.readFn('getMemberById', 'member_id');
var create = exports.create = utils.createFn('/admin/members/create');

exports.edit = _sample.edit;
function tableFilters(schema) {
  var _this = this;

  if (this.schemaParams) {
    this.schemaParams.created_at = null;
    return [function (h) {
      return h(_datePicker4.default.name, {
        props: {
          value: _this.schemaParams.created_at,
          type: 'month',
          placeholder: _i18n2.default.fr('label_pick_a_month')
        },
        on: {
          input: function input(v) {
            _this.schemaParams.created_at = v;
            _this.queryChanged();
          }
        }
      });
    }];
  }
  return [];
}

function formActions(model, schema, readonly) {
  var temp = [];

  if (!readonly) {
    temp.push({
      label: _i18n2.default.fr('action.delete') + ' [Del]',
      class: 'btn-danger',
      trigger: function trigger(e) {
        return e.keyCode === 46;
      },
      action: utils.formActions.delete('deleteMemberById', 'member_id', '/admin/' + (['admin', 'superadmin'].indexOf((0, _lodash.get)(model, 'role')) >= 0 ? 'admins' : 'members'))
    });

    temp.push({
      label: _i18n2.default.fr('action.clear_tokens'),
      class: 'btn-danger',
      action: function action(model, schema) {
        var _this2 = this;

        return (0, _sweetalert2.default)({
          text: _i18n2.default.fr('alert.html.confirm_action_$action', { action: '${i18n.action.clear_tokens}' }),
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: _i18n2.default.fr('action.ok'),
          cancelButtonText: _i18n2.default.fr('action.cancel'),
          confirmButtonClass: 'btn btn-success btn-fill',
          cancelButtonClass: 'btn btn-fill',
          buttonsStyling: false
        }).then(function () {
          return utils.updateFn('updateMemberById', 'member_id', [], function (payload, schema, columns) {
            payload.tokens = [];
            return payload;
          }).call(_this2, model, schema);
        }, function (dismiss) {});
      }
    });
    if (!(0, _lodash.get)(model, 'finished_interview')) {
      temp.push({
        label: _i18n2.default.fr('action.finished_interview'),
        class: 'btn-success',
        action: utils.updateFn('updateMemberById', 'member_id', {
          finished_interview: 'finished_interview'
        }, function (payload, schema, columns) {
          payload.finished_interview = true;
          return payload;
        })
      });
    }
    temp.push({
      label: _i18n2.default.fr('action.save') + ' [Ctrl+Enter]',
      class: 'btn-success',
      validation: true,
      trigger: function trigger(e) {
        return (e.metaKey || e.ctrlKey) && e.keyCode === 13;
      },
      action: utils.updateFn('updateMemberById', 'member_id', {
        status: 'status',
        app_config: 'app_config',
        verification: 'verification',
        role: 'role',
        profile: 'details.profile',
        finished_interview: 'finished_interview',
        reset_password: 'reset_password',
        details: 'details',
        certificates: 'certificates'
      })
    });
  }
  temp.push({
    label: _i18n2.default.fr('action.send_feedback_to_caregiver'),
    class: 'btn-success',
    action: function action(model, schema, columns) {
      this.$router.push('/admin/feedback-admin/create?type=admin_to_caregiver&member_id=' + model.member_id);
      return _promise2.default.resolve(false);
    }
  });
  temp.push({
    label: _i18n2.default.fr('action.send_feedback_to_client'),
    class: 'btn-success',
    action: function action(model, schema, columns) {
      this.$router.push('/admin/feedback-admin/create?type=admin_to_client&member_id=' + model.member_id);
      return _promise2.default.resolve(false);
    }
  });
  temp.push({
    label: _i18n2.default.fr('create_schema_$name', { name: '${i18n.schema.order}' }),
    class: 'btn-success',
    validation: false,
    action: function action(model, schema) {
      var _this3 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        var self, count;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                self = _this3;
                _context.next = 3;
                return Subprofile.list.call(_this3, { limit: 1, creator_id: model.member_id });

              case 3:
                count = _context.sent;

                if (!(count.total == 0)) {
                  _context.next = 9;
                  break;
                }

                _context.next = 7;
                return (0, _sweetalert2.default)({
                  title: _i18n2.default.fr('alert.html.no_subprofile'),
                  text: _i18n2.default.fr('alert.html.no_subprofile_desc'),
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: _i18n2.default.fr('action.ok'),
                  cancelButtonText: _i18n2.default.fr('action.cancel'),
                  confirmButtonClass: 'btn btn-success btn-fill',
                  cancelButtonClass: 'btn btn-fill',
                  buttonsStyling: false
                }).then(function () {
                  self.$router.push('/admin/subprofiles/create?member_id=' + model.member_id);
                }, function (dismiss) {});

              case 7:
                _context.next = 10;
                break;

              case 9:
                _this3.$router.push('/admin/orders/create?member_id=' + model.member_id);

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    }
  });
  temp.push({
    label: _i18n2.default.fr('action.update_stat'),
    class: 'btn-success',
    action: utils.updateFn('updateMemberStat', 'member_id', [])
  });
  temp.push(utils.formActions.back);
  return temp;
}

function listActions(schema, readonly) {
  var temp = [];
  temp.push({
    label: _i18n2.default.fr('action.export_data'),
    action: utils.exportFn({
      'subprofile.subprofile_id': 'Service User - ID',
      'subprofile.details.profile.first_name': 'Service User - First Name',
      'subprofile.details.profile.last_name': 'Service User - Last Name',
      'subprofile.details.profile.gender': 'Service User - Gender',
      'subprofile.details.profile.birthday': 'Service User - Date of Birth',
      'subprofile.details.medical_history.disease.cancer': 'Service User - Cancer',
      'subprofile.details.medical_history.disease.stroke': 'Service User - Stroke',
      'subprofile.details.medical_history.disease.genetic_disease': 'Service User - Genetic Disease',
      'subprofile.details.medical_history.disease.heart_disease': 'Service User - Heart Disease',
      'subprofile.details.medical_history.disease.hypertension': 'Service User - Hypertension',
      'subprofile.details.medical_history.disease.diabetes': 'Service User - Diabetes',
      'subprofile.details.medical_history.otherDisease': 'Service User - Other Disease',
      'subprofile.details.medical_history.doneSurgery': 'Service User - Done Surgery',
      'subprofile.details.medical_history.surgery': 'Service User - Surgery',
      'subprofile.details.medical_history.mentalTreatment': 'Service User - Mental Treatment',
      'subprofile.details.medical_history.useService': 'Service User - Use Service',

      'subprofile.order.order_id': 'Service User - Order - ID',
      'subprofile.order.product.details.title.en': 'Service User - Order - Type of Service (EN)',
      'subprofile.order.product.details.title.hk': 'Service User - Order - Type of Service (HK)',

      'member_id': 'Membership ID',
      'status': 'Status',
      'created_at': 'Created At',
      'details.profile.first_name': 'First Name',
      'details.profile.last_name': 'Last Name',
      'details.profile.other_name': 'Other Name',
      'details.profile.gender': 'Gender',
      'details.profile.birthday': 'Birthday',
      'verification.email.value': 'Email',
      'verification.phone.value': 'Mobile no.',
      'basic_info_fulfilled': 'Basic info fulfilled',
      'email_fulfilled': 'Email fulfilled',
      'app_config.notification.sms': 'User Preference - SMS',
      'app_config.notification.email': 'User Preference - Email',
      'app_config.notification.promotion': 'Receive Promotion',
      'app_config.language': 'Language',
      'finished_interview': 'Finished interview',
      'details.years_of_experience': 'Years of Experience',
      'details.working_experience': 'Working Experience',

      'stat.rating.admin_to_caregiver_avg': 'Rating - Admin to Caregiver (avg)',
      'stat.rating.admin_to_client_avg': 'Rating - Admin to Client (avg)',
      'stat.rating.client_appointment_feedback_avg': 'Rating - Client appointment feedback (avg)',
      'stat.rating.caregiver_appointment_feedback_avg': 'Rating - Caregiver appointment feedback (avg)',

      'role': 'Role',
      'is_caregiver': 'Is Verified Caregiver'
    }, function () {
      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(row, fields) {
        var filter, out, subprofiles, i, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, subprofile, disease, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, key, orders, _i, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, order;

        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                row.basic_info_fulfilled = !!(row.details.profile.first_name && row.details.profile.last_name && row.details.profile.gender);
                row.email_fulfilled = !!row.verification.email.value;
                row.is_caregiver = !!(row.groups.length || row.finished_interview);
                row.role = row.groups.map(function (x) {
                  return x.group.details.code;
                }).join('/');

                filter = function filter(x) {
                  for (var k in fields) {
                    k = (0, _lodash.toPath)(k);
                    if ((0, _lodash.get)(x, k) == null) {
                      (0, _lodash.set)(x, k, '');
                    }
                  }
                  return (0, _lodash.pick)(x, (0, _keys2.default)(fields));
                };

                out = [row];
                subprofiles = [];
                i = 5;

              case 8:
                if (!(i > 0)) {
                  _context2.next = 21;
                  break;
                }

                _context2.prev = 9;
                _context2.next = 12;
                return Subprofile.list.call(this, {
                  skip: 0, limit: 9999999, creator_id: row.member_id, status: { $exists: true }
                }, Subprofile, []);

              case 12:
                subprofiles = _context2.sent.data;
                return _context2.abrupt('break', 21);

              case 16:
                _context2.prev = 16;
                _context2.t0 = _context2['catch'](9);

              case 18:
                --i;
                _context2.next = 8;
                break;

              case 21:
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context2.prev = 24;
                _iterator = (0, _getIterator3.default)(subprofiles);

              case 26:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context2.next = 87;
                  break;
                }

                subprofile = _step.value;
                disease = (0, _lodash.get)(subprofile, 'details.medical_history.disease');

                if (!disease) {
                  _context2.next = 49;
                  break;
                }

                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context2.prev = 33;

                for (_iterator2 = (0, _getIterator3.default)(disease); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  key = _step2.value;

                  disease[key] = true;
                }
                _context2.next = 41;
                break;

              case 37:
                _context2.prev = 37;
                _context2.t1 = _context2['catch'](33);
                _didIteratorError2 = true;
                _iteratorError2 = _context2.t1;

              case 41:
                _context2.prev = 41;
                _context2.prev = 42;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 44:
                _context2.prev = 44;

                if (!_didIteratorError2) {
                  _context2.next = 47;
                  break;
                }

                throw _iteratorError2;

              case 47:
                return _context2.finish(44);

              case 48:
                return _context2.finish(41);

              case 49:

                out.push((0, _extends3.default)({}, row, { subprofile: subprofile }));

                orders = [];
                _i = 5;

              case 52:
                if (!(_i > 0)) {
                  _context2.next = 65;
                  break;
                }

                _context2.prev = 53;
                _context2.next = 56;
                return Order.list.call(this, {
                  skip: 0, limit: 9999999, subprofile_id: subprofile.subprofile_id
                }, Order, []);

              case 56:
                orders = _context2.sent.data;
                return _context2.abrupt('break', 65);

              case 60:
                _context2.prev = 60;
                _context2.t2 = _context2['catch'](53);

              case 62:
                --_i;
                _context2.next = 52;
                break;

              case 65:
                _iteratorNormalCompletion3 = true;
                _didIteratorError3 = false;
                _iteratorError3 = undefined;
                _context2.prev = 68;


                for (_iterator3 = (0, _getIterator3.default)(orders); !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                  order = _step3.value;

                  out.push((0, _extends3.default)({}, row, { subprofile: (0, _extends3.default)({}, subprofile, { order: { order_id: order.order_id, product: order.product } }) }));
                }
                _context2.next = 76;
                break;

              case 72:
                _context2.prev = 72;
                _context2.t3 = _context2['catch'](68);
                _didIteratorError3 = true;
                _iteratorError3 = _context2.t3;

              case 76:
                _context2.prev = 76;
                _context2.prev = 77;

                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                  _iterator3.return();
                }

              case 79:
                _context2.prev = 79;

                if (!_didIteratorError3) {
                  _context2.next = 82;
                  break;
                }

                throw _iteratorError3;

              case 82:
                return _context2.finish(79);

              case 83:
                return _context2.finish(76);

              case 84:
                _iteratorNormalCompletion = true;
                _context2.next = 26;
                break;

              case 87:
                _context2.next = 93;
                break;

              case 89:
                _context2.prev = 89;
                _context2.t4 = _context2['catch'](24);
                _didIteratorError = true;
                _iteratorError = _context2.t4;

              case 93:
                _context2.prev = 93;
                _context2.prev = 94;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 96:
                _context2.prev = 96;

                if (!_didIteratorError) {
                  _context2.next = 99;
                  break;
                }

                throw _iteratorError;

              case 99:
                return _context2.finish(96);

              case 100:
                return _context2.finish(93);

              case 101:
                return _context2.abrupt('return', out.map(filter));

              case 102:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[9, 16], [24, 89, 93, 101], [33, 37, 41, 49], [42,, 44, 48], [53, 60], [68, 72, 76, 84], [77,, 79, 83], [94,, 96, 100]]);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }())
  });
  return temp;
}

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(7);

var _promise2 = _interopRequireDefault(_promise);

var _stringify = __webpack_require__(37);

var _stringify2 = _interopRequireDefault(_stringify);

var _typeof2 = __webpack_require__(27);

var _typeof3 = _interopRequireDefault(_typeof2);

exports.parseError = parseError;
exports.parseResponse = parseResponse;
exports.getCookie = getCookie;
exports.formatSiUnit = formatSiUnit;
exports.formatThousands = formatThousands;
exports.uuid = uuid;
exports.formatPhone = formatPhone;
exports.apiHost = apiHost;

var _i18n = __webpack_require__(2);

var _i18n2 = _interopRequireDefault(_i18n);

var _debug = __webpack_require__(5);

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function parseError(err) {
  if (err instanceof Error) {
    return err.message;
  }
  if ((typeof err === 'undefined' ? 'undefined' : (0, _typeof3.default)(err)) === 'object') {
    if (err.err) {
      err = err.err;
    }
  }
  if ((typeof err === 'undefined' ? 'undefined' : (0, _typeof3.default)(err)) === 'object') {
    return _i18n2.default.S(err, (0, _stringify2.default)(err));
  }
  return err;
}

function parseResponse(response) {
  if (!response || !response.body) {
    throw new Error(_i18n2.default.fr('alert.empty_response', { response: response }));
  }
  var result = response.body;
  if (!result.success) {
    console.error(response);
    return _promise2.default.reject(result);
  }
  return response;
}

function getCookie(name) {
  var value = "; " + document.cookie;
  var parts = value.split("; " + name + "=");
  if (parts.length == 2) return parts.pop().split(";").shift();
}

function formatSiUnit(value, units, zeroIndex, base, decimals) {
  decimals = Math.pow(10, decimals);
  var order = Math.floor(Math.log(value) / Math.log(base));
  order = Math.min(Math.max(order + zeroIndex, 0), units.length - 1) - zeroIndex;
  var round = Math.round(value / Math.pow(base, order) * decimals) / decimals;
  return round + ' ' + units[order + zeroIndex];
}

formatSiUnit.BYTE = ['B', 'KB', 'MB', 'GB', 'TB', 'EB'];

formatSiUnit.byte = function (value) {
  var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  return formatSiUnit(value, formatSiUnit.BYTE, 0, 1024, decimals);
};

function formatThousands(value, comma) {
  return String(value).replace(/\B(?=(\d{3})+(?!\d))/g, comma || ',');
}

function uuid(length) {
  var text = "";
  var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

  for (var i = 0; i < length; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }return text;
}

function formatPhone(value) {
  if (typeof value === 'string') {
    value = value.replace(/^(852|853|86)(?=\d)/, '$1-');
  }
  return value;
}

function apiHost() {
  var url = _debug2.default.API_HOST || window.API || 'http://api.okcare.fletrix.hk/';
  return url.replace(/\/+$/, '') + '/';
}

/***/ }),
/* 16 */,
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(7);

var _promise2 = _interopRequireDefault(_promise);

exports.title = title;
exports.columns = columns;
exports.view = view;
exports.create = create;
exports.edit = edit;
exports.formActions = formActions;

var _vue = __webpack_require__(6);

var _vue2 = _interopRequireDefault(_vue);

var _lodash = __webpack_require__(1);

var _utils = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function title(model, schema) {
  return (0, _lodash.get)(model, 'id', 'default schema name');
}

function columns(model, schema, readonly, table) {
  return [{
    "label": "Member Id",
    "prop": "member_id",
    "type": "string"
  }, {
    "label": "Email",
    "prop": "created_at",
    "type": "date"
  }, {
    "label": "Basicinfo Fulfilled",
    "prop": "basicInfo_fulfilled",
    "type": "boolean"
  }, {
    "label": "Gender",
    "prop": "details.profile.gender",
    "type": "string"
  }];
}

function view(model, index, schema, columns) {
  var field = (0, _utils.findKeyField)(columns);
  if (field) {
    this.$router.push((0, _lodash.trimEnd)(this.$route.path, '/') + '/' + (0, _lodash.get)(model, field.prop));
  }
  return _promise2.default.resolve();
}

function create(schema, columns) {
  this.$router.push((0, _lodash.trimEnd)(this.$route.path, '/') + '/create');
  return _promise2.default.resolve();
}

function edit(model, index, schema, columns) {
  var field = (0, _utils.findKeyField)(columns);
  if (field) {
    this.$router.push((0, _lodash.trimEnd)(this.$route.path, '/') + '/' + (0, _lodash.get)(model, field.prop) + '?edit=');
  }
  return _promise2.default.resolve(false);
}

function formActions(model, schema, readonly) {
  var temp = [];
  if (!readonly) {
    temp.push({
      label: 'Update',
      class: 'btn-info',
      validation: true,
      action: function action(model, schema, columns) {
        return _promise2.default.resolve(false);
      }
    });
  }
  temp.push({
    label: 'Delete',
    class: 'btn-danger',
    validation: false,
    action: function action(model, schema, columns) {
      return _promise2.default.resolve(false);
    }
  });
  return temp;
}

/***/ }),
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.edit = exports.read = exports.view = exports.list = exports.columns = undefined;

var _regenerator = __webpack_require__(19);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(18);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _datePicker = __webpack_require__(53);

var _datePicker2 = _interopRequireDefault(_datePicker);

var _base = __webpack_require__(9);

var _base2 = _interopRequireDefault(_base);

var _datePicker3 = __webpack_require__(49);

var _datePicker4 = _interopRequireDefault(_datePicker3);

var _getIterator2 = __webpack_require__(23);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _promise = __webpack_require__(7);

var _promise2 = _interopRequireDefault(_promise);

exports.title = title;
exports.tableFilters = tableFilters;
exports.formActions = formActions;
exports.listActions = listActions;

var _debug = __webpack_require__(5);

var _debug2 = _interopRequireDefault(_debug);

var _lodash = __webpack_require__(1);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _appointment_db = __webpack_require__(330);

var _appointment_db2 = _interopRequireDefault(_appointment_db);

var _utils = __webpack_require__(3);

var utils = _interopRequireWildcard(_utils);

var _sample = __webpack_require__(17);

var _index = __webpack_require__(2);

var _index2 = _interopRequireDefault(_index);

var _subprofile = __webpack_require__(32);

var Subprofile = _interopRequireWildcard(_subprofile);

var _transaction = __webpack_require__(40);

var Transaction = _interopRequireWildcard(_transaction);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function title(model) {
  var p = (0, _lodash.get)(model, 'subprofile');
  p = p ? Subprofile.title.call(this, p, Subprofile) : null;
  return p || _index2.default.s('schema.appointment');
}

var columns = exports.columns = utils.columnsFn(_appointment_db2.default);

var list = exports.list = utils.listFn('getAppointments_byAdmin', function (payload) {
  if ((0, _lodash.get)(this, 'schemaParams.created_at')) {
    payload.created_at = {
      $gte: +(0, _moment2.default)(this.schemaParams.created_at).startOf('month'),
      $lte: +(0, _moment2.default)(this.schemaParams.created_at).endOf('month')
    };
  }
  return payload;
});
var view = exports.view = utils.viewFn('/admin/appointments/:id');
var read = exports.read = utils.readFn('getAppointmentById', 'appointment_id', null, null, function (p) {
  return p.then(function (response) {
    if (!response.body) {
      throw new Error(_index2.default.f('alert.empty_response', { response: response }));
    }
    var result = response.body;
    if (!result.success) {
      console.error(response);
      return _promise2.default.reject(result.err.hk || result.err);
    }
    if (!result.data) {
      console.error(response);
      throw new Error(_index2.default.f('alert.invalid_response', { response: response }));
    }
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = (0, _getIterator3.default)((0, _lodash.get)(result.data, 'potential_recipients', [])), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var x = _step.value;

        (0, _lodash.unset)(x, 'recipient.details.profile.service_location');
        (0, _lodash.unset)(x, 'recipient.details.profile.emergency_contact');
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    (0, _lodash.unset)(result, 'data.sender.details.profile.service_location');
    (0, _lodash.unset)(result, 'data.sender.details.profile.emergency_contact');
    return result.data;
  });
});
exports.edit = _sample.edit;
function tableFilters(schema) {
  var _this = this;

  if (this.schemaParams) {
    this.schemaParams.created_at = null;
    return [function (h) {
      return h(_datePicker4.default.name, {
        props: {
          value: _this.schemaParams.created_at,
          type: 'month',
          placeholder: _index2.default.fr('label_pick_a_month')
        },
        on: {
          input: function input(v) {
            _this.schemaParams.created_at = v;
            _this.queryChanged();
          }
        }
      });
    }];
  }
  return [];
}

function formActions(model, schema, readonly) {
  var temp = [];

  var invoice = (0, _lodash.last)((0, _lodash.get)(model, 'details.invoices', []));
  if (invoice) {
    temp.push({
      label: _index2.default.fr('action.view_invoice'),
      class: 'btn-info',
      action: function action(model) {
        var invoice = (0, _lodash.last)((0, _lodash.get)(model, 'details.invoices', []));
        return utils.viewFn('/admin/transactions/:id').call(this, invoice, 0, Transaction, Transaction.columns.call(this, invoice, Transaction, false, false));
      }
    });
  }

  if (!readonly) {
    temp.push({
      label: _index2.default.fr('action.save') + ' [Ctrl+Enter]',
      class: 'btn-success',
      validation: true,
      trigger: function trigger(e) {
        return (e.metaKey || e.ctrlKey) && e.keyCode === 13;
      },
      action: utils.updateFn('updateAppointmentById', 'appointment_id', ['status', 'details.remarks', 'details.service_date', 'details.ticket_required', 'progress_status', 'potential_recipients', 'invoice_completed'])
    });
    if (_debug2.default.DEBUG) {
      temp.push({
        label: _index2.default.s('action.delete') + ' [Del]',
        class: 'btn-danger',
        trigger: function trigger(e) {
          return e.keyCode === 46;
        },
        action: utils.formActions.delete('deleteAppointmentById', 'appointment_id', '/admin/appointments')
      });
    }
  }
  var status = (0, _lodash.get)(model, 'progress_status');
  var caregiver = (0, _lodash.find)((0, _lodash.get)(model, 'potential_recipients', []), function (x) {
    return ['confirmed', 'arrived', 'absent', 'late', 'reported', 'feedbacked', 'invoice_sent', 'complete'].indexOf(x.status) >= 0;
  });
  var helper_status = (0, _lodash.get)(caregiver, 'status');
  if (status == 'waiting_admin_approve') {
    temp.push({
      label: _index2.default.s('action.approve'),
      class: 'btn-success',
      action: utils.updateFn('approveAppointment', 'appointment_id', [])
    });
  } else if (['waiting_helper_confirm', 'waiting_admin_confirm', 'matching_helper'].indexOf(status) >= 0) {
    temp.push({
      label: _index2.default.s('action.distribute_job'),
      class: 'btn-info',
      action: utils.updateFn('redistributeJob', 'appointment_id', [])
    });
  }
  if (helper_status == 'invoice_sent' && 'complete' !== status) {
    temp.push({
      label: _index2.default.fr('action.complete_appointment'),
      class: 'btn-success',
      action: utils.updateFn('completeAppointment', 'appointment_id', [])
    });
  }
  if ('complete' === status) {
    if (caregiver) {
      temp.push({
        label: _index2.default.fr('action.send_feedback_to_caregiver'),
        class: 'btn-success',
        action: function action(model, schema, columns) {
          this.$router.push('/admin/feedback-admin/create?type=admin_to_caregiver&member_id=' + caregiver.recipient.member_id + '&appointment_id=' + model.appointment_id);
          return _promise2.default.resolve(false);
        }
      });
    }
    temp.push({
      label: _index2.default.fr('action.send_feedback_to_client'),
      class: 'btn-success',
      action: function action(model, schema, columns) {
        if (model.sender) {
          this.$router.push('/admin/feedback-admin/create?type=admin_to_client&member_id=' + model.sender.member_id + '&appointment_id=' + model.appointment_id);
        }
        return _promise2.default.resolve(false);
      }
    });
  }

  temp.push(utils.formActions.back);
  return temp;
}

function listActions(schema, readonly) {
  var temp = [];
  temp.push({
    label: _index2.default.fr('action.export_data'),
    action: utils.exportFn({
      'details.order.order_id': 'Order ID',
      'appointment_id': 'Booking ID',
      'created_at': 'Created At',
      'status': 'Status',

      'sender.details.profile.first_name': 'Client - First Name',
      'sender.details.profile.last_name': 'Client - Last Name',
      'sender.details.profile.other_name': 'Client - Other Name',
      'sender.details.profile.gender': 'Client - Gender',
      'sender.verification.email.value': 'Client - Email',
      'sender.verification.phone.value': 'Client - Mobile no.',
      'sender.basic_info_fulfilled': 'Client - Basic info fulfilled',
      'sender.email_fulfilled': 'Client - Email fulfilled',
      'sender.app_config.notification.sms': 'Client - User Preference - SMS',
      'sender.app_config.notification.email': 'Client - User Preference - Email',
      'sender.app_config.notification.promotion': 'Client - Receive Promotion',
      'sender.app_config.language': 'Client - Language',

      'subprofile.subprofile_id': 'Service User - ID',
      'subprofile.details.profile.first_name': 'Service User - First Name',
      'subprofile.details.profile.last_name': 'Service User - Last Name',
      'subprofile.details.profile.gender': 'Service User - Gender',
      'subprofile.details.profile.birthday': 'Service User - Date of Birth',
      'subprofile.details.medical_history.disease.cancer': 'Service User - Cancer',
      'subprofile.details.medical_history.disease.stroke': 'Service User - Stroke',
      'subprofile.details.medical_history.disease.genetic_disease': 'Service User - Genetic Disease',
      'subprofile.details.medical_history.disease.heart_disease': 'Service User - Heart Disease',
      'subprofile.details.medical_history.disease.hypertension': 'Service User - Hypertension',
      'subprofile.details.medical_history.disease.diabetes': 'Service User - Diabetes',
      'subprofile.details.medical_history.otherDisease': 'Service User - Other Disease',
      'subprofile.details.medical_history.doneSurgery': 'Service User - Done Surgery',
      'subprofile.details.medical_history.surgery': 'Service User - Surgery',
      'subprofile.details.medical_history.mentalTreatment': 'Service User - Mental Treatment',
      'subprofile.details.medical_history.useService': 'Service User - Use Service',

      'progress_status': 'Progress Status',
      'caregiver.status': 'Caregiver Status',
      'caregiver.name': 'Caregiver Name',
      'potential_recipients.length': '# of Caregiver',
      'details.order.product.details.title.en': 'Product',
      'details.service_date': 'Service Date',

      'details.order.service_location.area': 'Service Location - Area',
      'details.order.service_location.district': 'Service Location - District',
      'details.order.service_location.address': 'Service Location - Address'

    }, function () {
      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(row, fields) {
        var disease, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, key, filter;

        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:

                row.caregiver = row.potential_recipients.find(function (x) {
                  return ['accepted', 'confirmed', 'arrived', 'absent', 'late', 'reported', 'feedbacked', 'invoice_sent', 'complete'].includes(x.status);
                });

                disease = (0, _lodash.get)(row, 'subprofile.details.medical_history.disease');

                if (!disease) {
                  _context.next = 22;
                  break;
                }

                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context.prev = 6;

                for (_iterator2 = (0, _getIterator3.default)(disease); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  key = _step2.value;

                  disease[key] = true;
                }
                _context.next = 14;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context['catch'](6);
                _didIteratorError2 = true;
                _iteratorError2 = _context.t0;

              case 14:
                _context.prev = 14;
                _context.prev = 15;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 17:
                _context.prev = 17;

                if (!_didIteratorError2) {
                  _context.next = 20;
                  break;
                }

                throw _iteratorError2;

              case 20:
                return _context.finish(17);

              case 21:
                return _context.finish(14);

              case 22:

                if (row.caregiver) {
                  row.caregiver.name = (0, _lodash.get)(row, 'caregiver.recipient.details.profile.last_name', '') + ' ' + (0, _lodash.get)(row, 'caregiver.recipient.details.profile.first_name', '');
                }

                filter = function filter(x) {
                  for (var k in fields) {
                    k = (0, _lodash.toPath)(k);
                    if ((0, _lodash.get)(x, k) == null) {
                      (0, _lodash.set)(x, k, '');
                    }
                  }
                };

                filter(row);
                return _context.abrupt('return', row);

              case 26:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[6, 10, 14, 22], [15,, 17, 21]]);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }())
  });
  return temp;
}

/***/ }),
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.edit = exports.create = exports.read = exports.view = exports.list = exports.columns = undefined;
exports.title = title;
exports.formActions = formActions;

var _lodash = __webpack_require__(1);

var _group_db = __webpack_require__(331);

var _group_db2 = _interopRequireDefault(_group_db);

var _utils = __webpack_require__(3);

var utils = _interopRequireWildcard(_utils);

var _sample = __webpack_require__(17);

var _index = __webpack_require__(2);

var _index2 = _interopRequireDefault(_index);

var _debug = __webpack_require__(5);

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function title(model) {
  return _index2.default.S((0, _lodash.get)(model, 'details.name')) || (0, _lodash.get)(model, 'details.name_zh') || _index2.default.s('schema.group');
}

var columns = exports.columns = utils.columnsFn(_group_db2.default);

var list = exports.list = utils.listFn('getGroups');
var view = exports.view = utils.viewFn('/admin/groups/:id');
var read = exports.read = utils.readFn('getGroupById', 'group_id');
var create = exports.create = utils.createFn('/admin/groups/create');

exports.edit = _sample.edit;
function formActions(model, schema, readonly) {
  var temp = [];
  if (!readonly) {
    temp.push({
      label: _index2.default.fr('action.save') + ' [Ctrl+Enter]',
      class: 'btn-success',
      validation: true,
      trigger: function trigger(e) {
        return (e.metaKey || e.ctrlKey) && e.keyCode === 13;
      },
      action: utils.updateFn('updateGroup', 'group_id', ['status', 'type', 'tags', 'details'])
    });
    temp.push({
      label: _index2.default.fr('action.duplicate'),
      class: 'btn-info',
      validation: true,
      action: utils.updateFn('duplicateGroup', 'group_id', [], null, null, utils.formActions.postprocess.redirect(function (result) {
        return '/admin/groups/' + result.data.group_id;
      }))
    });
    if (_debug2.default.DEBUG) {
      temp.push({
        label: _index2.default.s('action.delete') + ' [Del]',
        class: 'btn-danger',
        trigger: function trigger(e) {
          return e.keyCode === 46;
        },
        action: utils.formActions.delete('deleteGroupById', 'group_id', '/admin/groups')
      });
    }
  }
  temp.push(utils.formActions.back);
  return temp;
}

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.edit = exports.read = exports.view = exports.list = exports.columns = undefined;

var _promise = __webpack_require__(7);

var _promise2 = _interopRequireDefault(_promise);

exports.title = title;
exports.formActions = formActions;

var _lodash = __webpack_require__(1);

var _subprofile_db = __webpack_require__(336);

var _subprofile_db2 = _interopRequireDefault(_subprofile_db);

var _utils = __webpack_require__(3);

var utils = _interopRequireWildcard(_utils);

var _sample = __webpack_require__(17);

var _profile = __webpack_require__(44);

var Profile = _interopRequireWildcard(_profile);

var _index = __webpack_require__(2);

var _index2 = _interopRequireDefault(_index);

var _debug = __webpack_require__(5);

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function title(model) {
  var a = (0, _lodash.get)(model, 'details.profile');
  return a ? Profile.title.call(this, a, Profile) : '';
}

var columns = exports.columns = utils.columnsFn(_subprofile_db2.default);

var list = exports.list = utils.listFn('getSubprofiles');
var view = exports.view = utils.viewFn('/admin/subprofiles/:id');
var read = exports.read = utils.readFn('getSubprofileById', 'subprofile_id');

exports.edit = _sample.edit;
function formActions(model, schema, readonly) {
  var temp = [];
  if (!readonly) {
    temp.push({
      label: _index2.default.fr('action.save') + ' [Ctrl+Enter]',
      class: 'btn-success',
      validation: true,
      trigger: function trigger(e) {
        return (e.metaKey || e.ctrlKey) && e.keyCode === 13;
      },
      action: utils.updateFn('updateSubprofile', 'subprofile_id', ['status', 'type', 'tags', 'details'])
    });
    if (_debug2.default.DEBUG) {
      temp.push({
        label: _index2.default.fr('action.delete') + ' [Del]',
        class: 'btn-danger',
        trigger: function trigger(e) {
          return e.keyCode === 46;
        },
        action: utils.formActions.delete('deleteSubprofileById', 'subprofile_id', '/admin/subprofiles')
      });
    }
  }
  temp.push({
    label: _index2.default.fr('action.create_$obj', { obj: '${i18n.schema.order}' }),
    class: 'btn-info',
    validation: false,
    action: function action(model, schema) {
      this.$router.push('/admin/orders/create?member_id=' + (0, _lodash.get)(model, 'creator.member_id') + '&subprofile_id=' + (0, _lodash.get)(model, 'subprofile_id'));
      return _promise2.default.resolve();
    }
  });
  temp.push(utils.formActions.back);
  return temp;
}

/***/ }),
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.edit = exports.read = exports.view = exports.list = exports.columns = undefined;

var _regenerator = __webpack_require__(19);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(18);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _promise = __webpack_require__(7);

var _promise2 = _interopRequireDefault(_promise);

var _datePicker = __webpack_require__(53);

var _datePicker2 = _interopRequireDefault(_datePicker);

var _base = __webpack_require__(9);

var _base2 = _interopRequireDefault(_base);

var _datePicker3 = __webpack_require__(49);

var _datePicker4 = _interopRequireDefault(_datePicker3);

exports.title = title;
exports.tableFilters = tableFilters;
exports.formActions = formActions;
exports.listActions = listActions;

var _lodash = __webpack_require__(1);

var _order_db = __webpack_require__(334);

var _order_db2 = _interopRequireDefault(_order_db);

var _utils = __webpack_require__(3);

var utils = _interopRequireWildcard(_utils);

var _sample = __webpack_require__(17);

var _index = __webpack_require__(2);

var _index2 = _interopRequireDefault(_index);

var _subprofile = __webpack_require__(32);

var Subprofile = _interopRequireWildcard(_subprofile);

var _debug = __webpack_require__(5);

var _debug2 = _interopRequireDefault(_debug);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function title(model) {
  var p = (0, _lodash.get)(model, 'subProfile');
  if (p) {
    return Subprofile.title.call(this, p, Subprofile);
  }
  return p || _index2.default.s('schema.order');
}

var columns = exports.columns = utils.columnsFn(_order_db2.default);

var list = exports.list = utils.listFn('getOrders', function (payload) {
  if ((0, _lodash.get)(this, 'schemaParams.created_at')) {
    payload.created_at = {
      $gte: +(0, _moment2.default)(this.schemaParams.created_at).startOf('month'),
      $lte: +(0, _moment2.default)(this.schemaParams.created_at).endOf('month')
    };
  }
  return payload;
});
var view = exports.view = utils.viewFn('/admin/orders/:id');
var read = exports.read = utils.readFn('getOrderById', 'order_id');
exports.edit = _sample.edit;
function tableFilters(schema) {
  var _this = this;

  if (this.schemaParams) {
    this.schemaParams.created_at = null;
    return [function (h) {
      return h(_datePicker4.default.name, {
        props: {
          value: _this.schemaParams.created_at,
          type: 'month',
          placeholder: _index2.default.fr('label_pick_a_month')
        },
        on: {
          input: function input(v) {
            _this.schemaParams.created_at = v;
            _this.queryChanged();
          }
        }
      });
    }];
  }
  return [];
}

function formActions(model, schema, readonly) {
  var temp = [];
  if (!readonly) {
    temp.push({
      label: _index2.default.fr('action.save') + ' [Ctrl+Enter]',
      trigger: function trigger(e) {
        return (e.metaKey || e.ctrlKey) && e.keyCode === 13;
      },
      class: 'btn-success',
      validation: true,
      action: utils.updateFn('updateOrderAsAdmin', 'order_id', ['available_tickets', 'total_tickets', 'details', 'custom_ids', 'subProfile', 'expiry_date', 'status', 'service_location', 'emergency_contact'])
    });
    if (_debug2.default.DEBUG) {
      temp.push({
        label: _index2.default.fr('action.delete') + ' [Del]',
        class: 'btn-danger',
        trigger: function trigger(e) {
          return e.keyCode === 46;
        },
        action: utils.formActions.delete('deleteOrderById', 'order_id', '/admin/orders')
      });
    }
  }
  if (model.created_by) {
    temp.push({
      label: _index2.default.fr('action.create_$obj', { obj: '${i18n.schema.appointment}' }),
      class: 'btn-info',
      validation: false,
      action: function action(model, schema) {
        this.$router.push('/admin/appointments/create?order_id=' + model.order_id);
        return _promise2.default.resolve();
      }
    });
    temp.push({
      label: _index2.default.fr('action.create_$obj', { obj: '${i18n.schema.rapid_payment}' }),
      class: 'btn-info',
      validation: false,
      action: function action(model, schema) {
        this.$router.push('/admin/transactions/standalone?type=rapid&order_id=' + model.order_id);
        return _promise2.default.resolve();
      }
    });
    temp.push({
      label: _index2.default.fr('schema.refund_transaction'),
      class: 'btn-info',
      validation: false,
      action: function action(model, schema) {
        this.$router.push('/admin/transactions/standalone?type=refund&order_id=' + model.order_id);
        return _promise2.default.resolve();
      }
    });
  }
  temp.push(utils.formActions.back);
  return temp;
}

function listActions(schema, readonly) {
  var temp = [];
  temp.push({
    label: _index2.default.fr('action.export_data'),
    action: utils.exportFn({
      'order_id': 'Order ID',
      'created_by_name': 'Creator',
      'status': 'Status',
      'created_at': 'Created At',
      'updated_at': 'Updated At',
      'required_groups.0.group.details.code': 'Type of Service',
      'service_dates': 'Service Dates',
      'total_tickets': 'Total Tickets',
      'available_tickets': 'Available Tickets',
      'unit_amount': 'Unit Amount',
      'location_fee': 'Location Fee',
      'expiry_date': 'Expired At'
    }, function () {
      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(row, fields) {
        var filter;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                row.created_by_name = (0, _lodash.get)(row, 'created_by.details.profile.last_name', '') + ' ' + (0, _lodash.get)(row, 'created_by.details.profile.first_name', '');
                row.service_dates = (0, _lodash.get)(row, 'appointments', []).map(function (x) {
                  return (0, _moment2.default)((0, _lodash.get)(x, 'details.service_date'));
                }).filter(function (x) {
                  return x.isValid();
                }).map(function (x) {
                  return x.format('DD/MM/YYYY');
                }).join('\n');

                filter = function filter(x) {
                  for (var k in fields) {
                    k = (0, _lodash.toPath)(k);
                    if ((0, _lodash.get)(x, k) == null) {
                      (0, _lodash.set)(x, k, '');
                    }
                  }
                };

                filter(row);
                return _context.abrupt('return', row);

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }())
  });
  return temp;
}

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.edit = exports.read = exports.view = exports.list = exports.columns = undefined;

var _regenerator = __webpack_require__(19);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(18);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

exports.title = title;
exports.formActions = formActions;
exports.listActions = listActions;

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _lodash = __webpack_require__(1);

var _transaction_db = __webpack_require__(280);

var _transaction_db2 = _interopRequireDefault(_transaction_db);

var _utils = __webpack_require__(3);

var utils = _interopRequireWildcard(_utils);

var _sample = __webpack_require__(17);

var _index = __webpack_require__(2);

var _index2 = _interopRequireDefault(_index);

var _membership = __webpack_require__(14);

var Member = _interopRequireWildcard(_membership);

var _debug = __webpack_require__(5);

var _debug2 = _interopRequireDefault(_debug);

var _sweetalert = __webpack_require__(54);

var _sweetalert2 = _interopRequireDefault(_sweetalert);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function title(model) {
  if (model) {
    return (0, _moment2.default)((0, _lodash.get)(model, 'created_at')).format('YYYY-MM-DD HH:mm:ss') + ' (From ' + Member.title.call(this, model.from, Member) + ' to ' + Member.title.call(this, model.to, Member) + ')';
  } else {
    return _index2.default.s('schema.transaction');
  }
}

var columns = exports.columns = utils.columnsFn(_transaction_db2.default);

var list = exports.list = utils.listFn('getTransactions');
var view = exports.view = utils.viewFn('/admin/transactions/:id');
var read = exports.read = utils.readFn('getTransactionById', 'transaction_id');

exports.edit = _sample.edit;
function formActions(model, schema, readonly) {
  var temp = [];
  if (!readonly) {
    if (model && model.type === 'caregiver_invoice' && ['waiting_admin_confirm', 'pending'].includes(model.transaction_progress)) {
      temp.push({
        label: _index2.default.fr('action.complete_invoice'),
        class: 'btn-success',
        action: function action(model, schema, columns) {
          var _this = this;

          return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
            var self;
            return _regenerator2.default.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    self = _this;
                    return _context.abrupt('return', (0, _sweetalert2.default)({
                      html: _index2.default.fr('alert.html.confirm_complete_invoice'),
                      type: 'warning',
                      showCancelButton: true,
                      confirmButtonText: _index2.default.fr('action.yes'),
                      cancelButtonText: _index2.default.fr('action.cancel'),
                      confirmButtonClass: 'btn btn-danger btn-fill',
                      cancelButtonClass: 'btn btn-fill',
                      buttonsStyling: false
                    }).then(function () {
                      return utils.updateFn('updateTransaction', 'transaction_id', ['transaction_progress'], function (payload) {
                        payload.transaction_progress = 'success';
                        return payload;
                      }).call(self, model, schema, columns);
                    }, function () {
                      return false;
                    }));

                  case 2:
                  case 'end':
                    return _context.stop();
                }
              }
            }, _callee, _this);
          }))();
        }
      });
    }
    temp.push({
      label: _index2.default.fr('action.save') + ' [Ctrl+Enter]',
      trigger: function trigger(e) {
        return (e.metaKey || e.ctrlKey) && e.keyCode === 13;
      },
      class: 'btn-success',
      validation: true,
      action: utils.updateFn('updateTransaction', 'transaction_id', ['transaction_progress', 'status', 'remark'])
    });
    if (_debug2.default.DEBUG) {
      temp.push({
        label: _index2.default.s('action.delete') + ' [Del]',
        class: 'btn-danger',
        trigger: function trigger(e) {
          return e.keyCode === 46;
        },
        action: utils.formActions.delete('deleteTransactionById', 'transaction_id', '/admin/transactions')
      });
    }
  }
  temp.push(utils.formActions.back);
  return temp;
}

function listActions(schema, readonly) {
  var temp = [];
  temp.push({
    label: _index2.default.fr('action.create_$obj', { obj: '${i18n.schema.standalone_transaction}' }),
    class: 'btn-success',
    action: utils.createFn('/admin/transactions/standalone?type=standalone')
  });
  temp.push({
    label: _index2.default.fr('action.create_$obj', { obj: '${i18n.schema.rapid_payment}' }),
    class: 'btn-success',
    action: utils.createFn('/admin/transactions/standalone?type=rapid')
  });
  return temp;
}

/***/ }),
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.columns = undefined;
exports.title = title;

var _lodash = __webpack_require__(1);

var _utils = __webpack_require__(3);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _i18n = __webpack_require__(2);

var _i18n2 = _interopRequireDefault(_i18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function title(model) {
  return model ? _i18n2.default.fr('fields.display_name_$first_$last', {
    first: (0, _lodash.get)(model, 'first_name', ''),
    last: (0, _lodash.get)(model, 'last_name', '')
  }).trim() : '';
}

var columns = exports.columns = (0, _utils.columnsFn)(function () {
  return {
    first_name: { type: 'string' },
    last_name: { type: 'string' },
    other_name: { type: 'string' },
    gender: { type: 'select', items: ['gender.m', 'gender.f'] },
    hkid: { type: 'string' },
    mobile: { type: 'string' },
    home_tel: { type: 'string' },
    birthday: { type: 'date' },
    age: {
      type: 'label', get: function get(model) {
        return model ? _i18n2.default.fr('fields.years_old_$yrs', { yrs: (0, _moment2.default)().diff(model.birthday, 'years') }) : '';
      }
    },
    height: { type: 'number' },
    weight: { type: 'number' }
  };
});

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.columns = undefined;

var _stringify = __webpack_require__(37);

var _stringify2 = _interopRequireDefault(_stringify);

var _keys = __webpack_require__(16);

var _keys2 = _interopRequireDefault(_keys);

exports.title = title;

var _lodash = __webpack_require__(1);

var _utils = __webpack_require__(3);

var _systemconfig = __webpack_require__(101);

var SystemConfig = _interopRequireWildcard(_systemconfig);

var _i18n = __webpack_require__(2);

var _i18n2 = _interopRequireDefault(_i18n);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var columns = exports.columns = (0, _utils.columnsFn)({
  area: {
    type: 'select', readonly: true,
    items: (0, _lodash.map)((0, _keys2.default)(_i18n2.default.s('fields.service_areas')), function (x) {
      return 'fields.service_areas.' + x;
    })
  },
  district: {
    type: 'select',
    label: 'fields.district',
    list: false,
    valueKey: 'id',
    items: function items(value, model, spec, search) {
      return (0, _utils.readFn)('getCurrentSystemconfig', '').call(this, null, SystemConfig, []).then(function (response) {
        var data = (0, _lodash.get)(response, 'selection.district_area_fee');
        if (search) {
          var re = (0, _stringify2.default)(search).replace(/^"|"$/g, '').toLowerCase();
          data = (0, _lodash.filter)(data, function (x) {
            return (0, _stringify2.default)(x).toLowerCase().indexOf(re) >= 0;
          });
        }
        return (0, _lodash.map)(data, function (x) {
          return { value: x, label: _i18n2.default.S(x.location) };
        });
      });
    },
    set: function set(model, spec, v) {
      this.$set(model, 'area', v.area);
      this.$set(model, 'district', v.id);
    },
    get: function get(model) {
      return model.district ? { id: model.district } : null;
    }
  },
  address: { type: 'string' }
});

function title(model) {
  return (0, _lodash.get)(model, 'address');
}

/***/ }),
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.edit = exports.create = exports.read = exports.view = exports.list = exports.columns = undefined;

var _getIterator2 = __webpack_require__(23);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _promise = __webpack_require__(7);

var _promise2 = _interopRequireDefault(_promise);

exports.title = title;
exports.formActions = formActions;

var _lodash = __webpack_require__(1);

var _product_db = __webpack_require__(279);

var _product_db2 = _interopRequireDefault(_product_db);

var _utils = __webpack_require__(3);

var utils = _interopRequireWildcard(_utils);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _sample = __webpack_require__(17);

var _index = __webpack_require__(2);

var _index2 = _interopRequireDefault(_index);

var _group = __webpack_require__(31);

var Group = _interopRequireWildcard(_group);

var _debug = __webpack_require__(5);

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function title(model) {
  var title = _index2.default.S((0, _lodash.get)(model, 'details.title'));
  if (title) return title;
  var gp = (0, _lodash.get)(model, 'required_groups.0.group');
  gp = gp ? Group.title.call(this, gp, Group) : null;
  return gp || _index2.default.s('schema.product');
}

var columns = exports.columns = utils.columnsFn(_product_db2.default);

var list = exports.list = utils.listFn('getProducts');
var view = exports.view = utils.viewFn('/admin/products/:id');
var read = exports.read = utils.readFn('getProductById', 'product_id', null, null, function (p) {
  return p.then(function (response) {
    if (!response.body) {
      throw new Error(_index2.default.f('alert.empty_response', { response: response }));
    }
    var result = response.body;
    if (!result.success) {
      console.error(response);
      return _promise2.default.reject(_index2.default.S(result.err));
    }
    if (!result.data) {
      console.error(response);
      throw new Error(_index2.default.f('alert.invalid_response', { response: response }));
    }
    (0, _lodash.each)(result.data.customs, function (x) {
      var str = x.custom_id.replace(/\.[a-z0-9\-]{36}$/i, '').split('-');
      x.details.start_time = (0, _moment2.default)(str[1], 'HHmm');
      x.details.cooldown_hours = parseFloat(str[2]) / 60;
      x.details.service_hours = parseFloat(str[0]) / 60;
    });
    return result.data;
  });
});
var create = exports.create = utils.createFn('/admin/products/create');

exports.edit = _sample.edit;
function formActions(model, schema, readonly) {
  var temp = [];
  if (!readonly) {
    if (!this.$route.params.id) {
      temp.push({
        label: _index2.default.fr('action.create'),
        class: 'btn-success',
        validation: true,
        action: utils.updateFn('createProduct', null, ['type', 'tags', 'inventory_unlimited', 'inventory', 'required_custom_types', 'required_groups', 'customs', 'details'], function (payload, schema, columns) {
          (0, _lodash.each)(payload.customs, function (x) {
            x.custom_id = x.details.service_hours * 60 + '-' + (0, _moment2.default)(x.details.start_time).format('HHmm') + '-' + x.details.cooldown_hours * 60;
          });
          return payload;
        })
      });
    } else {
      temp.push({
        label: _index2.default.fr('action.save') + ' [Ctrl+Enter]',
        class: 'btn-success',
        validation: true,
        trigger: function trigger(e) {
          return (e.metaKey || e.ctrlKey) && e.keyCode === 13;
        },
        action: utils.updateFn('updateProduct', 'product_id', ['type', 'status', 'tags', 'inventory_unlimited', 'inventory', 'privacy', 'required_custom_types', 'required_groups', 'customs', 'details'], function (payload, schema, columns) {
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = (0, _getIterator3.default)(payload.customs), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var x = _step.value;

              x.custom_id = x.details.service_hours * 60 + '-' + (0, _moment2.default)(x.details.start_time).format('HHmm') + '-' + x.details.cooldown_hours * 60;
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          return payload;
        })
      });
      temp.push({
        label: _index2.default.fr('action.duplicate'),
        class: 'btn-info',
        validation: true,
        action: utils.updateFn('duplicateProduct', 'product_id', [], null, null, utils.formActions.postprocess.redirect(function (result) {
          return '/admin/products/' + result.data.product_id;
        }))
      });
      if (_debug2.default.DEBUG) {
        temp.push({
          label: _index2.default.s('action.delete') + ' [Del]',
          class: 'btn-danger',
          trigger: function trigger(e) {
            return e.keyCode === 46;
          },
          action: utils.formActions.delete('deleteProductById', 'product_id', '/admin/products')
        });
      }
    }
  }
  temp.push(utils.formActions.back);
  return temp;
}

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.columns = undefined;

var _taggedTemplateLiteral2 = __webpack_require__(30);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['', ' ', ' ', ' (', ')'], ['', ' ', ' ', ' (', ')']);

exports.title = title;

var _utils = __webpack_require__(3);

var _index = __webpack_require__(2);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var columns = exports.columns = (0, _utils.columnsFn)({
  name: { type: 'string' },
  last_name: { type: 'string' },
  first_name: { type: 'string' },
  mobile: { type: 'string' }
});

function title(model) {
  return model ? _index2.default.nn(_templateObject, model.last_name, model.first_name, model.name, model.mobile) : '';
}

/***/ }),
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(450)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(312),
  /* template */
  __webpack_require__(514),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 98 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 99 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.edit = exports.read = exports.view = exports.list = exports.columns = undefined;
exports.title = title;
exports.formActions = formActions;

var _lodash = __webpack_require__(1);

var _notification_db = __webpack_require__(277);

var _notification_db2 = _interopRequireDefault(_notification_db);

var _utils = __webpack_require__(3);

var utils = _interopRequireWildcard(_utils);

var _sample = __webpack_require__(17);

var _index = __webpack_require__(2);

var _index2 = _interopRequireDefault(_index);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _debug = __webpack_require__(5);

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function title(model) {
  return _index2.default.S((0, _lodash.get)(model, 'details.title'), _index2.default.s('schema.notification'));
}

var columns = exports.columns = utils.columnsFn(_notification_db2.default);
var list = exports.list = utils.listFn('getAdminNotifications');
var view = exports.view = utils.viewFn('/admin/notifications/:id');
var read = exports.read = utils.readFn('getNotificationById', 'notification_id');

exports.edit = _sample.edit;
function formActions(model, schema, readonly) {
  var temp = [];
  var read = (0, _lodash.get)(model, 'read');
  temp.push({
    label: read ? _index2.default.fr('action.unread') : _index2.default.fr('action.read'),
    class: 'btn-success',
    action: utils.updateFn('updateNotificationByIds', null, null, function (payload) {
      payload.notification_ids = [payload.notification_id];
      payload.read = !read;
      return payload;
    }, null, utils.formActions.postprocess.redirect(function () {
      return '/admin/notifications';
    }))
  });
  if (_debug2.default.DEBUG) {
    temp.push({
      label: _index2.default.fr('action.delete') + ' [Del]',
      class: 'btn-danger',
      trigger: function trigger(e) {
        return e.keyCode === 46;
      },
      action: utils.formActions.delete('deleteNotificationById', 'notification_id', '/admin/notifications')
    });
  }
  if (!readonly) {
    temp.push({
      label: _index2.default.fr('action.save') + ' [Ctrl+Enter]',
      class: 'btn-success',
      validation: true,
      trigger: function trigger(e) {
        return (e.metaKey || e.ctrlKey) && e.keyCode === 13;
      },
      action: utils.updateFn('updateNotificationByIds', 'notification_ids', ['status', 'read'])
    });
  }
  temp.push(utils.formActions.back);
  return temp;
}

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.edit = exports.read = exports.view = exports.list = exports.columns = undefined;

var _taggedTemplateLiteral2 = __webpack_require__(30);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['', ' (', ')'], ['', ' (', ')']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['', ' (', ', $', ')'], ['', ' (', ', $', ')']),
    _templateObject3 = (0, _taggedTemplateLiteral3.default)(['', ' ', ''], ['', ' ', '']);

exports.title = title;
exports.formActions = formActions;

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _lodash = __webpack_require__(1);

var _utils = __webpack_require__(3);

var utils = _interopRequireWildcard(_utils);

var _sample = __webpack_require__(17);

var _index = __webpack_require__(2);

var _index2 = _interopRequireDefault(_index);

var _membership = __webpack_require__(14);

var Member = _interopRequireWildcard(_membership);

var _debug = __webpack_require__(5);

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function title(model) {
  return model ? (0, _moment2.default)((0, _lodash.get)(model, 'created_at')).format('YYYY-MM-DD HH:mm:ss') : _index2.default.s('schema.systemconfig');
}

var columns = exports.columns = utils.columnsFn({
  systemconfig_id: { type: 'id' },
  status: { type: 'select', items: ['status.active', 'status.inactive'] },
  type: { type: 'string' },
  updated_at: { type: 'datetime' },
  last_updated_by: { type: 'schema', schema: Member, external: true },
  config: {
    type: 'schema', schema: (0, _utils.inlineSchema)({
      app_name: { type: 'string' },
      log_write_requests: { type: 'checkbox' },
      dev_secret: { type: 'string' }
    })
  },
  selection: {
    type: 'schema', schema: (0, _utils.inlineSchema)({
      areas: {
        type: 'array', add: true, delete: true, itemType: {
          type: 'schema', schema: (0, _lodash.merge)((0, _utils.inlineSchema)({
            id: { type: 'string', required: true },
            area: { type: 'i18n', itemType: { type: 'string' } }
          }), {
            title: function title(model) {
              return _index2.default.nn(_templateObject, _index2.default.S(model.area), model.id);
            }
          })
        }
      },
      district_area_fee: {
        type: 'array', add: true, delete: true, itemType: {
          type: 'schema', schema: (0, _lodash.merge)((0, _utils.inlineSchema)({
            id: { type: 'string', required: true },
            extra_fee: { type: 'number', min: 0 },
            caregiver_commission: { type: 'number', min: 0 },
            area: {
              type: 'select', items: function items() {
                return (0, _lodash.map)((0, _lodash.get)(this.rootModel, 'selection.areas', []), function (x) {
                  return { value: x.id, label: _index2.default.S(x.area) };
                });
              }
            },
            location: { type: 'i18n', itemType: { type: 'string' } }
          }), {
            title: function title(model) {
              return _index2.default.nn(_templateObject2, _index2.default.S(model.location), model.id, model.extra_fee);
            }
          })
        }
      },
      special_dates: {
        type: 'array', add: true, delete: true, itemType: {
          type: 'schema', schema: (0, _lodash.merge)((0, _utils.inlineSchema)({
            "details.title": { type: 'string' },
            "ratio": { type: 'number', default: 1 },
            "date": { type: 'date' }
          }), {
            title: function title(model) {
              return _index2.default.nn(_templateObject, (0, _lodash.get)(model, 'details.title'), (0, _moment2.default)(model.date).format('YYYY-MM-DD'));
            }
          })
        }
      }
    })
  },
  versions: {
    type: 'schema',
    schema: (0, _utils.inlineSchema)({
      client: {
        type: 'array', add: true, delete: true, min: 1,
        itemType: {
          type: 'schema', schema: (0, _lodash.merge)((0, _utils.inlineSchema)({
            version: { type: 'string' },
            compulsory: { type: 'boolean' },
            updated_at: { type: 'datetime' }
          }), {
            title: function title(model) {
              return _index2.default.nn(_templateObject3, model.version, model.compulsory ? _index2.default.fr('label_compulsory') : '');
            }
          })
        }
      },
      caregiver: {
        type: 'array', add: true, delete: true, min: 1,
        itemType: {
          type: 'schema', schema: (0, _lodash.merge)((0, _utils.inlineSchema)({
            version: { type: 'string' },
            compulsory: { type: 'boolean' },
            updated_at: { type: 'datetime' }
          }), {
            title: function title(model) {
              return _index2.default.nn(_templateObject3, model.version, model.compulsory ? _index2.default.fr('label_compulsory') : '');
            }
          })
        }
      }

    })
  },
  feedback: {
    type: 'schema',
    schema: (0, _utils.inlineSchema)({
      client_questions: {
        type: 'array', add: _debug2.default.DEBUG, delete: _debug2.default.DEBUG,
        itemType: {
          type: 'schema', schema: (0, _utils.inlineSchema)({
            question: { type: 'i18n', itemType: { type: 'string' } },

            ratio: { type: 'number' }
          })
        }
      },
      caregiver_questions: {
        type: 'array', add: _debug2.default.DEBUG, delete: _debug2.default.DEBUG,
        itemType: {
          type: 'schema', schema: (0, _utils.inlineSchema)({
            question: { type: 'i18n', itemType: { type: 'string' } },

            ratio: { type: 'number' }
          })
        }
      },
      adminToClient_questions: {
        type: 'array', add: _debug2.default.DEBUG, delete: _debug2.default.DEBUG,
        itemType: {
          type: 'schema', schema: (0, _utils.inlineSchema)({
            question: { type: 'i18n', itemType: { type: 'string' } },

            ratio: { type: 'number' }
          })
        }
      },
      adminToCaregiver_questions: {
        type: 'array', add: _debug2.default.DEBUG, delete: _debug2.default.DEBUG,
        itemType: {
          type: 'schema', schema: (0, _utils.inlineSchema)({
            question: { type: 'i18n', itemType: { type: 'string' } },

            ratio: { type: 'number' }
          })
        }
      }
    })
  },
  app_terms: {
    label: 'Purchase Terms',
    type: 'schema',
    schema: (0, _utils.inlineSchema)({
      client: {
        type: 'i18n', itemType: { type: 'text' }
      },
      caregiver: {
        type: 'i18n', itemType: { type: 'text' }
      }
    })
  }
});

var list = exports.list = utils.listFn('getSystemconfigs');
var view = exports.view = utils.viewFn('/admin/systemconfigs/:id');
var read = exports.read = utils.readFn('getSystemconfigById', 'systemconfig_id');

exports.edit = _sample.edit;
function formActions(model, schema, readonly) {
  var temp = [];
  if (!readonly) {
    temp.push({
      label: _index2.default.fr('action.save') + ' [Ctrl+Enter]',
      class: 'btn-success',
      validation: true,
      trigger: function trigger(e) {
        return (e.metaKey || e.ctrlKey) && e.keyCode === 13;
      },
      action: utils.updateFn('updateSystemconfig', 'systemconfig_id', ['config', 'selection', 'versions', 'feedback', 'app_terms'])
    });
  }
  temp.push(utils.formActions.back);
  return temp;
}

/***/ }),
/* 102 */,
/* 103 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.columns = undefined;

var _keys = __webpack_require__(16);

var _keys2 = _interopRequireDefault(_keys);

exports.title = title;

var _lodash = __webpack_require__(1);

var _i18n = __webpack_require__(2);

var _i18n2 = _interopRequireDefault(_i18n);

var _utils = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var columns = exports.columns = (0, _utils.columnsFn)({
  disease: {
    type: 'select', multi: true,
    items: (0, _lodash.map)((0, _keys2.default)(_i18n2.default.s('fields.medical_histories.disease')), function (x) {
      return 'fields.medical_histories.disease.' + x;
    })
  },
  currentStatus: {
    type: 'select', multi: true,
    items: (0, _lodash.map)((0, _keys2.default)(_i18n2.default.s('fields.medical_histories.currentStatus')), function (x) {
      return 'fields.medical_histories.currentStatus.' + x;
    })
  },
  otherDisease: { type: 'string' },
  doneSurgery: { type: 'checkbox' },
  surgery: { type: 'string' },
  mentalTreatment: { type: 'checkbox' },
  useService: { type: 'string' }
});

function title(model) {
  return model ? model.name : '';
}

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.columns = undefined;
exports.title = title;

var _utils = __webpack_require__(3);

var columns = exports.columns = (0, _utils.columnsFn)({
  company_name: { type: 'string' }
});

function title(model) {
  return model ? model.company_name : '';
}

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(457)
__webpack_require__(458)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(311),
  /* template */
  __webpack_require__(533),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 107 */,
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.list = exports.listActions = exports.formActions = exports.edit = exports.read = exports.view = exports.columns = exports.title = undefined;

var _membership = __webpack_require__(14);

Object.defineProperty(exports, 'title', {
  enumerable: true,
  get: function get() {
    return _membership.title;
  }
});
Object.defineProperty(exports, 'columns', {
  enumerable: true,
  get: function get() {
    return _membership.columns;
  }
});
Object.defineProperty(exports, 'view', {
  enumerable: true,
  get: function get() {
    return _membership.view;
  }
});
Object.defineProperty(exports, 'read', {
  enumerable: true,
  get: function get() {
    return _membership.read;
  }
});
Object.defineProperty(exports, 'edit', {
  enumerable: true,
  get: function get() {
    return _membership.edit;
  }
});
Object.defineProperty(exports, 'formActions', {
  enumerable: true,
  get: function get() {
    return _membership.formActions;
  }
});
Object.defineProperty(exports, 'listActions', {
  enumerable: true,
  get: function get() {
    return _membership.listActions;
  }
});
exports.tableFilters = tableFilters;

var _utils = __webpack_require__(3);

var utils = _interopRequireWildcard(_utils);

var _i18n = __webpack_require__(2);

var _i18n2 = _interopRequireDefault(_i18n);

var _lodash = __webpack_require__(1);

var _group = __webpack_require__(31);

var Group = _interopRequireWildcard(_group);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var list = exports.list = utils.listFn('getCaregivers', function (payload) {
  if ((0, _lodash.get)(this, 'schemaParams.group_ids')) {
    payload.group_ids = [(0, _lodash.get)(this, 'schemaParams.group_ids')];
  }
  return payload;
});

function tableFilters(schema) {
  var _this = this;

  if (this.schemaParams) {
    var self = this;
    this.$set(this.schemaParams, 'group_ids', null);
    return [function (h) {
      return h('f-select', {
        props: {
          model: _this.schemaParams,
          rootModel: _this.schemaParams,
          spec: {
            prop: 'group_ids',
            placeholder: _i18n2.default.fr('label_pick_a_profession'),
            type: 'select',
            search: true,
            items: function items(value, model, fieldSpec, search) {
              return Group.list.call(self, { skip: 0, limit: 10, search: search }).then(function (response) {
                return (0, _lodash.map)(response.data, function (x) {
                  return {
                    value: x.group_id,
                    label: _i18n2.default.S((0, _lodash.get)(x, 'details.name'), (0, _lodash.get)(x, 'details.name_en'))
                  };
                });
              });
            },

            onchange: function onchange(v) {
              self.queryChanged();
            }
          }
        }
      });
    }];
  }
  return [];
}

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.read = exports.list = exports.columns = undefined;

var _taggedTemplateLiteral2 = __webpack_require__(30);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['', ' : ', ''], ['', ' : ', '']);

exports.title = title;
exports.view = view;
exports.formActions = formActions;

var _lodash = __webpack_require__(1);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _utils = __webpack_require__(3);

var utils = _interopRequireWildcard(_utils);

var _index = __webpack_require__(2);

var _index2 = _interopRequireDefault(_index);

var _appointment = __webpack_require__(26);

var Appointment = _interopRequireWildcard(_appointment);

var _membership = __webpack_require__(14);

var Member = _interopRequireWildcard(_membership);

var _debug = __webpack_require__(5);

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function title(model) {
  return model ? (0, _moment2.default)((0, _lodash.get)(model, 'created_at')).format('YYYY-MM-DD HH:mm:ss') + ' (' + Member.title.call(this, (0, _lodash.get)(model, 'refs.sender')) + ' to ' + Member.title.call(this, (0, _lodash.get)(model, 'refs.receiver')) + ')' : _index2.default.s('schema.appointment');
}

var columns = exports.columns = (0, _utils.columnsFn)(function () {
  return {
    feedback_id: { type: 'id' },
    status: { type: 'select', items: ['status.active', 'status.inactive'], default: 'active' },
    created_at: { type: 'datetime', readonly: true },
    type: {
      type: 'select',
      items: ['type.feedback.admin_to_caregiver', 'type.feedback.admin_to_client', 'type.feedback.client_to_caregiver', 'type.feedback.client_appointment_feedback'],
      readonly: true
    },
    tags: { type: 'tags' },

    details: {
      type: 'schema',
      schema: (0, _utils.inlineSchema)({
        remark: { type: 'label' },
        scores: {
          type: 'array', itemType: {
            type: 'schema', schema: (0, _lodash.merge)((0, _utils.inlineSchema)({
              question: { type: 'label' },
              score: { type: 'label' },
              weight: { type: 'label', label: _index2.default.fr('fields.ratio') }
            }), {
              title: function title(model) {
                return _index2.default.nn(_templateObject, model.question, model.score);
              }
            })
          }
        },
        avg_score: {
          type: 'label',
          readonly: true, get: function get(model) {
            try {
              return model && model.scores ? Math.round((0, _lodash.sumBy)(model.scores, function (x) {
                return x.score * Number(x.weight);
              }) / (0, _lodash.sumBy)(model.scores, function (x) {
                return Number(x.weight);
              }) * 10) / 10 : 0;
            } catch (e) {
              return NaN;
            }
          }
        }
      })
    },
    'refs.sender': { type: 'schema', schema: Member, readonly: true, list: true },
    'refs.receiver': { type: 'schema', schema: Member, readonly: true, list: true },
    'refs.appointment': { type: 'schema', schema: Appointment, readonly: true }
  };
});
var list = exports.list = utils.listFn('getFeedbacks', function (payload) {
  payload.type = 'caregiver_appointment_feedback';
  return payload;
});

function view(model, index, schema, columns) {
  return utils.viewFn(model && model.type === 'client_to_caregiver' ? '/admin/feedback-client/:id' : '/admin/feedback-caregiver/:id').apply(this, arguments);
}

var read = exports.read = utils.readFn('getFeedbackById', 'feedback_id');

function formActions(model, schema, readonly) {
  var temp = [];
  if (_debug2.default.DEBUG) {
    temp.push({
      label: _index2.default.fr('action.delete') + ' [Del]',
      class: 'btn-danger',
      trigger: function trigger(e) {
        return e.keyCode === 46;
      },
      action: utils.formActions.delete('deleteFeedbackById', 'feedback_id', '/admin/feedback-caregiver')
    });
  }
  temp.push(utils.formActions.back);
  return temp;
}

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.edit = exports.read = exports.view = exports.list = exports.columns = undefined;
exports.title = title;
exports.formActions = formActions;

var _lodash = __webpack_require__(1);

var _payment_db = __webpack_require__(335);

var _payment_db2 = _interopRequireDefault(_payment_db);

var _utils = __webpack_require__(3);

var utils = _interopRequireWildcard(_utils);

var _sample = __webpack_require__(17);

var _index = __webpack_require__(2);

var _index2 = _interopRequireDefault(_index);

var _debug = __webpack_require__(5);

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function title(model) {
  return (0, _lodash.get)(model, 'payment_id') || _index2.default.s('schema.payment');
}

var columns = exports.columns = utils.columnsFn(_payment_db2.default);

var list = exports.list = utils.listFn('getPayments');
var view = exports.view = utils.viewFn('/admin/payments/:id');
var read = exports.read = utils.readFn('getPaymentById', 'payment_id');

exports.edit = _sample.edit;
function formActions(model, schema, readonly) {
  var temp = [];
  if (!readonly) {
    temp.push({
      label: _index2.default.fr('action.save'),
      class: 'btn-success',
      validation: true,
      action: utils.updateFn('updatePayment', 'payment_id', [])
    });
  }
  if (_debug2.default.DEBUG) {
    temp.push({
      label: _index2.default.fr('action.delete') + ' [Del]',
      class: 'btn-danger',
      trigger: function trigger(e) {
        return e.keyCode === 46;
      },
      action: utils.formActions.delete('deletePaymentById', 'payment_id', '/admin/payments')
    });
  }
  temp.push(utils.formActions.back);
  return temp;
}

/***/ }),
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 142 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(315),
  /* template */
  __webpack_require__(537),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 259 */,
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(1);

exports.default = {
  install: function install(Vue) {
    Vue.mixin({
      computed: {
        $auth: {
          get: function get() {
            return (0, _lodash.get)(this, '$store.state.auth');
          },
          set: function set(v) {
            this.$store.commit('auth', v);
          }
        }
      }
    });
  }
};

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  install: function install(Vue) {
    Vue.mixin({
      beforeCreate: function beforeCreate() {
        if (this.$options.bus) {
          this.$bus = typeof this.$options.bus === 'function' ? this.$options.bus() : this.$options.bus;
        } else if (this.$options.parent && this.$options.parent.$bus) {
          this.$bus = this.$options.parent.$bus;
        }
      }
    });
  }
};

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SideBar = __webpack_require__(498);

var _SideBar2 = _interopRequireDefault(_SideBar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SidebarStore = {
  options: null,
  showSidebar: false,
  sidebarLinks: [],
  isMinimized: false,
  displaySidebar: function displaySidebar(value) {
    this.showSidebar = value;
  },
  toggleMinimize: function toggleMinimize() {
    document.body.classList.toggle('sidebar-mini');

    var simulateWindowResize = setInterval(function () {
      window.dispatchEvent(new Event('resize'));
    }, 180);

    setTimeout(function () {
      clearInterval(simulateWindowResize);
    }, 1000);

    this.isMinimized = !this.isMinimized;
  },
  reload: function reload() {
    if (this.options && this.options.sidebarLinks) {
      if (typeof this.options.sidebarLinks === 'function') {
        this.sidebarLinks = this.options.sidebarLinks.call(this.options.vm);
      } else {
        this.sidebarLinks = this.options.sidebarLinks;
      }
    }
  }
};

var SidebarPlugin = {
  install: function install(Vue, options) {
    SidebarStore.options = options;
    SidebarStore.reload();
    Vue.mixin({
      data: function data() {
        return {
          sidebarStore: SidebarStore
        };
      }
    });

    Object.defineProperty(Vue.prototype, '$sidebar', {
      get: function get() {
        return this.$root.sidebarStore;
      }
    });
    Vue.component('side-bar', _SideBar2.default);
  }
};

exports.default = SidebarPlugin;

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _datePicker = __webpack_require__(53);

var _datePicker2 = _interopRequireDefault(_datePicker);

var _datePicker3 = __webpack_require__(49);

var _datePicker4 = _interopRequireDefault(_datePicker3);

var _collapseItem = __webpack_require__(98);

var _collapseItem2 = _interopRequireDefault(_collapseItem);

var _collapseItem3 = __webpack_require__(89);

var _collapseItem4 = _interopRequireDefault(_collapseItem3);

var _collapse = __webpack_require__(99);

var _collapse2 = _interopRequireDefault(_collapse);

var _base = __webpack_require__(9);

var _base2 = _interopRequireDefault(_base);

var _collapse3 = __webpack_require__(90);

var _collapse4 = _interopRequireDefault(_collapse3);

var _formGroupInput = __webpack_require__(494);

var _formGroupInput2 = _interopRequireDefault(_formGroupInput);

var _Dropdown = __webpack_require__(491);

var _Dropdown2 = _interopRequireDefault(_Dropdown);

var _Checkbox = __webpack_require__(258);

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _Radio = __webpack_require__(493);

var _Radio2 = _interopRequireDefault(_Radio);

var _vueNavTabs = __webpack_require__(539);

var _vueNavTabs2 = _interopRequireDefault(_vueNavTabs);

var _fArray = __webpack_require__(472);

var _fArray2 = _interopRequireDefault(_fArray);

var _fInput = __webpack_require__(481);

var _fInput2 = _interopRequireDefault(_fInput);

var _fTextarea = __webpack_require__(490);

var _fTextarea2 = _interopRequireDefault(_fTextarea);

var _fCheckbox = __webpack_require__(474);

var _fCheckbox2 = _interopRequireDefault(_fCheckbox);

var _fDatetime = __webpack_require__(475);

var _fDatetime2 = _interopRequireDefault(_fDatetime);

var _fSelect = __webpack_require__(487);

var _fSelect2 = _interopRequireDefault(_fSelect);

var _fTags = __webpack_require__(489);

var _fTags2 = _interopRequireDefault(_fTags);

var _fSchema = __webpack_require__(486);

var _fSchema2 = _interopRequireDefault(_fSchema);

var _fTable = __webpack_require__(488);

var _fTable2 = _interopRequireDefault(_fTable);

var _fLabel = __webpack_require__(483);

var _fLabel2 = _interopRequireDefault(_fLabel);

var _fId = __webpack_require__(479);

var _fId2 = _interopRequireDefault(_fId);

var _fRadio = __webpack_require__(485);

var _fRadio2 = _interopRequireDefault(_fRadio);

var _fLink = __webpack_require__(484);

var _fLink2 = _interopRequireDefault(_fLink);

var _fImg = __webpack_require__(480);

var _fImg2 = _interopRequireDefault(_fImg);

var _fFile = __webpack_require__(476);

var _fFile2 = _interopRequireDefault(_fFile);

var _fButton = __webpack_require__(473);

var _fButton2 = _interopRequireDefault(_fButton);

var _fI18n = __webpack_require__(478);

var _fI18n2 = _interopRequireDefault(_fI18n);

var _fJson = __webpack_require__(482);

var _fJson2 = _interopRequireDefault(_fJson);

var _fHtml = __webpack_require__(477);

var _fHtml2 = _interopRequireDefault(_fHtml);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GlobalComponents = {
  install: function install(Vue) {
    Vue.use(_vueNavTabs2.default);
    Vue.use(_collapse4.default);
    Vue.use(_collapseItem4.default);
    Vue.use(_datePicker4.default);

    Vue.component(_formGroupInput2.default.name, _formGroupInput2.default);
    Vue.component(_Dropdown2.default.name, _Dropdown2.default);
    Vue.component(_Checkbox2.default.name, _Checkbox2.default);
    Vue.component(_Radio2.default.name, _Radio2.default);

    Vue.component(_fArray2.default.name, _fArray2.default);
    Vue.component(_fInput2.default.name, _fInput2.default);
    Vue.component(_fTextarea2.default.name, _fTextarea2.default);
    Vue.component(_fCheckbox2.default.name, _fCheckbox2.default);
    Vue.component(_fDatetime2.default.name, _fDatetime2.default);
    Vue.component(_fSelect2.default.name, _fSelect2.default);
    Vue.component(_fTags2.default.name, _fTags2.default);
    Vue.component(_fSchema2.default.name, _fSchema2.default);
    Vue.component(_fTable2.default.name, _fTable2.default);
    Vue.component(_fLabel2.default.name, _fLabel2.default);
    Vue.component(_fId2.default.name, _fId2.default);
    Vue.component(_fRadio2.default.name, _fRadio2.default);
    Vue.component(_fLink2.default.name, _fLink2.default);
    Vue.component(_fImg2.default.name, _fImg2.default);
    Vue.component(_fFile2.default.name, _fFile2.default);
    Vue.component(_fButton2.default.name, _fButton2.default);
    Vue.component(_fI18n2.default.name, _fI18n2.default);
    Vue.component(_fJson2.default.name, _fJson2.default);
    Vue.component(_fHtml2.default.name, _fHtml2.default);
  }
};

exports.default = GlobalComponents;

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _loading = __webpack_require__(439);

var _loading2 = _interopRequireDefault(_loading);

var _base = __webpack_require__(9);

var _base2 = _interopRequireDefault(_base);

var _loading3 = __webpack_require__(396);

var _loading4 = _interopRequireDefault(_loading3);

var _vueClickaway = __webpack_require__(466);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GlobalDirectives = {
  install: function install(Vue) {
    Vue.use(_loading4.default.directive);
    Vue.directive('click-outside', _vueClickaway.directive);
  }
};

exports.default = GlobalDirectives;

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(22);

var _extends3 = _interopRequireDefault(_extends2);

var _DashboardLayout = __webpack_require__(470);

var _DashboardLayout2 = _interopRequireDefault(_DashboardLayout);

var _lodash = __webpack_require__(1);

var _debug = __webpack_require__(5);

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotFound = function NotFound() {
  return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 598));
};

var Overview = function Overview() {
  return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 596));
};

var Login = function Login() {
  return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 597));
};

var SchemaBaseTable = function SchemaBaseTable() {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 75));
};
var SchemaBaseForm = function SchemaBaseForm() {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 106));
};
var Member = function Member() {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 14));
};
var MemberAdmin = function MemberAdmin() {
  return __webpack_require__.e/* import() */(40).then(__webpack_require__.bind(null, 579));
};
var CreateMember = function CreateMember() {
  return __webpack_require__.e/* import() */(39).then(__webpack_require__.bind(null, 580));
};
var ImportMember = function ImportMember() {
  return __webpack_require__.e/* import() */(38).then(__webpack_require__.bind(null, 581));
};
var Caregiver = function Caregiver() {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 108));
};
var Client = function Client() {
  return __webpack_require__.e/* import() */(52).then(__webpack_require__.bind(null, 558));
};
var Subprofile = function Subprofile() {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 32));
};
var CreateSubprofile = function CreateSubprofile() {
  return __webpack_require__.e/* import() */(31).then(__webpack_require__.bind(null, 590));
};
var Group = function Group() {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 31));
};
var GroupApply = function GroupApply() {
  return __webpack_require__.e/* import() */(43).then(__webpack_require__.bind(null, 576));
};
var GroupCreate = function GroupCreate() {
  return __webpack_require__.e/* import() */(42).then(__webpack_require__.bind(null, 577));
};
var GroupApps = function GroupApps() {
  return __webpack_require__.e/* import() */(44).then(__webpack_require__.bind(null, 575));
};
var GroupAppMember = function GroupAppMember() {
  return __webpack_require__.e/* import() */(45).then(__webpack_require__.bind(null, 574));
};
var Order = function Order() {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 39));
};
var CreateOrder = function CreateOrder() {
  return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 587));
};
var Transaction = function Transaction() {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 40));
};
var StandaloneTransaction = function StandaloneTransaction() {
  return __webpack_require__.e/* import() */(30).then(__webpack_require__.bind(null, 591));
};
var Payment = function Payment() {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 110));
};
var Product = function Product() {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 58));
};
var CreateProduct = function CreateProduct() {
  return __webpack_require__.e/* import() */(33).then(__webpack_require__.bind(null, 588));
};
var Service = function Service() {
  return __webpack_require__.e/* import() */(32).then(__webpack_require__.bind(null, 589));
};
var Coupon = function Coupon() {
  return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 555));
};
var CreateCoupon = function CreateCoupon() {
  return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 568));
};
var Appointment = function Appointment() {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 26));
};
var CreateAppointment = function CreateAppointment() {
  return __webpack_require__.e/* import() */(53).then(__webpack_require__.bind(null, 557));
};
var FeedbackAdminToCaregiver = function FeedbackAdminToCaregiver() {
  return __webpack_require__.e/* import() */(48).then(__webpack_require__.bind(null, 571));
};
var FeedbackAdminToClient = function FeedbackAdminToClient() {
  return __webpack_require__.e/* import() */(47).then(__webpack_require__.bind(null, 572));
};
var CreateFeedbackAdmin = function CreateFeedbackAdmin() {
  return __webpack_require__.e/* import() */(49).then(__webpack_require__.bind(null, 570));
};
var FeedbackCaregiver = function FeedbackCaregiver() {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 109));
};
var FeedbackClient = function FeedbackClient() {
  return __webpack_require__.e/* import() */(46).then(__webpack_require__.bind(null, 573));
};
var Content = function Content() {
  return __webpack_require__.e/* import() */(51).then(__webpack_require__.bind(null, 543));
};
var ContentAny = function ContentAny() {
  return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, 547));
};
var CreateContent = function CreateContent() {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 565));
};
var Enquiry = function Enquiry() {
  return __webpack_require__.e/* import() */(50).then(__webpack_require__.bind(null, 546));
};
var EnquiryQuestionnaire = function EnquiryQuestionnaire() {
  return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 556));
};
var EnquiryQuestionnaire1 = function EnquiryQuestionnaire1() {
  return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 569));
};
var ContentJoinusInputform = function ContentJoinusInputform() {
  return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 549));
};

var ContentJoinusBannertop = function ContentJoinusBannertop() {
  return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 548));
};
var ContentOurservicespageWhyusfeatures = function ContentOurservicespageWhyusfeatures() {
  return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 551));
};

var ContentOurservicespageDownloadtop = function ContentOurservicespageDownloadtop() {
  return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 550));
};
var ContentOurservicespageWhyusmiddle = function ContentOurservicespageWhyusmiddle() {
  return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 552));
};
var ContentOurservicespageOurservicesdetails = function ContentOurservicespageOurservicesdetails() {
  return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 566));
};

var ContentAboutusPlaintext = function ContentAboutusPlaintext() {
  return __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, 561));
};
var ContentAboutusBridge = function ContentAboutusBridge() {
  return __webpack_require__.e/* import() */(29).then(__webpack_require__.bind(null, 559));
};
var ContentAboutusMiddle = function ContentAboutusMiddle() {
  return __webpack_require__.e/* import() */(28).then(__webpack_require__.bind(null, 560));
};
var ContentAboutusTri = function ContentAboutusTri() {
  return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, 562));
};
var ContentContentFaq = function ContentContentFaq() {
  return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 564));
};
var ContentRecruitment = function ContentRecruitment() {
  return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 554));
};
var ContentCategory = function ContentCategory() {
  return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, 563));
};
var ContentPost = function ContentPost() {
  return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 553));
};
var CreateContentPost = function CreateContentPost() {
  return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 567));
};

var Notification = function Notification() {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 100));
};
var SystemNotification = function SystemNotification() {
  return __webpack_require__.e/* import() */(34).then(__webpack_require__.bind(null, 586));
};
var AdminSendouts = function AdminSendouts() {
  return __webpack_require__.e/* import() */(36).then(__webpack_require__.bind(null, 584));
};
var Emails = function Emails() {
  return __webpack_require__.e/* import() */(37).then(__webpack_require__.bind(null, 582));
};
var CreateSystemNotification = function CreateSystemNotification() {
  return __webpack_require__.e/* import() */(35).then(__webpack_require__.bind(null, 585));
};
var CreateMemberNotification = function CreateMemberNotification() {
  return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 583));
};
var Systemconfig = function Systemconfig() {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 101));
};
var Log = function Log() {
  return __webpack_require__.e/* import() */(41).then(__webpack_require__.bind(null, 578));
};

var parseFilter = function parseFilter(q) {
  var obj = {};
  for (var key in q) {
    try {
      (0, _lodash.set)(obj, key, JSON.parse(q[key]));
    } catch (e) {
      (0, _lodash.set)(obj, key, q[key]);
    }
  }
  return obj.filter;
};

var adminMenu = {
  path: '/admin',
  component: _DashboardLayout2.default,
  meta: { auth: true },
  children: [{
    path: 'members',
    name: 'schema.members',
    component: SchemaBaseTable,
    props: function props(r) {
      return { schema: Member, initialFilter: parseFilter(r.query) };
    }
  }, {
    path: 'members/create',
    name: ['create_schema_$name', { name: '${i18n.schema.member}' }],
    component: SchemaBaseForm,
    props: { schema: CreateMember }
  }, {
    path: 'members/import',
    name: 'Import ${i18n.schema.members}',
    component: SchemaBaseForm,
    props: { schema: ImportMember }
  }, {
    path: 'admins',
    name: 'schema.admins',
    component: SchemaBaseTable,
    props: function props(r) {
      return { schema: MemberAdmin, initialFilter: parseFilter(r.query) };
    }
  }, {
    path: 'caregivers',
    name: 'schema.caregivers',
    component: SchemaBaseTable,
    props: function props(r) {
      return { schema: Caregiver, initialFilter: parseFilter(r.query) };
    }
  }, {
    path: 'clients',
    name: 'schema.clients',
    component: SchemaBaseTable,
    props: function props(r) {
      return { schema: Client, initialFilter: parseFilter(r.query) };
    }
  }, {
    path: 'members/:id',
    name: ['schema_$name_details', { name: '${i18n.schema.member}' }],
    component: SchemaBaseForm,
    props: function props(r) {
      return { schema: Member, id: r.params.id };
    }
  }, {
    path: 'subprofiles',
    name: 'schema.subprofiles',
    component: SchemaBaseTable,
    props: function props(r) {
      return { schema: Subprofile };
    }
  }, {
    path: 'subprofiles/create',
    name: ['create_schema_$name', { name: '${i18n.schema.subprofile}' }],
    component: SchemaBaseForm,
    props: { schema: CreateSubprofile }
  }, {
    path: 'subprofiles/:id',
    name: ['schema_$name_details', { name: '${i18n.schema.subprofiles}' }],
    component: SchemaBaseForm,
    props: function props(r) {
      return { schema: Subprofile, id: r.params.id };
    }
  }, {
    path: 'groups',
    name: 'schema.groups',
    component: SchemaBaseTable,
    props: function props(r) {
      return { schema: Group, initialFilter: parseFilter(r.query) };
    }
  }, {
    path: 'groups/apply',
    name: 'schema.group_apply',
    component: SchemaBaseForm,
    props: { schema: GroupApply }
  }, {
    path: 'groups/create',
    name: ['create_schema_$name', { name: '${i18n.schema.group}' }],
    component: SchemaBaseForm,
    props: { schema: GroupCreate }
  }, {
    path: 'groups/:id',
    name: ['schema_$name_details', { name: '${i18n.schema.groups}' }],
    component: SchemaBaseForm,
    props: function props(r) {
      return { schema: Group, id: r.params.id };
    }
  }, {
    path: 'group-applications',
    name: 'schema.group_applications',
    component: SchemaBaseTable,
    props: function props(r) {
      return { schema: GroupApps, initialFilter: parseFilter(r.query) };
    }
  }, {
    path: 'group-applications/:id/',
    name: ['schema_$name_details', { name: '${i18n.schema.group_application}' }],
    component: SchemaBaseForm,
    props: function props(r) {
      return { schema: GroupAppMember, id: r.params.id };
    }
  }, {
    path: 'appointments',
    name: 'schema.appointments',
    component: SchemaBaseTable,
    props: function props(r) {
      return { schema: Appointment, initialFilter: parseFilter(r.query) };
    }
  }, {
    path: 'appointments/create',
    name: ['create_schema_$name', { name: '${i18n.schema.appointment}' }],
    component: SchemaBaseForm,
    props: function props(r) {
      return { schema: CreateAppointment, id: r.params.id };
    }
  }, {
    path: 'appointments/:id',
    name: ['schema_$name_details', { name: '${i18n.schema.appointment}' }],
    component: SchemaBaseForm,
    props: function props(r) {
      return { schema: Appointment, id: r.params.id };
    }
  }, {
    path: 'orders',
    name: 'schema.orders',
    component: SchemaBaseTable,
    props: function props(r) {
      return { schema: Order, initialFilter: parseFilter(r.query) };
    }
  }, {
    path: 'orders/create',
    name: ['create_schema_$name', { name: '${i18n.schema.order}' }],
    component: SchemaBaseForm,
    props: { schema: CreateOrder }
  }, {
    path: 'orders/:id',
    name: ['schema_$name_details', { name: '${i18n.schema.order}' }],
    component: SchemaBaseForm,
    props: function props(r) {
      return { schema: Order, id: r.params.id };
    }
  }, {
    path: 'transactions',
    name: 'schema.transactions',
    component: SchemaBaseTable,
    props: function props(r) {
      return { schema: Transaction, initialFilter: parseFilter(r.query) };
    }
  }, {
    path: 'transactions/standalone',
    name: ['create_schema_$name', { name: '${i18n.schema.standalone_transaction}' }],
    component: SchemaBaseForm,
    props: { schema: StandaloneTransaction }
  }, {
    path: 'transactions/:id',
    name: ['schema_$name_details', { name: '${i18n.schema.transaction}' }],
    component: SchemaBaseForm,
    props: function props(r) {
      return { schema: Transaction, id: r.params.id };
    }
  }, {
    path: 'payments',
    name: 'schema.payments',
    component: SchemaBaseTable,
    props: function props(r) {
      return { schema: Payment, initialFilter: parseFilter(r.query) };
    }
  }, {
    path: 'payments/:id',
    name: ['schema_$name_details', { name: '${i18n.schema.payment}' }],
    component: SchemaBaseForm,
    props: function props(r) {
      return { schema: Payment, id: r.params.id };
    }
  }, {
    path: 'products',
    name: 'schema.products',
    component: SchemaBaseTable,
    props: function props(r) {
      return { schema: Product, initialFilter: parseFilter(r.query) };
    }
  }, {
    path: 'products/create',
    name: ['create_schema_$name', { name: '${i18n.schema.product}' }],
    component: SchemaBaseForm,
    props: function props(r) {
      return { schema: CreateProduct, id: r.params.id };
    }
  }, {
    path: 'products/:id',
    name: ['schema_$name_details', { name: '${i18n.schema.product}' }],
    component: SchemaBaseForm,
    props: function props(r) {
      return { schema: Product, id: r.params.id };
    }
  }, {
    path: 'services',
    name: 'schema.services',
    component: SchemaBaseTable,
    props: function props(r) {
      return { schema: Service, initialFilter: parseFilter(r.query) };
    }
  }, {
    path: 'services/:id',
    name: ['schema_$name_details', { name: '${i18n.schema.service}' }],
    component: SchemaBaseForm,
    props: function props(r) {
      return { schema: Service, id: r.params.id };
    }
  }, {
    path: 'coupons',
    name: 'schema.coupons',
    component: SchemaBaseTable,
    props: function props(r) {
      return { schema: Coupon, initialFilter: parseFilter(r.query) };
    }
  }, {
    path: 'coupons/create',
    name: ['create_schema_$name', { name: '${i18n.schema.coupon}' }],
    component: SchemaBaseForm,
    props: function props(r) {
      return { schema: CreateCoupon, id: r.params.id };
    }
  }, {
    path: 'coupons/:id',
    name: ['schema_$name_details', { name: '${i18n.schema.coupon}' }],
    component: SchemaBaseForm,
    props: function props(r) {
      return { schema: Coupon, id: r.params.id };
    }
  }, {
    path: 'feedback-admin/create',
    name: ['create_schema_$name', { name: '${i18n.schema.feedback_admin}' }],
    component: SchemaBaseForm,
    props: { schema: CreateFeedbackAdmin }
  }, {
    path: 'feedback-admin/:id',
    name: ['schema_$name_details', { name: '${i18n.schema.feedback_admin}' }],
    component: SchemaBaseForm,
    props: function props(r) {
      return { schema: FeedbackAdminToClient, id: r.params.id, readonly: true };
    }
  }, {
    path: 'feedback-admin-client',
    name: 'schema.feedbacks_admin',
    component: SchemaBaseTable,
    props: function props(r) {
      return { schema: FeedbackAdminToClient, initialFilter: parseFilter(r.query) };
    }
  }, {
    path: 'feedback-admin-caregiver',
    name: 'schema.feedbacks_admin',
    component: SchemaBaseTable,
    props: function props(r) {
      return { schema: FeedbackAdminToCaregiver, initialFilter: parseFilter(r.query) };
    }
  }, {
    path: 'feedback-caregiver',
    name: 'schema.feedbacks_caregiver',
    component: SchemaBaseTable,
    props: function props(r) {
      return { schema: FeedbackCaregiver, initialFilter: parseFilter(r.query) };
    }
  }, {
    path: 'feedback-caregiver/:id',
    name: ['schema_$name_details', { name: '${i18n.schema.feedback_caregiver}' }],
    component: SchemaBaseForm,
    props: function props(r) {
      return { schema: FeedbackCaregiver, id: r.params.id, readonly: true };
    }
  }, {
    path: 'feedback-client',
    name: 'schema.feedbacks_client',
    component: SchemaBaseTable,
    props: function props(r) {
      return { schema: FeedbackClient, initialFilter: parseFilter(r.query) };
    }
  }, {
    path: 'feedback-client/:id',
    name: ['schema_$name_details', { name: '${i18n.schema.feedback_client}' }],
    component: SchemaBaseForm,
    props: function props(r) {
      return { schema: FeedbackClient, id: r.params.id, readonly: true };
    }
  }, {
    path: 'notifications',
    name: 'schema.notifications',
    component: SchemaBaseTable,
    props: function props(r) {
      return { schema: Notification, initialFilter: parseFilter(r.query) };
    }
  }, {
    path: 'notifications/:id',
    name: ['schema_$name_details', { name: '${i18n.schema.notification}' }],
    component: SchemaBaseForm,
    props: function props(r) {
      return { schema: Notification, id: r.params.id, readonly: true };
    }
  }, {
    path: 'systemnotifications',
    name: 'schema.systemnotifications',
    component: SchemaBaseTable,
    props: function props(r) {
      return { schema: SystemNotification, initialFilter: parseFilter(r.query) };
    }
  }, {
    path: 'systemnotifications/create',
    name: ['create_schema_$name', { name: '${i18n.schema.systemnotification}' }],
    component: SchemaBaseForm,
    props: { schema: CreateSystemNotification }
  }, {
    path: 'systemnotifications/:id',
    name: ['schema_$name_details', { name: '${i18n.schema.systemnotification}' }],
    component: SchemaBaseForm,
    props: function props(r) {
      return { schema: SystemNotification, id: r.params.id };
    }
  }, {
    path: 'sendouts',
    name: 'schema.adminsendouts',
    component: SchemaBaseTable,
    props: function props(r) {
      return { schema: AdminSendouts, initialFilter: parseFilter(r.query) };
    }
  }, {
    path: 'sendouts/create',
    name: 'schema.adminsendout',
    component: SchemaBaseForm,
    props: { schema: CreateMemberNotification }
  }, {
    path: 'sendouts/:id',
    name: ['schema_$name_details', { name: '${i18n.schema.adminsendout}' }],
    component: SchemaBaseForm,
    props: function props(r) {
      return { schema: AdminSendouts, id: r.params.id, readonly: true };
    }
  }, {
    path: 'emails',
    name: 'schema.emails',
    component: SchemaBaseTable,
    props: function props(r) {
      return { schema: Emails, initialFilter: parseFilter(r.query) };
    }
  }, {
    path: 'emails/:id',
    name: ['schema_$name_details', { name: '${i18n.schema.email}' }],
    component: SchemaBaseForm,
    props: function props(r) {
      return { schema: Emails, id: r.params.id, readonly: true };
    }
  }, {
    path: 'logs',
    name: 'schema.logs',
    component: SchemaBaseTable,
    props: function props(r) {
      return { schema: Log, initialFilter: parseFilter(r.query) };
    }
  }, {
    path: 'logs/:id',
    name: ['schema_$name_details', { name: '${i18n.schema.log}' }],
    component: SchemaBaseForm,
    props: function props(r) {
      return { schema: Log, id: r.params.id };
    }
  }, {
    path: 'contents',
    name: 'schema.contents',
    component: SchemaBaseTable,
    props: function props(r) {
      return {
        schema: Content,
        initialFilter: (0, _extends3.default)({}, parseFilter(r.query), _debug2.default.DEBUG ? {} : { editable: true })
      };
    }
  }, {
    path: 'posts',
    name: 'schema.posts',
    component: SchemaBaseTable,
    props: function props(r) {
      return { schema: ContentPost, initialFilter: parseFilter(r.query) };
    }
  }, {
    path: 'posts/create',
    name: ['create_schema_$name', { name: '${i18n.schema.post}' }],
    component: SchemaBaseForm,
    props: { schema: CreateContentPost }
  }, {
    path: 'contents/create',
    name: ['create_schema_$name', { name: '${i18n.schema.content}' }],
    component: SchemaBaseForm,
    props: { schema: CreateContent }
  }, {
    path: 'posts/:id',
    name: ['schema_$name_details', { name: '${i18n.schema.post}' }],
    component: SchemaBaseForm,
    props: function props(r) {
      return { schema: ContentPost, id: r.params.id };
    }
  }, {
    path: 'contents/input_form-joinus/:id',
    name: ['schema_$name_details', { name: '${i18n.schema["content-joinus-input_form"]}' }],
    component: SchemaBaseForm,
    props: function props(r) {
      return { schema: ContentJoinusInputform, id: r.params.id };
    }
  }, {
    path: 'contents/content-faq/:id',
    name: ['schema_$name_details', { name: '${i18n.schema["content-content-faq"]}' }],
    component: SchemaBaseForm,
    props: function props(r) {
      return { schema: ContentContentFaq, id: r.params.id };
    }
  }, {
    path: 'contents/banner_top-joinus/:id',
    name: ['schema_$name_details', { name: '${i18n.schema["content-joinus-banner_top"]}' }],
    component: SchemaBaseForm,
    props: function props(r) {
      return { schema: ContentJoinusBannertop, id: r.params.id };
    }
  }, {
    path: 'contents/our_services_page-whyus_features/:id',
    name: ['schema_$name_details', { name: '${i18n.schema["content-our_services_page-whyus_features"]}' }],
    component: SchemaBaseForm,
    props: function props(r) {
      return { schema: ContentOurservicespageWhyusfeatures, id: r.params.id };
    }
  }, {
    path: 'contents/download_top-our_services_page/:id',
    name: ['schema_$name_details', { name: '${i18n.schema["content-our_services_page-download_top"]}' }],
    component: SchemaBaseForm,
    props: function props(r) {
      return { schema: ContentOurservicespageDownloadtop, id: r.params.id };
    }
  }, {
    path: 'contents/our_services_page-whyus_middle/:id',
    name: ['schema_$name_details', { name: '${i18n.schema["content-our_services_page-whyus_middle"]}' }],
    component: SchemaBaseForm,
    props: function props(r) {
      return { schema: ContentOurservicespageWhyusmiddle, id: r.params.id };
    }
  }, {
    path: 'contents/our_services_details-our_services_page/:id',
    name: ['schema_$name_details', { name: '${i18n.schema["content-our_services_page-our_services_details"]}' }],
    component: SchemaBaseForm,
    props: function props(r) {
      return { schema: ContentOurservicespageOurservicesdetails, id: r.params.id };
    }
  }, {
    path: 'contents/aboutus-bridge/:id',
    name: ['schema_$name_details', { name: '${i18n.schema["content-aboutus-bridge"]}' }],
    component: SchemaBaseForm,
    props: function props(r) {
      return { schema: ContentAboutusBridge, id: r.params.id };
    }
  }, {
    path: 'contents/aboutus-middle/:id',
    name: ['schema_$name_details', { name: '${i18n.schema["content-aboutus-middle"]}' }],
    component: SchemaBaseForm,
    props: function props(r) {
      return { schema: ContentAboutusMiddle, id: r.params.id };
    }
  }, {
    path: 'contents/aboutus-plain_text/:id',
    name: ['schema_$name_details', { name: '${i18n.schema["content-aboutus-plain_text"]}' }],
    component: SchemaBaseForm,
    props: function props(r) {
      return { schema: ContentAboutusPlaintext, id: r.params.id };
    }
  }, {
    path: 'contents/aboutus-tri/:id',
    name: ['schema_$name_details', { name: '${i18n.schema["content-aboutus-tri"]}' }],
    component: SchemaBaseForm,
    props: function props(r) {
      return { schema: ContentAboutusTri, id: r.params.id };
    }
  }, {
    path: 'contents/recruitment/:id',
    name: ['schema_$name_details', { name: '${i18n.schema["content-recruitment"]}' }],
    component: SchemaBaseForm,
    props: function props(r) {
      return { schema: ContentRecruitment, id: r.params.id };
    }
  }, {
    path: 'contents/:tags/:id',
    name: ['schema_$name_details', { name: '${i18n.schema.content}' }],
    component: SchemaBaseForm,
    props: function props(r) {
      return { schema: ContentAny, id: r.params.id };
    }
  }, {
    path: 'enquiries',
    name: 'schema.enquiries',
    component: SchemaBaseTable,
    props: function props(r) {
      return { schema: Enquiry, initialFilter: parseFilter(r.query) };
    }
  }, {
    path: 'enquiry_questionnaires',
    name: 'schema.enquiry_questionnaires',
    component: SchemaBaseTable,
    props: function props(r) {
      return { schema: EnquiryQuestionnaire, initialFilter: parseFilter(r.query) };
    }
  }, {
    path: 'enquiry_questionnaires1',
    name: 'schema.enquiry_questionnaires',
    component: SchemaBaseTable,
    props: function props(r) {
      return { schema: EnquiryQuestionnaire1, initialFilter: parseFilter(r.query) };
    }
  }, {
    path: 'enquiries/questionnaire/:id',
    name: ['schema_$name_details', { name: '${i18n.schema.enquiry_questionnaire}' }],
    component: SchemaBaseForm,
    props: function props(r) {
      return { schema: EnquiryQuestionnaire, id: r.params.id, readonly: true };
    }
  }, {
    path: 'enquiries/:id',
    name: ['schema_$name_details', { name: '${i18n.schema.enquiry}' }],
    component: SchemaBaseForm,
    props: function props(r) {
      return { schema: Enquiry, id: r.params.id, readonly: true };
    }
  }, {
    path: 'systemconfigs',
    name: 'schema.systemconfigs',
    component: SchemaBaseTable,
    props: function props(r) {
      return { schema: Systemconfig, initialFilter: parseFilter(r.query) };
    }
  }, {
    path: 'systemconfigs/:id',
    name: ['schema_$name_details', { name: '${i18n.schema.systemconfig}' }],
    component: SchemaBaseForm,
    props: function props(r) {
      return { schema: Systemconfig, id: r.params.id };
    }
  }]
};

var loginPage = {
  path: '/login',
  name: 'Login',
  component: Login
};

var routes = [{
  path: '/',
  name: 'menu.overview',

  redirect: '/admin/overview'
}, adminMenu, loginPage, {
  path: '/admin',
  component: _DashboardLayout2.default,
  meta: { auth: true },
  redirect: '/admin/overview',
  children: [{
    path: 'overview',
    name: 'menu.overview',
    component: Overview
  }]
}, {
  path: '/logout',
  name: 'Logout',
  component: {
    template: '<div></div>',
    mounted: function mounted() {
      var _this = this;

      this.$auth = null;
      this.$nextTick(function () {
        _this.$router.replace('/');
      });
    }
  }
}, { path: '*', component: NotFound }];

exports.default = routes;

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var ecommerce = [{
    name: _i18n2.default.s('schema.orders'),
    path: '/admin/orders'
  }, {
    name: _i18n2.default.s('schema.products'),
    path: '/admin/products'
  }, {
    name: _i18n2.default.s('schema.coupons'),
    path: '/admin/coupons'
  }];
  if ((0, _lodash.get)(this, '$auth.role') === 'superadmin') {
    ecommerce.splice(1, 0, {
      name: _i18n2.default.s('schema.transactions'),
      path: '/admin/transactions'
    }, {
      name: _i18n2.default.s('schema.payments'),
      path: '/admin/payments'
    });
  }
  var members = [{
    name: _i18n2.default.s('schema.members'),
    path: '/admin/members'
  }, {
    name: _i18n2.default.s('schema.caregivers'),
    path: '/admin/caregivers'
  }, {
    name: _i18n2.default.s('schema.clients'),
    path: '/admin/clients'
  }, {
    name: _i18n2.default.s('schema.subprofiles'),
    path: '/admin/subprofiles'
  }];
  if (_debug2.default.DEBUG && (0, _lodash.get)(this, '$auth.role') === 'superadmin') {
    members.push({
      name: _i18n2.default.fr('action.import_members'),
      path: '/admin/members/import'
    });
  }
  var links = [{
    name: _i18n2.default.s('menu.overview'),

    path: '/admin/overview'
  }, {
    name: _i18n2.default.s('menu.members'),

    collapsed: true,
    children: members
  }, {
    name: _i18n2.default.s('menu.appointments'),
    path: '/admin/appointments'
  }, {
    name: _i18n2.default.s('menu.ecommerce'),

    collapsed: true,
    children: ecommerce
  }, {
    name: _i18n2.default.s('menu.admin'),

    path: '/admin/admins'
  }, {
    name: _i18n2.default.s('menu.feedbacks'),

    collapsed: true,
    children: [{
      name: _i18n2.default.fr('schema.feedbacks_admin_caregiver'),
      path: '/admin/feedback-admin-caregiver'
    }, {
      name: _i18n2.default.fr('schema.feedbacks_admin_client'),
      path: '/admin/feedback-admin-client'
    }, {
      name: _i18n2.default.fr('schema.feedbacks_caregiver'),
      path: '/admin/feedback-caregiver'
    }, {
      name: _i18n2.default.fr('schema.feedbacks_client'),
      path: '/admin/feedback-client'
    }]
  }, {
    name: _i18n2.default.s('schema.services'),

    collapsed: true,
    path: '/admin/services'
  }, {
    name: _i18n2.default.s('schema.groups'),

    collapsed: true,
    children: [{
      name: _i18n2.default.s('schema.groups'),
      path: '/admin/groups'
    }, {
      name: _i18n2.default.s('schema.group_applications'),
      path: '/admin/group-applications'
    }]
  }, {
    name: _i18n2.default.s('schema.contents'),

    collapsed: true,
    children: [{
      name: _i18n2.default.s('schema.content'),
      path: '/admin/contents'
    }, {
      name: _i18n2.default.s('schema.posts'),
      path: '/admin/posts',
      hide: !_debug2.default.DEBUG }]
  }, {
    name: _i18n2.default.s('menu.notifications'),

    collapsed: true,
    children: [{
      name: _i18n2.default.s('menu.notifications'),
      path: '/admin/notifications'
    }, {
      name: _i18n2.default.s('schema.systemnotifications'),
      path: '/admin/systemnotifications'
    }, {
      name: _i18n2.default.s('schema.adminsendouts'),
      path: '/admin/sendouts'
    }, {
      name: _i18n2.default.s('schema.emails'),
      path: '/admin/emails'
    }]
  }, {
    name: _i18n2.default.s('menu.systemconfigs'),

    collapsed: true,
    path: '/admin/systemconfigs'
  }, {
    name: _i18n2.default.s('schema.logs'),
    path: '/admin/logs'
  }, {
    name: _i18n2.default.s('action.logout'),

    path: '/logout'
  }];

  return links;
};

var _debug = __webpack_require__(5);

var _debug2 = _interopRequireDefault(_debug);

var _i18n = __webpack_require__(2);

var _i18n2 = _interopRequireDefault(_i18n);

var _lodash = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 267 */,
/* 268 */,
/* 269 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 270 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 271 */,
/* 272 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(454)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(287),
  /* template */
  __webpack_require__(523),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(16);

var _keys2 = _interopRequireDefault(_keys);

exports.default = function () {
  return {
    notification_id: { type: 'id', required: true, cat: GN },
    status: { type: 'select', items: ['status.active', 'status.inactive'], default: 'active' },
    created_at: { type: 'datetime', readonly: true, cat: GN },
    read: { type: Boolean, default: false, cat: GN },

    sender: { type: 'schema', external: true, schema: Member },
    recipient: { type: 'schema', external: true, schema: Member },

    content_type: {
      type: 'select',
      items: (0, _lodash.map)((0, _keys2.default)(_index2.default.s('fields.content_types')), function (x) {
        return 'fields.content_types.' + x;
      })
    },
    type: {
      label: 'fields.sub_type', type: 'string', hidden: !_debug2.default.DEBUG, list: !!_debug2.default.DEBUG
    },
    'details.title': { cat: GN, type: 'i18n', itemType: { type: 'label' }, list: false },
    'details.content': { cat: GN, type: 'i18n', itemType: { type: 'label' }, list: false },

    ref: {
      cat: GN,
      hidden: !_debug2.default.DEBUG,
      type: 'schema', schema: (0, _utils.inlineSchema)({
        member: { type: 'schema', external: true, schema: Member },
        appointment: { type: 'schema', external: true, schema: Appointment },
        order: { type: 'schema', external: true, schema: Order },
        transaction: { type: 'schema', external: true, schema: Transaction },
        product: { type: 'schema', external: true, schema: Product }
      })
    }
  };
};

var _lodash = __webpack_require__(1);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _utils = __webpack_require__(3);

var _index = __webpack_require__(2);

var _index2 = _interopRequireDefault(_index);

var _membership = __webpack_require__(14);

var Member = _interopRequireWildcard(_membership);

var _appointment = __webpack_require__(26);

var Appointment = _interopRequireWildcard(_appointment);

var _order = __webpack_require__(39);

var Order = _interopRequireWildcard(_order);

var _transaction = __webpack_require__(40);

var Transaction = _interopRequireWildcard(_transaction);

var _product = __webpack_require__(58);

var Product = _interopRequireWildcard(_product);

var _debug = __webpack_require__(5);

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GN = 'fields.cat.general';

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = __webpack_require__(30);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _promise = __webpack_require__(7);

var _promise2 = _interopRequireDefault(_promise);

var _keys = __webpack_require__(16);

var _keys2 = _interopRequireDefault(_keys);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['', ' (', ')'], ['', ' (', ')']);

exports.default = function (member) {
  var GE = 'fields.cat.general';
  var CL = 'fields.cat.client';
  var CG = 'fields.cat.caregiver';

  return {
    member_id: { type: 'id', required: true, cat: [GE, CL, CG] },
    created_at: { type: 'datetime', readonly: true, cat: [GE, CL, CG], list: 4 },
    status: {
      type: 'select',
      items: ['status.active', 'status.inactive'],
      cat: [GE, CL, CG],
      list: 5
    },
    tags: { type: 'tags', unique: true },
    role: {
      type: 'select',
      items: (0, _lodash.map)((0, _keys2.default)(_i18n2.default.s('fields.roles')), function (x) {
        return 'fields.roles.' + x;
      }),
      readonly: true
    },

    'details.profile': {
      cat: [GE, CL, CG],
      type: 'schema', expand: true, schema: (0, _utils.inlineSchema)({
        first_name: { type: 'string' },
        last_name: { type: 'string' },
        other_name: { type: 'string' },
        gender: { type: 'select', items: ['gender.m', 'gender.f'] },
        birthday: { type: 'date' },
        profile_pic: { type: 'img' },

        not_available_days: {
          readonly: true,
          type: 'array', itemType: {
            type: 'schema', schema: (0, _lodash.merge)((0, _utils.inlineSchema)({
              startTime: { type: 'date' },
              endTime: { type: 'date' }
            }), {
              title: function title(model) {
                var start = (0, _moment2.default)(model.startTime).startOf('day');
                var end = (0, _moment2.default)(model.endTime).startOf('day');
                if (start.isSame(end)) {
                  return start.format('YYYY/MM/DD');
                } else {
                  return start.format('YYYY/MM/DD') + ' - ' + end.format('YYYY/MM/DD');
                }
              }
            })
          }
        }
      })
    },
    details: {
      cat: [CG],
      type: 'schema', schema: (0, _utils.inlineSchema)({
        notes: { type: 'text' },
        address: { type: 'string', hidden: !_debug2.default.DEBUG },
        hkid: { type: 'string', hidden: !_debug2.default.DEBUG },
        marriage_status: { type: 'string', hidden: !_debug2.default.DEBUG },
        bank_account: { type: 'string', hidden: !_debug2.default.DEBUG },
        bank_type: { type: 'string', hidden: !_debug2.default.DEBUG },
        referral: { type: 'string', hidden: !_debug2.default.DEBUG },
        signed_contract: { type: 'checkbox', hidden: !_debug2.default.DEBUG },
        working_visa: { type: 'checkbox', hidden: !_debug2.default.DEBUG },
        years_of_experience: { type: 'number', min: 0 },
        working_experience: { type: 'text' },
        working_history: {
          type: 'array', add: true, delete: true, hidden: !_debug2.default.DEBUG,
          itemType: {
            type: 'schema', schema: (0, _lodash.merge)((0, _utils.inlineSchema)({
              title: { type: 'string' },
              company: { type: 'string' },
              startDate: { type: 'date' },
              endDate: { type: 'date' },
              fulltime: { type: 'checkbox' }
            }), {
              title: function title(model) {
                return model ? model.title : '';
              }
            })
          }
        },
        certificates: {
          type: 'array', add: true, delete: true, hidden: !_debug2.default.DEBUG,
          itemType: {
            type: 'schema', schema: (0, _lodash.merge)((0, _utils.inlineSchema)({
              name: { type: 'string' },
              issuer: { type: 'string' },
              startDate: { type: 'date' },
              endDate: { type: 'date' }
            }), {
              title: function title(model) {
                return model ? model.name : '';
              }
            })
          }
        }
      })
    },

    'verification.email.value': {
      cat: [GE, CL, CG],
      type: 'string',
      label: 'fields.email',
      list: 1
    },
    'verification.phone.value': {
      cat: [GE, CL, CG],
      type: 'phone',
      label: 'fields.phone',
      list: 2
    },
    'details.profile.gender': { type: 'select', items: ['gender.m', 'gender.f'], hidden: true, list: 3 },

    basicInfo_fulfilled: { type: Boolean, default: false, list: false },
    email_fulfilled: { type: Boolean, default: false, list: false },

    groups: {
      cat: [CG],
      type: 'array', itemType: {
        type: 'schema', schema: (0, _lodash.merge)((0, _utils.inlineSchema)(function (model) {
          return {
            group: { type: 'schema', schema: Group, external: true, readonly: true },
            self_status: {
              readonly: true,
              type: 'select',
              items: ['status.pending', 'status.approved', 'status.rejected']
            },
            updated_at: { type: 'datetime', readonly: true },
            created_at: { type: 'datetime', readonly: true },
            refs: {
              type: 'schema', readonly: true, schema: (0, _utils.inlineSchema)({
                photo: { type: 'img', multi: true, readonly: true },
                reason: { type: 'string' }
              })
            },
            action: {
              type: 'button',
              actions: [{
                label: 'action.approve',
                class: 'btn-success',
                hidden: model && ['pending', 'rejected'].indexOf(model.self_status) < 0,
                action: function action(model, spec, readonly) {
                  var _this = this;

                  var gid = (0, _lodash.get)(model, 'group.group_id');
                  var mid = member.member_id;
                  return this.$http.post('', {
                    endpoint: 'replyGroupApplications',
                    member_id: mid,
                    group_ids: [gid],
                    approval_status: 'approved'
                  }).then(function (response) {
                    if (!response.body) {
                      throw new Error(_i18n2.default.f('alert.empty_response'));
                    }
                    var result = response.body;
                    if (!result.success) {
                      console.error(response);
                      return _promise2.default.reject(result.err.hk || result.err);
                    }
                    if (_this.$notify) {
                      _this.$notify({
                        component: {
                          template: _i18n2.default.f('alert.html.record_updated_successfully')
                        },
                        icon: 'ti-info',
                        horizontalAlign: 'center',
                        verticalAlign: 'top',
                        type: 'success'
                      });
                    }
                    return true;
                  });
                }
              }, {
                label: 'action.reject',
                action: function action(model, spec, readonly) {
                  var _this2 = this;

                  var gid = (0, _lodash.get)(model, 'group.group_id');
                  var mid = member.member_id;
                  return this.$http.post('', {
                    endpoint: 'replyGroupApplications',
                    member_id: mid,
                    group_ids: [gid],
                    approval_status: 'rejected'
                  }).then(function (response) {
                    if (!response.body) {
                      throw new Error(_i18n2.default.f('alert.empty_response'));
                    }
                    var result = response.body;
                    if (!result.success) {
                      console.error(response);
                      return _promise2.default.reject(result.err.hk || result.err);
                    }
                    if (_this2.$notify) {
                      _this2.$notify({
                        component: {
                          template: _i18n2.default.f('alert.html.record_updated_successfully')
                        },
                        icon: 'ti-info',
                        horizontalAlign: 'center',
                        verticalAlign: 'top',
                        type: 'success'
                      });
                    }
                    return true;
                  });
                }
              }, {
                label: 'action.delete',
                class: 'btn-danger',
                action: function action(model, spec, readonly) {
                  var _this3 = this;

                  var gid = (0, _lodash.get)(model, 'group.group_id');
                  var mid = member.member_id;
                  return this.$http.post('', {
                    endpoint: 'replyGroupApplications',
                    member_id: mid,
                    group_ids: [gid],
                    approval_status: 'delete'
                  }).then(function (response) {
                    if (!response.body) {
                      throw new Error(_i18n2.default.f('alert.empty_response'));
                    }
                    var result = response.body;
                    if (!result.success) {
                      console.error(response);
                      return _promise2.default.reject(result.err.hk || result.err);
                    }
                    if (_this3.$notify) {
                      _this3.$notify({
                        component: {
                          template: _i18n2.default.f('alert.html.record_updated_successfully')
                        },
                        icon: 'ti-info',
                        horizontalAlign: 'center',
                        verticalAlign: 'top',
                        type: 'success'
                      });
                    }
                    return true;
                  });
                }
              }].filter(function (x) {
                return !x.hidden;
              })
            }
          };
        }), {
          title: function title(model) {
            return model ? _i18n2.default.nn(_templateObject, Group.title.call(this, model.group), _i18n2.default.fr('status.' + model.self_status)) : '';
          }
        })
      }
    },

    finished_interview: {
      cat: [CG],
      type: 'boolean'
    },

    init_login_type: {
      type: 'select', readonly: true,
      items: ['type.login.emailPwd'],
      list: 3
    },

    'verification.phone': {
      type: 'schema', schema: (0, _lodash.merge)((0, _utils.inlineSchema)({
        updated_at: { type: 'datetime', readonly: true },
        status: { type: 'select', list: false, items: ['status.verified', 'status.not_verified'] },
        value: { type: String }
      }), {
        title: function title(model) {
          return (0, _utils2.formatPhone)((0, _lodash.get)(model, 'value'));
        }
      })
    },
    'verification.email': {
      type: 'schema', schema: (0, _lodash.merge)((0, _utils.inlineSchema)({
        updated_at: { type: 'datetime', readonly: true },
        status: { type: 'select', list: false, items: ['status.verified', 'status.not_verified'] },
        value: { type: String }
      }), {
        title: function title(model) {
          return (0, _lodash.get)(model, 'value');
        }
      })
    },

    app_config: {
      type: 'schema',
      schema: (0, _utils.inlineSchema)({
        'notification.sms': { type: 'boolean', default: true },
        'notification.email': { type: 'boolean', default: true },
        'notification.promotion': { type: 'boolean', default: true },
        language: {
          type: 'radio',
          items: (0, _keys2.default)(_i18n2.default.lang).map(function (x) {
            return { label: x.toUpperCase(), value: x };
          }),
          default: _i18n2.default.local
        },
        dev_mode: { type: 'checkbox', hidden: !_debug2.default.DEBUG },
        dev_stripe: {
          type: 'checkbox', hidden: !_debug2.default.DEBUG, readonly: function readonly() {
            return !(0, _lodash.get)(this.model, 'dev_mode');
          }
        }
      })
    },

    stat: {
      type: 'schema',
      readonly: true,
      schema: (0, _utils.inlineSchema)({
        click: { type: 'number' },
        view: { type: 'number' },
        rating: {
          type: 'schema', schema: (0, _utils.inlineSchema)({
            admin_to_caregiver_avg: { type: 'number' },
            admin_to_caregiver_max: { type: 'number' },
            admin_to_caregiver_min: { type: 'number' },
            admin_to_client_avg: { type: 'number' },
            admin_to_client_max: { type: 'number' },
            admin_to_client_min: { type: 'number' },
            client_appointment_feedback_avg: { type: 'number' },
            client_appointment_feedback_max: { type: 'number' },
            client_appointment_feedback_min: { type: 'number' },
            caregiver_appointment_feedback_avg: { type: 'number' },
            caregiver_appointment_feedback_max: { type: 'number' },
            caregiver_appointment_feedback_min: { type: 'number' }
          })
        }
      })
    },

    apply_group: {
      cat: [CG],
      type: 'link', link: {
        label: _i18n2.default.fr('action.click_to_$action', { action: '${i18n.action.apply}' }),
        to: function to(value, model, fieldSpec) {
          return model ? '/admin/groups/apply?member_id=' + model.member_id : null;
        }
      }
    },

    certificates: {
      cat: [CG],
      type: 'file',
      multi: true,
      preprocess: function preprocess(payload) {
        payload.type = 'certificate';
        return payload;
      }
    },

    add_subprofile: {
      cat: [CL],
      type: 'link', link: {
        label: _i18n2.default.fr('action.click_to_$action', { action: '${i18n.action.add}' }),
        to: function to(value, model, fieldSpec) {
          return model ? '/admin/subprofiles/create?member_id=' + model.member_id : null;
        }
      }
    },

    my_subprofiles: {
      cat: [CL],
      type: 'table', schema: Subprofile,
      initialFilter: function initialFilter(value, model) {
        return { creator_id: model.member_id };
      }
    },
    my_appointments: {
      cat: [CL],
      type: 'table', schema: MyAppointment,
      initialFilter: function initialFilter(value, model) {
        return { member_id: model.member_id, caregiver: model && model.groups.length };
      }
    },
    my_jobs: {
      cat: [CG],
      type: 'table', schema: MyAppointment,
      initialFilter: function initialFilter(value, model) {
        return { member_id: model.member_id, caregiver: model && model.groups.length };
      }
    },
    my_orders: {
      cat: [CL],
      type: 'table', schema: MyOrder,
      initialFilter: function initialFilter(value, model) {
        return { member_id: model.member_id };
      }
    },

    reset_password: {
      type: 'schema', schema: (0, _utils.inlineSchema)({
        new_password: { type: 'string', inputType: 'password' },
        confirm_password: {
          type: 'string', inputType: 'password', validator: function validator(v) {
            var a = (0, _lodash.get)(member, 'reset_password.new_password');
            return a == null || v === a ? null : 'Password mismatch';
          }
        }
      })
    },

    _tokens: {
      type: 'array', readonly: true,
      hidden: !_debug2.default.DEBUG,
      itemType: { type: 'json' }
    }

  };
};

var _lodash = __webpack_require__(1);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _utils = __webpack_require__(3);

var _i18n = __webpack_require__(2);

var _i18n2 = _interopRequireDefault(_i18n);

var _subprofile = __webpack_require__(32);

var Subprofile = _interopRequireWildcard(_subprofile);

var _profile = __webpack_require__(44);

var Profile = _interopRequireWildcard(_profile);

var _group = __webpack_require__(31);

var Group = _interopRequireWildcard(_group);

var _appointmentAs = __webpack_require__(329);

var MyAppointment = _interopRequireWildcard(_appointmentAs);

var _orderAs = __webpack_require__(333);

var MyOrder = _interopRequireWildcard(_orderAs);

var _emergency_contact = __webpack_require__(59);

var EmergencyContact = _interopRequireWildcard(_emergency_contact);

var _service_location = __webpack_require__(45);

var ServiceLocation = _interopRequireWildcard(_service_location);

var _debug = __webpack_require__(5);

var _debug2 = _interopRequireDefault(_debug);

var _utils2 = __webpack_require__(15);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = __webpack_require__(30);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['', '-', '-', ''], ['', '-', '-', '']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['', ': ', ''], ['', ': ', '']);

exports.default = function () {
  return {

    product_id: { type: 'id', required: true },
    created_at: { type: 'datetime', readonly: true },

    privacy: { type: 'number', list: false },
    status: { type: 'select', items: ['status.active', 'status.inactive'], default: 'active' },
    type: { type: 'string', default: 'published' },
    tags: { type: 'tags', hidden: false, list: true },

    details: {
      expand: true,
      type: 'schema', schema: (0, _utils.inlineSchema)({
        title: { type: 'i18n', itemType: { type: 'string' } },
        description: { type: 'i18n', itemType: { type: 'text' } },
        days_to_expiry: { type: 'number' } })
    },

    required_custom_types: { type: 'select', items: ['fields.timeslot', 'fields.feature'], multi: true, list: false },

    customs: {
      label: 'fields.timeslots',
      type: 'array', add: true, delete: true, itemType: {
        type: 'schema', schema: (0, _lodash.merge)((0, _utils.inlineSchema)({
          custom_id: {
            type: 'id', required: true, readonly: true,
            get: function get(model) {
              return _i18n2.default.nn(_templateObject, (0, _lodash.get)(model, 'details.service_hours', 0) * 60, (0, _moment2.default)((0, _lodash.get)(model, 'details.start_time')).format('HHmm'), (0, _lodash.get)(model, 'details.cooldown_hours', 0) * 60);
            }
          },
          type: { type: 'select', items: ['fields.timeslot', 'fields.feature'], required: true },
          details: {
            type: 'schema', expand: true,
            schema: (0, _utils.inlineSchema)({
              service_hours: {
                type: 'number', required: true, min: 0
              },
              start_time: {
                type: 'time', required: true
              },
              cooldown_hours: {
                type: 'number', required: true, min: 0
              },
              description: { type: 'string' }
            })
          },
          price_options: {
            type: 'array', add: true, delete: true, min: 1, max: 1, itemType: {
              type: 'schema', expand: true,
              schema: (0, _lodash.merge)((0, _utils.inlineSchema)({
                currency_type: {
                  type: 'select',
                  items: ['fields.currency.cash_hkd', 'fields.currency.cash_rmb']
                },
                currency_amount: { type: 'number' },
                caregiver_commission: { type: 'number' }
              }), {
                title: function title(model) {
                  return _i18n2.default.nn(_templateObject2, model.currency_type, model.currency_amount);
                }
              })
            }
          }
        }), {
          title: function title(model) {
            if (model && model.custom_id) {
              var parts = model.custom_id.replace(/\.[a-z0-9\-]{36}$/i, '');
              parts = parts.split('-');
              var start = (0, _moment2.default)(parts[1], 'HHmm');
              return _moment2.default.duration(parseInt(parts[0]), 'm').humanize() + ', ' + start.format('HH:mm') + '~' + start.add(parseInt(parts[0]), 'm').format('HH:mm') + ', cool down ' + _moment2.default.duration(parseInt(parts[2]), 'm').humanize();
            } else {
              return '';
            }
          }
        })
      }
    },


    required_groups: {
      type: 'array', add: true, delete: true, itemType: {
        type: 'schema', schema: (0, _lodash.merge)((0, _utils.inlineSchema)({
          group: {
            type: 'select', search: true, valueKey: 'group_id',
            items: function items(value, model, fieldSpec, search) {
              return Group.list.call(this, { skip: 0, limit: -1, search: search, status: 'active' }).then(function (response) {
                return (0, _lodash.map)(response.data, function (x) {
                  return { value: x, label: _i18n2.default.S((0, _lodash.get)(x, 'details.name')) };
                });
              });
            }
          },
          required_self_status: { type: 'select', items: ['status.pending', 'status.approved', 'status.admin'] }
        }), {
          title: function title(model) {
            return Group.title.call(this, model.group, Group);
          }
        })
      }
    },

    inventory_unlimited: { type: Boolean, list: false },
    inventory: { type: 'number', default: -1, list: false }

  };
};

var _lodash = __webpack_require__(1);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _utils = __webpack_require__(3);

var _i18n = __webpack_require__(2);

var _i18n2 = _interopRequireDefault(_i18n);

var _group = __webpack_require__(31);

var Group = _interopRequireWildcard(_group);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(16);

var _keys2 = _interopRequireDefault(_keys);

exports.default = function (model) {
  return {
    transaction_id: { type: 'id', required: true },
    created_at: { type: 'datetime', readonly: true },
    status: { type: 'select', items: ['status.active', 'status.inactive'], default: 'active' },

    'remark.transaction_code': { type: 'label' },
    'remark.notes': { type: 'string', maxlength: 200 },

    type: {
      type: 'select',
      readonly: true,
      items: (0, _lodash.map)((0, _keys2.default)(_i18n2.default.s('type.transaction')), function (x) {
        return 'type.transaction.' + x;
      })
    },
    tags: { type: 'tags' },

    transaction_progress: {
      type: 'select', items: ['status.pending', 'status.failed', 'status.success', 'status.waiting_admin_confirm'],
      get readonly() {
        return !model || model.type === 'purchase';
      }
    },

    from: { type: 'schema', schema: Member, readonly: true },
    to: { type: 'schema', schema: Member, readonly: true },

    products: {
      readonly: true,
      type: 'array',
      itemType: {
        type: 'schema', schema: (0, _utils.inlineSchema)({
          product: { type: 'schema', required: true, schema: Product },
          quantity: { type: 'number', validation: { min_value: 1 } } })
      }
    },

    coupons: [{
      coupon: {},
      quantity: { type: 'number' }
    }],

    currency_type: {
      type: 'select',
      readonly: true,
      items: ['fields.currency.cash_hkd', 'fields.currency.cash_usd']
    },

    total_amount: {
      type: 'label',
      readonly: true
    },

    details: {
      hidden: model && model.type == 'caregiver_invoice',
      type: 'schema', schema: (0, _utils.inlineSchema)({
        payment: { type: 'schema', schema: Payment, external: true }
      })
    },
    ref: {
      label: 'fields.records',
      type: 'schema', schema: (0, _utils.inlineSchema)({
        order: { type: 'schema', schema: Order, external: true, readonly: true },
        appointment: { type: 'schema', schema: Appointment, readonly: true }
      })
    }

  };
};

var _lodash = __webpack_require__(1);

var _utils = __webpack_require__(3);

var _membership = __webpack_require__(14);

var Member = _interopRequireWildcard(_membership);

var _product = __webpack_require__(58);

var Product = _interopRequireWildcard(_product);

var _payment = __webpack_require__(110);

var Payment = _interopRequireWildcard(_payment);

var _order = __webpack_require__(39);

var Order = _interopRequireWildcard(_order);

var _appointment = __webpack_require__(26);

var Appointment = _interopRequireWildcard(_appointment);

var _i18n = __webpack_require__(2);

var _i18n2 = _interopRequireDefault(_i18n);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _keys = __webpack_require__(16);

var _keys2 = _interopRequireDefault(_keys);

var _downloadjs = __webpack_require__(394);

var _downloadjs2 = _interopRequireDefault(_downloadjs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	props: {
		'type': {
			type: String,
			default: "xls"
		},

		'data': {
			type: Array,
			required: true
		},

		'fields': {
			type: Object,
			required: true
		},

		'title': {
			type: String,
			default: null
		},

		'name': {
			type: String,
			default: "data.xls"
		},
		'meta': {
			type: Array,
			default: function _default() {
				return [];
			}
		}
	},
	computed: {
		idName: function idName() {
			var now = new Date().getTime();
			return 'export_' + now;
		}
	},
	methods: {
		generate: function generate() {
			if (!this.data.length) {
				return;
			}
			var json = this.getProcessedJson(this.data, this.fields);
			if (this.type == 'csv') {
				return this.export(this.jsonToCSV(json), this.name, "application/csv");
			}
			return this.export(this.jsonToXLS(json), this.name, "application/vnd.ms-excel");
		},

		export: function _export(data, filename, mime) {
			var blob = this.base64ToBlob(data, mime);
			(0, _downloadjs2.default)(blob, filename, mime);
		},

		jsonToXLS: function jsonToXLS(data) {
			var xlsTemp = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><meta name=ProgId content=Excel.Sheet> <meta name=Generator content="Microsoft Excel 11"><meta http-equiv="Content-Type" content="text/html; charset=UTF-8"><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>${table}</table></body></html>';
			var xlsData = '<thead><tr>';

			if (this.title != null) {
				xlsData += '<tr><th colspan="' + (0, _keys2.default)(data[0]).length + '">' + this.title + '<th></tr>';
			}

			for (var key in data[0]) {
				xlsData += '<th>' + key + '</th>';
			}
			xlsData += '</tr></thead>';
			xlsData += '<tbody>';

			data.map(function (item, index) {
				xlsData += '<tbody><tr>';
				for (var _key in item) {
					xlsData += '<td>' + item[_key] + '</td>';
				}
				xlsData += '</tr></tbody>';
			});
			return xlsTemp.replace('${table}', xlsData);
		},

		jsonToCSV: function jsonToCSV(data) {
			var csvData = '';

			if (this.title != null) {
				csvData += this.title + '\r\n';
			}

			for (var key in data[0]) {
				csvData += key + ',';
			}
			csvData = csvData.slice(0, csvData.length - 1);
			csvData += '\r\n';

			data.map(function (item) {
				for (var _key2 in item) {
					var escapedCSV = item[_key2] + '';
					if (escapedCSV.match(/[,"\n]/)) {
						escapedCSV = '"' + escapedCSV.replace(/\"/g, "\"\"") + '"';
					}
					csvData += escapedCSV + ',';
				}
				csvData = csvData.slice(0, csvData.length - 1);
				csvData += '\r\n';
			});
			return csvData;
		},

		getProcessedJson: function getProcessedJson(data, header) {
			var keys = this.getKeys(data, header);
			var newData = [];
			var _self = this;
			data.map(function (item, index) {
				var newItem = {};
				for (var label in keys) {
					var iii = item;
					var property = keys[label];
					newItem[label] = _self.getNestedData(property, item);
				}
				newData.push(newItem);
			});

			return newData;
		},
		getKeys: function getKeys(data, header) {
			if (header) {
				return header;
			}

			var keys = {};
			for (var key in data[0]) {
				keys[key] = key;
			}
			return keys;
		},
		getNestedData: function getNestedData(key, item) {
			var valueFromNestedKey = null;
			var keyNestedSplit = key.split(".");
			valueFromNestedKey = item[keyNestedSplit[0]];
			for (var j = 1; j < keyNestedSplit.length; j++) {
				valueFromNestedKey = valueFromNestedKey[keyNestedSplit[j]];
			}
			return valueFromNestedKey;
		},
		base64ToBlob: function base64ToBlob(data, mime) {
			var base64 = window.btoa(window.unescape(encodeURIComponent(data)));
			var bstr = atob(base64);
			var n = bstr.length;
			var u8arr = new Uint8ClampedArray(n);
			while (n--) {
				u8arr[n] = bstr.charCodeAt(n);
			}
			return new Blob([u8arr], { type: mime });
		}
	} };

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

__webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 593));
__webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 594));
exports.default = {};

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {};

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {};

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TopNavbar = __webpack_require__(471);

var _TopNavbar2 = _interopRequireDefault(_TopNavbar);

var _ContentFooter = __webpack_require__(469);

var _ContentFooter2 = _interopRequireDefault(_ContentFooter);

var _Content = __webpack_require__(468);

var _Content2 = _interopRequireDefault(_Content);

var _MovingArrow = __webpack_require__(497);

var _MovingArrow2 = _interopRequireDefault(_MovingArrow);

var _UserMenu = __webpack_require__(499);

var _UserMenu2 = _interopRequireDefault(_UserMenu);

var _MobileMenu = __webpack_require__(496);

var _MobileMenu2 = _interopRequireDefault(_MobileMenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    TopNavbar: _TopNavbar2.default,
    ContentFooter: _ContentFooter2.default,
    DashboardContent: _Content2.default,
    MovingArrow: _MovingArrow2.default,
    UserMenu: _UserMenu2.default,
    MobileMenu: _MobileMenu2.default
  },
  methods: {
    toggleSidebar: function toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    }
  }
};

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(22);

var _extends3 = _interopRequireDefault(_extends2);

var _i18n = __webpack_require__(2);

var _i18n2 = _interopRequireDefault(_i18n);

var _lodash = __webpack_require__(1);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _debug2 = __webpack_require__(5);

var _debug3 = _interopRequireDefault(_debug2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      activeNotifications: false,
      searchQuery: ''
    };
  },

  computed: {
    debug: function debug() {
      return _debug3.default.DEBUG;
    },
    sumBy: function sumBy() {
      return _lodash.sumBy;
    },
    routeName: function routeName() {
      return (0, _lodash.isArray)(this.$route.name) ? _i18n2.default.fr.apply(_i18n2.default, this.$route.name) : _i18n2.default.fr(this.$route.name);
    },
    version: function version() {
      return (0, _extends3.default)({}, window.__version, {
        time: (0, _moment2.default)(window.__version.time).format('YYYY/MM/DD HH:mm')
      });
    }
  },
  methods: {
    changeLocal: function changeLocal(local) {
      _i18n2.default.local = local;
      this.$sidebar.reload();
    },
    capitalizeFirstLetter: function capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown: function toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown: function closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar: function toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar: function hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    minimizeSidebar: function minimizeSidebar() {
      this.$sidebar.toggleMinimize();
    },
    doSearch: function doSearch() {
      this.$bus.$emit('search', this.searchQuery);
      this.searchQuery = '';
    }
  }
};

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(7);

var _promise2 = _interopRequireDefault(_promise);

var _getIterator2 = __webpack_require__(23);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _extends2 = __webpack_require__(22);

var _extends3 = _interopRequireDefault(_extends2);

var _lodash = __webpack_require__(1);

var _mixin = __webpack_require__(8);

var _mixin2 = _interopRequireDefault(_mixin);

var _veeValidate = __webpack_require__(57);

var _i18n = __webpack_require__(2);

var _i18n2 = _interopRequireDefault(_i18n);

var _utils = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'f-array',
  mixins: [_mixin2.default],
  data: function data() {
    return {
      validator: _veeValidate.Validator.create()
    };
  },

  computed: {
    _specs: function _specs() {
      var _this = this;

      return (0, _lodash.map)(this.value, function (value, idx) {
        return { idx: idx, spec: (0, _extends3.default)({}, _this.spec.itemType, { prop: String(idx) }) };
      });
    }
  },
  methods: {
    add: function add() {
      var _this2 = this;

      if (!this.value) this.value = [];
      if (!(typeof this.spec.max === 'number' && this.value.length >= this.spec.max)) {
        var temp = { obj: undefined };
        _utils.sanitizeModel.call(this, temp, [(0, _extends3.default)({}, this.spec.itemType, { prop: 'obj' })]).then(function (x) {
          return _this2.value.push(x.obj);
        });
      }
    },
    del: function del(idx) {
      if (!this.value) this.value = [];
      if (!(typeof this.spec.min === 'number' && this.value.length <= this.spec.min)) {
        this.value.splice(idx, 1);
      }
    },
    validate: function validate() {
      var p = [];
      this.validator = _veeValidate.Validator.create();
      if (!this._readonly && this.value && this.spec.itemType.validation) {
        for (var i = 0; i < this.value.length; ++i) {
          this.validator.attach(String(i), this.spec.itemType.validation);
        }
      }
      p.push(this.validator.validateAll(this.value));
      if (this.$refs.fields) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = (0, _getIterator3.default)(this.$refs.fields), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var f = _step.value;

            if (typeof f.validate === 'function') {
              p.push(f.validate());
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
      return _promise2.default.all(p).then(function (valid) {
        return (0, _lodash.every)(valid);
      });
    }
  }
};

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = __webpack_require__(27);

var _typeof3 = _interopRequireDefault(_typeof2);

var _defineProperty2 = __webpack_require__(12);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _button = __webpack_require__(97);

var _button2 = _interopRequireDefault(_button);

var _base = __webpack_require__(9);

var _base2 = _interopRequireDefault(_base);

var _button3 = __webpack_require__(68);

var _button4 = _interopRequireDefault(_button3);

var _mixin = __webpack_require__(8);

var _mixin2 = _interopRequireDefault(_mixin);

var _lodash = __webpack_require__(1);

var _index = __webpack_require__(2);

var _index2 = _interopRequireDefault(_index);

var _utils = __webpack_require__(15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'f-button',
  mixins: [_mixin2.default],
  components: (0, _defineProperty3.default)({}, _button4.default.name, _button4.default),
  data: function data() {
    return {
      processing: false
    };
  },

  computed: {
    isArray: function isArray() {
      return _lodash.isArray;
    },
    _actions: function _actions() {
      if (typeof this.spec.actions === 'function') {
        return this.spec.actions.call(this, this.model, this.spec, this.readonly);
      } else if ((0, _lodash.isArray)(this.spec.actions)) {
        return this.spec.actions;
      } else {
        return [];
      }
    }
  },
  methods: {
    reload: function reload() {},
    click: function click(b, idx) {
      var self = this;
      if (typeof b.action === 'function') {
        var p = b.action.call(self, self.model, self.spec, self.readonly);
        if (p && (typeof p === 'undefined' ? 'undefined' : (0, _typeof3.default)(p)) === 'object' && typeof p.then === 'function') {
          self.processing = idx;
          p.then(function (reload) {
            self.processing = false;
            if (reload) {
              (self.$rootForm || self.$parentForm || self).reload();
            }
          }, function (err) {
            self.processing = false;
            err = (0, _utils.parseError)(err);
            self.$notify({
              component: { template: _index2.default.f('alert.html.$err', { err: err }) },
              icon: 'ti-alert',
              horizontalAlign: 'center',
              verticalAlign: 'top',
              type: 'danger'
            });
          });
        }
      }
    }
  }
};

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mixin = __webpack_require__(8);

var _mixin2 = _interopRequireDefault(_mixin);

var _Checkbox = __webpack_require__(258);

var _Checkbox2 = _interopRequireDefault(_Checkbox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'f-checkbox',
  mixins: [_mixin2.default],
  components: { PCheckbox: _Checkbox2.default }
};

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(12);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _timePicker = __webpack_require__(444);

var _timePicker2 = _interopRequireDefault(_timePicker);

var _timePicker3 = __webpack_require__(402);

var _timePicker4 = _interopRequireDefault(_timePicker3);

var _datePicker = __webpack_require__(53);

var _datePicker2 = _interopRequireDefault(_datePicker);

var _base = __webpack_require__(9);

var _base2 = _interopRequireDefault(_base);

var _datePicker3 = __webpack_require__(49);

var _datePicker4 = _interopRequireDefault(_datePicker3);

var _components;

var _mixin = __webpack_require__(8);

var _mixin2 = _interopRequireDefault(_mixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'f-datetime',
  mixins: [_mixin2.default],
  components: (_components = {}, (0, _defineProperty3.default)(_components, _datePicker4.default.name, _datePicker4.default), (0, _defineProperty3.default)(_components, _timePicker4.default.name, _timePicker4.default), _components)
};

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(7);

var _promise2 = _interopRequireDefault(_promise);

var _getIterator2 = __webpack_require__(23);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _defineProperty2 = __webpack_require__(12);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _button = __webpack_require__(97);

var _button2 = _interopRequireDefault(_button);

var _base = __webpack_require__(9);

var _base2 = _interopRequireDefault(_base);

var _button3 = __webpack_require__(68);

var _button4 = _interopRequireDefault(_button3);

var _lodash = __webpack_require__(1);

var _mixin = __webpack_require__(8);

var _mixin2 = _interopRequireDefault(_mixin);

var _index = __webpack_require__(2);

var _index2 = _interopRequireDefault(_index);

var _utils = __webpack_require__(15);

var _debug = __webpack_require__(5);

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: (0, _defineProperty3.default)({}, _button4.default.name, _button4.default),
  name: 'f-file',
  mixins: [_mixin2.default],
  data: function data() {
    return {
      meta: {}
    };
  },

  computed: {
    value_: function value_() {
      return this.value ? [].concat(this.value) : [];
    },
    type: function type() {
      return this.spec && this.spec.type || 'file';
    }
  },
  watch: {
    value_: {
      immediate: true,
      deep: true,
      handler: function handler(v) {
        var _this = this;

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          var _loop = function _loop() {
            var id = _step.value;

            if (!_this.meta[id]) {
              _this.$http.post('', { endpoint: 'getMediaprofileById', mediaprofile_id: id }).then(function (response) {
                _this.$set(_this.meta, id, (0, _lodash.get)(response.body, 'data'));
              });
            }
          };

          for (var _iterator = (0, _getIterator3.default)(v), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            _loop();
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
    }
  },
  methods: {
    mediaUrl: function mediaUrl(id) {
      return (0, _utils.apiHost)() + this.type + '/' + encodeURIComponent(id) + (this.filename(id) ? '/' + encodeURIComponent(this.filename(id)) : '') + '?access-token=' + encodeURIComponent(this.$auth.access_token) + '&device-uuid=' + encodeURIComponent(this.$auth.device_uuid);
    },
    filename: function filename(id) {
      return (0, _lodash.get)(this.meta[id], 'details.filename');
    },
    displayName: function displayName(id) {
      var size = (0, _lodash.get)(this.meta[id], 'details.size', -1);
      return (this.filename(id) || id) + (size >= 0 ? ' (' + _utils.formatSiUnit.byte(size) + ')' : '');
    },
    add: function add() {
      var _this2 = this;

      if (!this.$refs.file.files.length) {
        return;
      }
      var p = void 0;
      if (typeof this.spec.upload === 'function') {
        p = this.spec.upload.call(this, this.$refs.file.files);
      } else {
        p = _promise2.default.all((0, _lodash.map)(this.$refs.file.files, function (x) {
          return new _promise2.default(function (yes, no) {
            var r = new FileReader();
            r.addEventListener('load', function () {
              var base64 = r.result.substr(r.result.indexOf(',') + 1);
              var payload = {
                endpoint: 'uploadFile',
                type: _this2.type,
                sub_type: _this2.spec.sub_type || 'default',
                tags: [],
                privacy: 1,
                details: {
                  filename: x.name,
                  mime: x.type,
                  size: x.size
                },
                file: base64
              };
              if (typeof _this2.spec.preprocess === 'function') {
                payload = _this2.spec.preprocess.call(_this2, payload);
              }
              _this2.$http.post('', payload).then(function (response) {
                var mid = (0, _lodash.get)(response, 'body.data.mediaprofile_id');
                if (!mid) {
                  no(new Error('Empty response from server'));
                } else {
                  _this2.$set(_this2.meta, mid, response.body.data);
                  yes(mid);
                }
              }, no);
            });
            r.readAsDataURL(x);
          });
        }));
      }

      p.then(function (ids) {
        ids = ids ? [].concat(ids) : [];
        if (ids.length) {
          if (_this2.spec.multi) {
            if ((0, _lodash.isArray)(_this2.value)) {
              _this2.value = _this2.value.concat(ids);
            } else {
              _this2.value = ids;
            }
          } else {
            _this2.value = ids[0];
          }
        }
        _this2.$refs.file.value = null;
        _this2.$notify({
          component: {
            template: _index2.default.f('alert.html.file_uploaded_successfully')
          },
          icon: 'ti-info',
          horizontalAlign: 'center',
          verticalAlign: 'top',
          type: 'success'
        });
      }, function (err) {
        err = (0, _utils.parseError)(err);
        _this2.$notify({
          component: {
            template: _index2.default.f('alert.html.$err', { err: err })
          },
          icon: 'ti-alert',
          horizontalAlign: 'center',
          verticalAlign: 'top',
          type: 'danger'
        });
      });
    },
    del: function del(i) {
      if (this.spec.multi) {
        if (!(0, _lodash.isArray)(this.value)) {
          this.value = [];
        } else {
          this.value.splice(i, 1);
        }
      } else {
        this.value = null;
      }
    }
  }
};

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(111);

var _assign2 = _interopRequireDefault(_assign);

var _mixin = __webpack_require__(8);

var _mixin2 = _interopRequireDefault(_mixin);

var _tinymceVue = __webpack_require__(285);

var _tinymceVue2 = _interopRequireDefault(_tinymceVue);

var _utils = __webpack_require__(15);

var _lodash = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'f-html',
  mixins: [_mixin2.default],
  components: {
    Editor: _tinymceVue2.default
  },
  computed: {
    options: function options() {
      var _this = this;

      return (0, _assign2.default)({
        readonly: this._readonly,
        height: 500,
        toolbar: this._readonly ? false : 'formatselect | bold italic strikethrough forecolor backcolor | link | ' + 'alignleft aligncenter alignright alignjustify | numlist bullist outdent indent | ' + 'removeformat',
        menubar: !this._readonly,
        statusbar: !this._readonly,
        plugins: ['code preview fullpage searchreplace autolink directionality visualblocks', 'visualchars link codesample table charmap hr pagebreak nonbreaking', 'anchor toc insertdatetime advlist lists textcolor wordcount contextmenu', 'colorpicker textpattern media paste image'],
        removed_menuitems: 'newdocument',
        images_upload_handler: function images_upload_handler(blobInfo, yes, no) {
          var blob = blobInfo.blob();
          _this.$http.post('', {
            endpoint: 'uploadPNG',
            type: _this.spec.uploadType || "image",
            sub_type: _this.spec.uploadSubType || "default",
            tags: [],
            privacy: 1,
            details: {
              filename: blob.name,
              mime: blob.type,
              size: blob.size
            },
            image: blobInfo.base64()
          }).then(_utils.parseResponse).then(function (response) {
            var mid = (0, _lodash.get)(response, 'body.data.mediaprofile_id');
            if (!mid) {
              no('Empty response from server');
            } else {
              yes((0, _utils.apiHost)() + 'media/original/' + mid);
            }
          }, function (err) {
            no((0, _utils.parseError)(err));
          });
        }
      }, this.spec.options);
    }
  }
};

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(22);

var _extends3 = _interopRequireDefault(_extends2);

var _lodash = __webpack_require__(1);

var _mixin = __webpack_require__(8);

var _mixin2 = _interopRequireDefault(_mixin);

var _veeValidate = __webpack_require__(57);

var _i18n = __webpack_require__(2);

var _i18n2 = _interopRequireDefault(_i18n);

var _utils = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'f-i18n',
  mixins: [_mixin2.default],
  data: function data() {
    return {};
  },

  computed: {
    localKeys: function localKeys() {
      if (this.spec.local) {
        return Array.isArray(this.spec.local) ? this.spec.local : [this.spec.local];
      } else if (this._readonly) {
        return [this.i18n.local];
      }
      return this.i18n.langs;
    }
  },
  methods: {
    _spec: function _spec(local) {
      return (0, _extends3.default)({}, this.spec.itemType, {
        prop: this.spec.prop + (this.spec.separator == null ? '.' : this.spec.separator) + local
      });
    }
  }
};

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mixin = __webpack_require__(8);

var _mixin2 = _interopRequireDefault(_mixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'f-id',
  mixins: [_mixin2.default]
};

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(7);

var _promise2 = _interopRequireDefault(_promise);

var _getIterator2 = __webpack_require__(23);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _defineProperty2 = __webpack_require__(12);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _button = __webpack_require__(97);

var _button2 = _interopRequireDefault(_button);

var _base = __webpack_require__(9);

var _base2 = _interopRequireDefault(_base);

var _button3 = __webpack_require__(68);

var _button4 = _interopRequireDefault(_button3);

var _lodash = __webpack_require__(1);

var _mixin = __webpack_require__(8);

var _mixin2 = _interopRequireDefault(_mixin);

var _index = __webpack_require__(2);

var _index2 = _interopRequireDefault(_index);

var _utils = __webpack_require__(15);

var _debug = __webpack_require__(5);

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: (0, _defineProperty3.default)({}, _button4.default.name, _button4.default),
  name: 'f-img',
  mixins: [_mixin2.default],
  data: function data() {
    return {
      meta: {}
    };
  },

  computed: {
    value_: function value_() {
      return this.value ? [].concat(this.value) : [];
    },
    type: function type() {
      return this.spec && this.spec.type || 'image';
    }
  },
  watch: {
    value_: {
      immediate: true,
      deep: true,
      handler: function handler(v) {
        var _this = this;

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          var _loop = function _loop() {
            var id = _step.value;

            if (!_this.meta[id]) {
              _this.$http.post('', { endpoint: 'getMediaprofileById', mediaprofile_id: id }).then(function (response) {
                _this.$set(_this.meta, id, (0, _lodash.get)(response.body, 'data'));
              });
            }
          };

          for (var _iterator = (0, _getIterator3.default)(v), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            _loop();
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
    }
  },
  methods: {
    mediaUrl: function mediaUrl(id) {
      var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'thumbnail';

      return (0, _utils.apiHost)() + 'media/' + size + '/' + encodeURIComponent(id) + (this.filename(id) ? '/' + encodeURIComponent(this.filename(id)) : '') + '?access-token=' + encodeURIComponent(this.$auth.access_token) + '&device-uuid=' + encodeURIComponent(this.$auth.device_uuid);
    },
    filename: function filename(id) {
      return (0, _lodash.get)(this.meta[id], 'details.filename');
    },
    displayName: function displayName(id) {
      var size = (0, _lodash.get)(this.meta[id], 'details.size', -1);
      return (this.filename(id) || id) + (size >= 0 ? ' (' + _utils.formatSiUnit.byte(size) + ')' : '');
    },
    add: function add() {
      var _this2 = this;

      if (!this.$refs.file.files.length) {
        return;
      }
      var p = void 0;
      if (typeof this.spec.upload === 'function') {
        p = this.spec.upload.call(this, this.$refs.file.files);
      } else {
        p = _promise2.default.all((0, _lodash.map)(this.$refs.file.files, function (x) {
          return new _promise2.default(function (yes, no) {
            var r = new FileReader();
            r.addEventListener('load', function () {
              var base64 = r.result.substr(r.result.indexOf(',') + 1);
              var payload = {
                endpoint: 'uploadPNG',
                type: _this2.type,
                sub_type: _this2.spec.sub_type || 'default',
                tags: [],
                privacy: 1,
                details: {
                  filename: x.name,
                  mime: x.type,
                  size: x.size
                },
                image: base64
              };
              if (typeof _this2.spec.preprocess === 'function') {
                payload = _this2.spec.preprocess.call(_this2, payload);
              }
              _this2.$http.post('', payload).then(function (response) {
                var mid = (0, _lodash.get)(response, 'body.data.mediaprofile_id');
                if (!mid) {
                  no(new Error('Empty response from server'));
                } else {
                  _this2.$set(_this2.meta, mid, response.body.data);
                  yes(mid);
                }
              }, no);
            });
            r.readAsDataURL(x);
          });
        }));
      }

      p.then(function (ids) {
        ids = ids ? [].concat(ids) : [];
        if (ids.length) {
          if (_this2.spec.multi) {
            if ((0, _lodash.isArray)(_this2.value)) {
              _this2.value = _this2.value.concat(ids);
            } else {
              _this2.value = ids;
            }
          } else {
            _this2.value = ids[0];
          }
        }
        _this2.$refs.file.value = null;
        _this2.$notify({
          component: {
            template: _index2.default.f('alert.html.file_uploaded_successfully')
          },
          icon: 'ti-info',
          horizontalAlign: 'center',
          verticalAlign: 'top',
          type: 'success'
        });
      }, function (err) {
        err = (0, _utils.parseError)(err);
        _this2.$notify({
          component: {
            template: _index2.default.f('alert.html.$err', { err: err })
          },
          icon: 'ti-alert',
          horizontalAlign: 'center',
          verticalAlign: 'top',
          type: 'danger'
        });
      });
    },
    del: function del(i) {
      if (this.spec.multi) {
        if (!(0, _lodash.isArray)(this.value)) {
          this.value = [];
        } else {
          this.value.splice(i, 1);
        }
      } else {
        this.value = null;
      }
    }
  }
};

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(12);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _input = __webpack_require__(141);

var _input2 = _interopRequireDefault(_input);

var _base = __webpack_require__(9);

var _base2 = _interopRequireDefault(_base);

var _input3 = __webpack_require__(43);

var _input4 = _interopRequireDefault(_input3);

var _mixin = __webpack_require__(8);

var _mixin2 = _interopRequireDefault(_mixin);

var _utils = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'f-input',
  mixins: [_mixin2.default],
  components: (0, _defineProperty3.default)({}, _input4.default.name, _input4.default),
  computed: {
    value: {
      get: function get() {
        return _utils.getField.call(this, this.model, this.spec);
      },
      set: function set(v) {
        return _utils.setField.call(this, this.model, this.spec, this.spec.inputType === 'number' ? parseFloat(v) : v);
      }
    }
  }
};

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(7);

var _promise2 = _interopRequireDefault(_promise);

var _stringify = __webpack_require__(37);

var _stringify2 = _interopRequireDefault(_stringify);

var _mixin = __webpack_require__(8);

var _mixin2 = _interopRequireDefault(_mixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'f-json',
  mixins: [_mixin2.default],
  data: function data() {
    return {
      editor: null,
      err: null,
      json: '',
      _json: ''
    };
  },

  watch: {
    json: function json() {
      try {
        var o = JSON.parse(this.json);
        var _json = (0, _stringify2.default)(o);
        if (this._json != _json) {
          this._json = _json;
          this.value = o;
        }
        this.err = null;
      } catch (e) {
        this.err = e;
      }
    },
    value: function value() {
      var _json = (0, _stringify2.default)(this.value);
      if (this._json != _json) {
        this._json = _json;
        this.editor.setValue((0, _stringify2.default)(this.value, null, '\t'));
      }
      this.err = null;
    },
    _readonly: function _readonly() {
      this.editor.setReadOnly(this._readonly);
    }
  },
  methods: {
    validate: function validate() {
      return _promise2.default.resolve(!this.err);
    },
    reformat: function reformat() {
      try {
        this._json = '';
        this.value = Function('return (' + this.json + ')')();
      } catch (e) {
        this.err = e;
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.editor = window.ace.edit(this.$refs.editor);
    this.editor.setReadOnly(this._readonly);
    this.editor.getSession().setMode("ace/mode/json");
    this._json = (0, _stringify2.default)(this.value);
    this.json = (0, _stringify2.default)(this.value, null, '\t') || '';
    this.editor.setValue(this.json);
    this.editor.clearSelection();
    this.editor.getSession().on('change', function () {
      _this.json = _this.editor.getValue();
    });
  }
};

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mixin = __webpack_require__(8);

var _mixin2 = _interopRequireDefault(_mixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'f-label',
  mixins: [_mixin2.default]
};

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mixin = __webpack_require__(8);

var _mixin2 = _interopRequireDefault(_mixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'f-link',
  mixins: [_mixin2.default],
  components: {},
  computed: {
    link: function link() {
      return this.spec.link || {};
    },
    to: function to() {
      if (typeof this.link.to === 'function') {
        return this.link.to.call(this, this.value, this.model, this.spec);
      } else {
        return this.link.to;
      }
    }
  },
  methods: {}
};

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mixin = __webpack_require__(8);

var _mixin2 = _interopRequireDefault(_mixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'f-radio',
  mixins: [_mixin2.default]
};

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(7);

var _promise2 = _interopRequireDefault(_promise);

var _defineProperty2 = __webpack_require__(12);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _collapseItem = __webpack_require__(98);

var _collapseItem2 = _interopRequireDefault(_collapseItem);

var _collapseItem3 = __webpack_require__(89);

var _collapseItem4 = _interopRequireDefault(_collapseItem3);

var _collapse = __webpack_require__(99);

var _collapse2 = _interopRequireDefault(_collapse);

var _base = __webpack_require__(9);

var _base2 = _interopRequireDefault(_base);

var _collapse3 = __webpack_require__(90);

var _collapse4 = _interopRequireDefault(_collapse3);

var _components;

var _lodash = __webpack_require__(1);

var _mixin = __webpack_require__(8);

var _mixin2 = _interopRequireDefault(_mixin);

var _SchemaBaseForm = __webpack_require__(106);

var _SchemaBaseForm2 = _interopRequireDefault(_SchemaBaseForm);

var _utils = __webpack_require__(3);

var _i18n = __webpack_require__(2);

var _i18n2 = _interopRequireDefault(_i18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'f-schema',
  mixins: [_mixin2.default],
  components: (_components = {
    'schema-form': _SchemaBaseForm2.default
  }, (0, _defineProperty3.default)(_components, _collapse4.default.name, _collapse4.default), (0, _defineProperty3.default)(_components, _collapseItem4.default.name, _collapseItem4.default), _components),
  computed: {
    panelClass: function panelClass() {
      if (typeof this.spec.class === 'function') {
        return this.spec.class.call(this, this.value, this.spec.schema, this.readonly);
      } else {
        return this.spec.class;
      }
    },
    schemaTitle: function schemaTitle() {
      if (typeof this.spec.schema.title === 'function') {
        return this.spec.schema.title.call(this, this.value, this.model);
      } else {
        return this.spec.schema.title;
      }
    },
    id: function id() {
      if (this.value) {
        if (typeof this.value === 'string') {
          return this.value;
        } else if (this.columns) {
          var field = (0, _utils.findKeyField)(this.columns);
          return (0, _lodash.get)(this.value, field.prop);
        }
      }
    },
    columns: function columns() {
      var fn = (0, _lodash.get)(this, 'spec.schema.columns');
      return typeof fn === 'function' ? fn.call(this.$parent || this, this.value, this.spec.schema, this.readonly, false) : fn;
    },
    link: function link() {
      if (this.id) {
        if (typeof this.spec.link === 'function') {
          return this.spec.link.call(this, this.id);
        } else {
          return String(this.spec.link).replace(':id', this.id);
        }
      }
    }
  },
  methods: {
    validate: function validate() {
      if (!this._readonly && this.$refs.form) {
        return this.$refs.form.validate();
      } else {
        return _promise2.default.resolve(true);
      }
    },
    view: function view() {
      if (this.value) {
        this.spec.schema.view.call(this.$parent || this, this.value, 0, this.spec.schema, this.columns, true);
      }
    }
  }
};

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = __webpack_require__(27);

var _typeof3 = _interopRequireDefault(_typeof2);

var _defineProperty2 = __webpack_require__(12);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _select = __webpack_require__(142);

var _select2 = _interopRequireDefault(_select);

var _base = __webpack_require__(9);

var _base2 = _interopRequireDefault(_base);

var _select3 = __webpack_require__(134);

var _select4 = _interopRequireDefault(_select3);

var _lodash = __webpack_require__(1);

var _mixin = __webpack_require__(8);

var _mixin2 = _interopRequireDefault(_mixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'f-select',
  mixins: [_mixin2.default],
  components: (0, _defineProperty3.default)({}, _select4.default.name, _select4.default),
  data: function data() {
    return {
      options: [],
      loading: false
    };
  },
  mounted: function mounted() {
    this.reload();
  },

  computed: {
    map: function map() {
      return _lodash.map;
    },
    find: function find() {
      return _lodash.find;
    },
    get: function get() {
      return _lodash.get;
    },
    _options: function _options() {
      return (0, _lodash.map)(this.options, function (x) {
        return (typeof x === 'undefined' ? 'undefined' : (0, _typeof3.default)(x)) === 'object' ? x : { label: x, value: x };
      });
    },
    selectStyle: function selectStyle() {
      return this.spec.multi ? { display: 'block' } : '';
    }
  },
  watch: {
    'spec.items': function specItems() {
      this.reload();
    }
  },
  methods: {
    onchange: function onchange(val) {
      if (typeof this.spec.onchange === 'function') {
        this.spec.onchange.call(this, val, this.model, this.spec);
      }
    },
    reload: function reload(search) {
      var _this = this;

      if ((0, _lodash.isArray)(this.spec.items)) {
        this.options = this.spec.items;
      } else if (typeof this.spec.items === 'function') {
        this.options = [];
        this.loading = true;
        var p = this.spec.items.call(this, this.value, this.model, this.spec, search);
        if (p && typeof p.then === 'function') {
          p.then(function (options) {
            _this.options = options;
            _this.loading = false;
          }, function () {
            _this.loading = false;
          });
        } else {
          this.options = p;
          this.loading = false;
        }
      } else {
        this.options = [];
      }
    }
  }
};

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(12);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _collapseItem = __webpack_require__(98);

var _collapseItem2 = _interopRequireDefault(_collapseItem);

var _collapseItem3 = __webpack_require__(89);

var _collapseItem4 = _interopRequireDefault(_collapseItem3);

var _collapse = __webpack_require__(99);

var _collapse2 = _interopRequireDefault(_collapse);

var _base = __webpack_require__(9);

var _base2 = _interopRequireDefault(_base);

var _collapse3 = __webpack_require__(90);

var _collapse4 = _interopRequireDefault(_collapse3);

var _components;

var _lodash = __webpack_require__(1);

var _mixin = __webpack_require__(8);

var _mixin2 = _interopRequireDefault(_mixin);

var _SchemaBaseTable = __webpack_require__(75);

var _SchemaBaseTable2 = _interopRequireDefault(_SchemaBaseTable);

var _utils = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'f-table',
  mixins: [_mixin2.default],
  components: (_components = {
    'schema-table': _SchemaBaseTable2.default
  }, (0, _defineProperty3.default)(_components, _collapse4.default.name, _collapse4.default), (0, _defineProperty3.default)(_components, _collapseItem4.default.name, _collapseItem4.default), _components),
  data: function data() {
    return {
      title: ''
    };
  },

  computed: {
    filter: function filter() {
      if (typeof this.spec.initialFilter === 'function') {
        return this.spec.initialFilter.call(this, this.value, this.model);
      } else {
        return this.spec.initialFilter;
      }
    }
  },
  methods: {
    dataChanged: function dataChanged(data, total) {
      this.title = '(' + total + ')';
    }
  }
};

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(12);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _input = __webpack_require__(141);

var _input2 = _interopRequireDefault(_input);

var _input3 = __webpack_require__(43);

var _input4 = _interopRequireDefault(_input3);

var _tag = __webpack_require__(443);

var _tag2 = _interopRequireDefault(_tag);

var _base = __webpack_require__(9);

var _base2 = _interopRequireDefault(_base);

var _tag3 = __webpack_require__(69);

var _tag4 = _interopRequireDefault(_tag3);

var _components;

var _mixin = __webpack_require__(8);

var _mixin2 = _interopRequireDefault(_mixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'f-tags',
  mixins: [_mixin2.default],
  components: (_components = {}, (0, _defineProperty3.default)(_components, _tag4.default.name, _tag4.default), (0, _defineProperty3.default)(_components, _input4.default.name, _input4.default), _components),
  data: function data() {
    return {
      inputValue: ''
    };
  },

  methods: {
    handleClose: function handleClose(idx) {
      this.value.splice(idx, 1);
    },
    handleInputConfirm: function handleInputConfirm() {
      var inputValue = this.inputValue;
      if (inputValue) {
        if (!(this.spec.unique && this.value != null && this.value.indexOf(inputValue) >= 0)) {
          if (this.value == null) {
            this.value = [inputValue];
          } else {
            this.value.push(inputValue);
          }
        }
      }
      this.inputValue = '';
    }
  }
};

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mixin = __webpack_require__(8);

var _mixin2 = _interopRequireDefault(_mixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'f-textarea',
  mixins: [_mixin2.default]
};

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = __webpack_require__(27);

var _typeof3 = _interopRequireDefault(_typeof2);

var _stringify = __webpack_require__(37);

var _stringify2 = _interopRequireDefault(_stringify);

var _getIterator2 = __webpack_require__(23);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _regenerator = __webpack_require__(19);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(18);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _promise = __webpack_require__(7);

var _promise2 = _interopRequireDefault(_promise);

var _lodash = __webpack_require__(1);

var _veeValidate = __webpack_require__(57);

var _utils = __webpack_require__(3);

var _index = __webpack_require__(2);

var _index2 = _interopRequireDefault(_index);

var _utils2 = __webpack_require__(15);

var _sweetalert = __webpack_require__(54);

var _sweetalert2 = _interopRequireDefault(_sweetalert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {},
  props: {
    heading: { type: String },
    schema: { type: [Object, _promise2.default, Function], required: true },
    id: String,
    model: {},
    $parentForm: {},
    rootModel: {},
    $rootForm: {},
    readonly: Boolean,
    showActions: { type: Boolean, default: true },
    embedded: Boolean
  },
  data: function data() {
    return {
      schema_: null,
      currentModel: null,
      backupModel: null,
      validator: _veeValidate.Validator.create(),
      loading: false,
      processing: false
    };
  },

  computed: {
    self: function self() {
      return this;
    },
    columns: function columns() {
      var temp = typeof this.schema_.columns === 'function' ? this.schema_.columns.call(this, this.currentModel, this.schema_, this.readonly) : this.schema_.columns;
      return temp || [];
    },
    displayColumns: function displayColumns() {
      var _this = this;

      return (0, _lodash.filter)(this.columns, function (x) {
        return !x.hidden && (!_this.embedded || x.embed !== false);
      });
    },
    categorizedColumns: function categorizedColumns() {
      return _.chain(this.displayColumns).flatMap(function (col) {
        if (col.cat == null) {
          return { col: col, cat: 'fields.cat.default' };
        } else {
          return (0, _lodash.isArray)(col.cat) ? (0, _lodash.map)(col.cat, function (cat) {
            return { col: col, cat: cat };
          }) : { col: col, cat: col.cat };
        }
      }).groupBy('cat').map(function (v, k) {
        return { key: k, title: _index2.default.fr(k), columns: (0, _lodash.map)(v, function (x) {
            return x.col;
          }) };
      }).value();
    },
    formActions: function formActions() {
      var temp = typeof this.schema_.formActions === 'function' ? this.schema_.formActions.call(this, this.currentModel, this.schema_, this.readonly) : this.schema_.formActions;
      return temp || [];
    }
  },
  watch: {
    schema: function schema() {
      this.currentModel = null;
      this.reload();
    },
    model: function model() {
      this.reload();
    },
    id: function id() {
      this.reload();
    }
  },
  mounted: function mounted() {
    var p = this.reload();
    var self = this;
    if (!this.$parentForm) {
      p.then(function () {
        setTimeout(function () {
          if (self.$refs.tabs) {
            var idx = (0, _lodash.findIndex)(self.categorizedColumns, function (x) {
              return x.key == self.$route.hash.substr(1);
            });
            if (idx >= 0) {
              self.$refs.tabs.findTabAndActivate(idx);
            }
          }
        }, 0);
      });
    }
    document.body.addEventListener('keydown', this.keyEvent);
  },
  beforeDestroy: function beforeDestroy() {
    document.body.removeEventListener('keydown', this.keyEvent);
  },

  methods: {
    keyEvent: function keyEvent(e) {
      if (this.$rootForm == null && e.target == document.body) {
        for (var i = 0; i < this.formActions.length; ++i) {
          var act = this.formActions[i];
          if (typeof act.trigger === 'function' && act.trigger.call(this, e)) {
            this.handleAction(act, String(i));
            break;
          }
        }
      }
    },
    reload: function reload() {
      var _this2 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
        var self, fn;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.loading = true;
                _context2.next = 3;
                return typeof _this2.schema === 'function' ? _this2.schema.call(_this2) : _this2.schema;

              case 3:
                _this2.schema_ = _context2.sent;
                self = _this2;

                fn = function () {
                  var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
                    var setModel, model, init, k;
                    return _regenerator2.default.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            setModel = function setModel(x) {
                              _this2.backupModel = x;
                              _this2.currentModel = (0, _lodash.cloneDeep)(x);
                            };

                            _this2.validator = _veeValidate.Validator.create();

                            if (!_this2.model) {
                              _context.next = 8;
                              break;
                            }

                            _context.next = 5;
                            return _utils.sanitizeModel.call(self, _this2.model, _this2.columns);

                          case 5:
                            _this2.currentModel = _context.sent;
                            _context.next = 28;
                            break;

                          case 8:
                            if (!(_this2.id != null)) {
                              _context.next = 20;
                              break;
                            }

                            _this2.processing = 'reload';
                            _context.next = 12;
                            return _this2.schema_.read.call(self, _this2.id, _this2.schema_, _this2.columns);

                          case 12:
                            model = _context.sent;
                            _context.t0 = setModel;
                            _context.next = 16;
                            return _utils.sanitizeModel.call(self, model, _this2.columns);

                          case 16:
                            _context.t1 = _context.sent;
                            (0, _context.t0)(_context.t1);
                            _context.next = 28;
                            break;

                          case 20:
                            _this2.processing = 'reload';
                            init = {};

                            for (k in _this2.$route.query) {
                              (0, _lodash.set)(init, k, _this2.$route.query[k]);
                            }
                            _context.t2 = setModel;
                            _context.next = 26;
                            return _utils.sanitizeModel.call(self, init, _this2.columns);

                          case 26:
                            _context.t3 = _context.sent;
                            (0, _context.t2)(_context.t3);

                          case 28:
                          case 'end':
                            return _context.stop();
                        }
                      }
                    }, _callee, _this2);
                  }));

                  return function fn() {
                    return _ref.apply(this, arguments);
                  };
                }();

                _context2.prev = 6;
                _context2.next = 9;
                return fn();

              case 9:
                _context2.next = 15;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2['catch'](6);

                _context2.t0 = (0, _utils2.parseError)(_context2.t0);
                _this2.$notify({
                  component: { template: _index2.default.fr('alert.html.cannot_fetch_item_$err', { err: _context2.t0 }) },
                  icon: 'ti-alert',
                  horizontalAlign: 'center',
                  verticalAlign: 'top',
                  type: 'danger'
                });

              case 15:
                _this2.loading = false;
                _this2.processing = false;

              case 17:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[6, 11]]);
      }))();
    },
    undo: function undo() {
      var _this3 = this;

      if (this.backupModel) {
        this.processing = 'undo';
        this.currentModel = (0, _lodash.cloneDeep)(this.backupModel);
        setTimeout(function () {
          return _this3.processing = false;
        }, 0);
      }
    },
    validate: function validate() {
      var _this4 = this;

      var p = [];
      var self = this;
      this.validator = _veeValidate.Validator.create();
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        var _loop = function _loop() {
          var col = _step.value;

          if (col.validation) {
            _this4.validator.attach(col.prop, col.validation);
          } else if (typeof col.validator === 'function') {
            var key = (0, _stringify2.default)(col.prop);
            _this4.validator.extend(key, {
              getMessage: function getMessage(field, args, data) {
                return data;
              },
              validate: function validate(v, args) {
                var err = col.validator.apply(self, arguments);
                return { valid: !err, data: err };
              }
            });
            _this4.validator.attach(col.prop, key);
          }
        };

        for (var _iterator = (0, _getIterator3.default)(this.displayColumns), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          _loop();
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var dict = {};
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = (0, _getIterator3.default)(this.columns), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var _col = _step2.value;

          _utils.setField.call(this, dict, _col, _utils.getField.call(this, this.currentModel, _col));
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      p.push(this.validator.validateAll(dict));
      if (this.$refs.fields) {
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = (0, _getIterator3.default)(this.$refs.fields), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var f = _step3.value;

            if (typeof f.validate === 'function') {
              p.push(f.validate());
            }
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }
      }
      return _promise2.default.all(p).then(function (valid) {
        return (0, _lodash.every)(valid);
      });
    },
    handleAction: function handleAction(act, i) {
      var _this5 = this;

      var v = void 0;
      if (act.validation) {
        v = this.validate();
      } else {
        v = _promise2.default.resolve(true);
      }
      v.then(function (isValid) {
        if (isValid) {
          var p = act.action.call(_this5, _this5.currentModel, _this5.schema_, _this5.columns);
          if (p && (typeof p === 'undefined' ? 'undefined' : (0, _typeof3.default)(p)) === 'object' && typeof p.then === 'function') {
            _this5.processing = i;
            p.then(function (reload) {
              _this5.processing = false;
              if (reload) {
                if (_this5.embedded) {
                  (_this5.$rootForm || _this5.$parentForm || _this5).reload();
                } else {
                  _this5.reload();
                }
              }
            }).catch(function (err) {
              _this5.processing = false;
              (0, _sweetalert2.default)({
                title: _index2.default.fr('alert.html.$err', { err: (0, _utils2.parseError)(err) }),
                html: err.err_details ? '<pre>' + (0, _stringify2.default)(err.err_details) + '</pre>' : null,
                type: 'warning',
                showCancelButton: false,
                confirmButtonText: _index2.default.fr('action.ok'),
                confirmButtonClass: 'btn btn-info btn-fill',
                buttonsStyling: false
              });
            });
          }
        }
      });
    },
    tabChanged: function tabChanged(idx, newTab) {
      this.$router.replace('#' + newTab.id);
    },
    findField: function findField(path) {
      return (0, _lodash.find)((0, _lodash.get)(this.$refs, 'fields', []), function (x) {
        return x.name == path;
      });
    }
  }
};

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(12);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _keys = __webpack_require__(16);

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = __webpack_require__(22);

var _extends3 = _interopRequireDefault(_extends2);

var _typeof2 = __webpack_require__(27);

var _typeof3 = _interopRequireDefault(_typeof2);

var _getIterator2 = __webpack_require__(23);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _regenerator = __webpack_require__(19);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(18);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _promise = __webpack_require__(7);

var _promise2 = _interopRequireDefault(_promise);

var _option = __webpack_require__(440);

var _option2 = _interopRequireDefault(_option);

var _option3 = __webpack_require__(399);

var _option4 = _interopRequireDefault(_option3);

var _select = __webpack_require__(142);

var _select2 = _interopRequireDefault(_select);

var _select3 = __webpack_require__(134);

var _select4 = _interopRequireDefault(_select3);

var _tableColumn = __webpack_require__(441);

var _tableColumn2 = _interopRequireDefault(_tableColumn);

var _tableColumn3 = __webpack_require__(400);

var _tableColumn4 = _interopRequireDefault(_tableColumn3);

var _table = __webpack_require__(442);

var _table2 = _interopRequireDefault(_table);

var _base = __webpack_require__(9);

var _base2 = _interopRequireDefault(_base);

var _table3 = __webpack_require__(401);

var _table4 = _interopRequireDefault(_table3);

var _vue = __webpack_require__(6);

var _vue2 = _interopRequireDefault(_vue);

var _Pagination = __webpack_require__(495);

var _Pagination2 = _interopRequireDefault(_Pagination);

var _lodash = __webpack_require__(1);

var _Render = __webpack_require__(324);

var _Render2 = _interopRequireDefault(_Render);

var _index = __webpack_require__(2);

var _index2 = _interopRequireDefault(_index);

var _utils = __webpack_require__(3);

var _Switch = __webpack_require__(500);

var _Switch2 = _interopRequireDefault(_Switch);

var _utils2 = __webpack_require__(15);

var _debug = __webpack_require__(5);

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_table4.default);
_vue2.default.use(_tableColumn4.default);
_vue2.default.use(_select4.default);
_vue2.default.use(_option4.default);
exports.default = {
  components: {
    PPagination: _Pagination2.default,
    Render: _Render2.default,
    PSwitch: _Switch2.default
  },
  props: {
    schema: { type: [Object, _promise2.default, Function], required: true },
    initialFilter: { type: Object },
    embedded: { type: Boolean },
    selectable: { type: Boolean },
    perPage: { type: Number },
    rowStyle: {},
    rowClassName: {},
    listActions: { type: Boolean, default: true }
  },
  data: function data() {
    return {
      schema_: null,
      loading: false,
      hideTable: false,
      pagination: {
        perPage: _debug2.default.DEBUG ? Math.max(1, this.perPage || parseInt(window.localStorage['pagination.perPage'])) || 20 : 20,
        currentPage: 1,
        perPageOptions: [10, 20, 50, 100, 1000],
        total: 0
      },
      sort: {},
      searchQuery: '',
      tableData: [],
      columnFilters: {},
      tableFilters: [],
      schemaParams: {} };
  },
  mounted: function mounted() {
    this.reload();
    if (this.$bus) this.$bus.$on('search', this.searchChanged);
    document.body.addEventListener('keydown', this.keyEvent);
    this.$refs.container.addEventListener('keydown', this.keyEvent);
  },
  beforeDestroy: function beforeDestroy() {
    if (this.$bus) this.$bus.$off('search', this.searchChanged);
    document.body.removeEventListener('keydown', this.keyEvent);
    this.$refs.container.removeEventListener('keydown', this.keyEvent);
  },

  computed: {
    listActions_: function listActions_() {
      var temp = typeof this.schema_.listActions === 'function' ? this.schema_.listActions.call(this, this.schema_) : this.schema_.listActions;
      return temp || [];
    },
    columns: function columns() {
      var temp = typeof this.schema_.columns === 'function' ? this.schema_.columns.call(this, null, this.schema_, true, true) : this.schema_.columns;
      return temp || [];
    },
    displayColumns: function displayColumns() {
      return (0, _lodash.sortBy)((0, _lodash.filter)(this.columns, function (x) {
        return x.list !== false;
      }), function (x) {
        return x.list;
      });
    },
    to: function to() {
      var highBound = this.from + this.pagination.perPage;
      if (this.pagination.total < highBound) {
        highBound = this.pagination.total;
      }
      return highBound;
    },
    from: function from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    }
  },
  methods: {
    keyEvent: function keyEvent(e) {
      if (e.target == document.body && !this.embedded || e.target == this.$refs.container) {
        this._keyEvent(e);
      }
    },
    _keyEvent: function _keyEvent(e) {
      if (!e.ctrlKey && !e.altKey && !e.metaKey) {
        if (e.keyCode == 39) {
          this.$refs.pagination.nextPage();
          e.stopPropagation();
        } else if (e.keyCode == 37) {
          this.$refs.pagination.prevPage();
          e.stopPropagation();
        } else if (/^[a-z0-9 ,<.>/?`~[{\\|\]}'";:=+\-_]$/i.test(e.key)) {
          this.$refs.search.focus();
          e.stopPropagation();
        }
      }
    },
    rowTitle: function rowTitle(scope) {
      return this.schema_.title.call(this, scope.row, this.schema_);
    },
    rowId: function rowId(scope) {
      var spec = (0, _utils.findKeyField)(this.columns);
      return _utils.getField.call(this, scope.row, spec);
    },
    renderField: function renderField(spec, scope) {
      return spec.display.call(this, scope.row, scope.$index, spec, this.schema_, this.columns);
    },
    handleAction: function handleAction(btn) {
      var _this = this;

      btn.action.call(this, this.schema_, this.columns).then(function (refresh) {
        if (refresh) {
          _this.fetchData();
        }
      }).catch(function (err) {
        err = (0, _utils2.parseError)(err);
        _this.$notify({
          component: {
            template: '<span>' + err + '</span>'
          },
          icon: 'ti-alert',
          horizontalAlign: 'center',
          verticalAlign: 'top',
          type: 'danger'
        });
      });
    },
    handleCreate: function handleCreate() {
      var _this2 = this;

      this.schema_.create.call(this, this.schema_, this.columns).catch(function (err) {
        err = (0, _utils2.parseError)(err);
        _this2.$notify({
          component: {
            template: _index2.default.f('alert.html.$err', { err: err })
          },
          icon: 'ti-alert',
          horizontalAlign: 'center',
          verticalAlign: 'top',
          type: 'danger'
        });
      });
    },
    handleView: function handleView(row) {
      var _this3 = this;

      if (typeof this.schema_.view === 'function') {
        var p = this.schema_.view.call(this, row, 0, this.schema_, this.columns);
        if (p && typeof p.catch === 'function') {
          p.catch(function (err) {
            err = (0, _utils2.parseError)(err);
            _this3.$notify({
              component: {
                template: _index2.default.f('alert.html.$err', { err: err })
              },
              icon: 'ti-alert',
              horizontalAlign: 'center',
              verticalAlign: 'top',
              type: 'danger'
            });
          });
        }
      }
    },
    handleEdit: function handleEdit(scope) {
      var _this4 = this;

      var p = this.schema_.edit.call(this, scope.row, scope.$index, this.schema_, this.columns);
      if (p && typeof p.then === 'function') {
        p.then(function (refresh) {
          if (refresh) {
            _this4.fetchData();
          }
        }).catch(function (err) {
          err = (0, _utils2.parseError)(err);
          _this4.$notify({
            component: {
              template: '<span>Cannot edit item: ' + err + '</span>'
            },
            icon: 'ti-alert',
            horizontalAlign: 'center',
            verticalAlign: 'top',
            type: 'danger'
          });
        });
      }
    },
    handleDelete: function handleDelete(scope) {
      var _this5 = this;

      var p = this.schema_.delete.call(this, scope.row, scope.$index, this.schema_, this.columns);
      if (p && typeof p.then === 'function') {
        p.then(function (refresh) {
          if (refresh) {
            _this5.fetchData();
          }
          _this5.$notify({
            component: {
              template: '<p>Item deleted successfully</p>'
            },
            horizontalAlign: 'center',
            verticalAlign: 'top',
            type: 'success'
          });
        }).catch(function (err) {
          err = (0, _utils2.parseError)(err);
          _this5.$notify({
            component: {
              template: '<p>Cannot delete item: ' + err + '</p>'
            },
            icon: 'ti-alert',
            horizontalAlign: 'center',
            verticalAlign: 'top',
            type: 'danger'
          });
        });
      }
    },
    setData: function setData(data, total) {
      var _this6 = this;

      this.tableData = data || [];
      this.$nextTick(function () {
        _this6.pagination.total = total || data && data.length || 0;
        _this6.pagination.currentPage = Math.max(1, Math.min(_this6.pagination.currentPage, Math.ceil(_this6.pagination.total / _this6.pagination.perPage)));
        _this6.$emit('dataChanged', data, total);
      });
    },
    reload: function reload(keepData) {
      var _this7 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this7.loading = true;
                _this7.hideTable = true;_context.next = 4;
                return typeof _this7.schema === 'function' ? _this7.schema.call(_this7) : _this7.schema;

              case 4:
                _this7.schema_ = _context.sent;

                _this7.schemaParams = {};
                if (!keepData) {
                  _this7.setData([], 0);
                  _this7.searchQuery = '';
                }

                _this7.columnFilters = {};

                if (!_this7.schema_.tableFilters) {
                  _context.next = 19;
                  break;
                }

                if (!(typeof _this7.schema_.tableFilters === 'function')) {
                  _context.next = 15;
                  break;
                }

                _context.next = 12;
                return _this7.schema_.tableFilters.call(_this7, _this7.schema_);

              case 12:
                _context.t0 = _context.sent;
                _context.next = 16;
                break;

              case 15:
                _context.t0 = _this7.schema_.tableFilters;

              case 16:
                _this7.tableFilters = _context.t0;
                _context.next = 20;
                break;

              case 19:
                _this7.tableFilters = [];

              case 20:
                _context.next = 22;
                return new _promise2.default(function (ok) {
                  return _this7.$nextTick(ok);
                });

              case 22:
                if (!keepData) {
                  _this7.fetchData();
                }
                _this7.reloadColumnFilters();
                _this7.hideTable = false;
                _this7.loading = false;

              case 26:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this7);
      }))();
    },
    reloadColumnFilters: function reloadColumnFilters() {
      var _this8 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
        var filters, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, c, p, options;

        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                filters = {};
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context2.prev = 4;
                _iterator = (0, _getIterator3.default)(_this8.displayColumns);

              case 6:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context2.next = 18;
                  break;
                }

                c = _step.value;
                p = void 0;

                if ((0, _lodash.isArray)(c.filter)) {
                  p = c.filter;
                } else if (typeof c.filter === 'function') {
                  p = c.filter.call(_this8, c, _this8.schema_, _this8.columns);
                }

                if (!p) {
                  _context2.next = 15;
                  break;
                }

                _context2.next = 13;
                return p;

              case 13:
                options = _context2.sent;

                if (options) {
                  filters[c.prop] = (0, _lodash.map)(options, function (x) {
                    return (typeof x === 'undefined' ? 'undefined' : (0, _typeof3.default)(x)) === 'object' ? { text: _index2.default.fr(x.label), value: x.value } : { text: x, value: x };
                  });
                }

              case 15:
                _iteratorNormalCompletion = true;
                _context2.next = 6;
                break;

              case 18:
                _context2.next = 24;
                break;

              case 20:
                _context2.prev = 20;
                _context2.t0 = _context2['catch'](4);
                _didIteratorError = true;
                _iteratorError = _context2.t0;

              case 24:
                _context2.prev = 24;
                _context2.prev = 25;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 27:
                _context2.prev = 27;

                if (!_didIteratorError) {
                  _context2.next = 30;
                  break;
                }

                throw _iteratorError;

              case 30:
                return _context2.finish(27);

              case 31:
                return _context2.finish(24);

              case 32:
                _this8.columnFilters = filters;

              case 33:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this8, [[4, 20, 24, 32], [25,, 27, 31]]);
      }))();
    },
    columnFilterFn: function columnFilterFn(spec) {
      if (spec.filter) {
        return this.returnTrue;
      }
    },

    returnTrue: function returnTrue() {
      return true;
    },
    fetchData: function fetchData() {
      var _this9 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
        var payload, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, c, response;

        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this9.loading = true;
                payload = (0, _extends3.default)({}, _this9.initialFilter, {
                  skip: _this9.from,
                  limit: _this9.pagination.perPage,
                  sort: (0, _keys2.default)(_this9.sort).length ? _this9.sort : null,
                  search: _this9.searchQuery
                });

                if (!_this9.$refs.table) {
                  _context3.next = 22;
                  break;
                }

                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context3.prev = 6;

                for (_iterator2 = (0, _getIterator3.default)(_this9.$refs.table.store.states.columns); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  c = _step2.value;

                  if (c.filteredValue.length) {
                    payload[c.columnKey] = c.filteredValue;
                  }
                }
                _context3.next = 14;
                break;

              case 10:
                _context3.prev = 10;
                _context3.t0 = _context3['catch'](6);
                _didIteratorError2 = true;
                _iteratorError2 = _context3.t0;

              case 14:
                _context3.prev = 14;
                _context3.prev = 15;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 17:
                _context3.prev = 17;

                if (!_didIteratorError2) {
                  _context3.next = 20;
                  break;
                }

                throw _iteratorError2;

              case 20:
                return _context3.finish(17);

              case 21:
                return _context3.finish(14);

              case 22:
                _context3.prev = 22;
                _context3.next = 25;
                return _this9.schema_.list.call(_this9, payload, _this9.schema_, _this9.columns);

              case 25:
                response = _context3.sent;

                _this9.setData(response.data, response.total);
                _context3.next = 33;
                break;

              case 29:
                _context3.prev = 29;
                _context3.t1 = _context3['catch'](22);

                _context3.t1 = (0, _utils2.parseError)(_context3.t1);
                _this9.$notify({
                  component: {
                    template: _index2.default.fr('alert.html.cannot_fetch_list_$err', { err: _context3.t1 })
                  },
                  icon: 'ti-alert',
                  horizontalAlign: 'center',
                  verticalAlign: 'top',
                  type: 'danger'
                });

              case 33:
                _this9.loading = false;

              case 34:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this9, [[6, 10, 14, 22], [15,, 17, 21], [22, 29]]);
      }))();
    },

    queryChanged: (0, _lodash.debounce)(function () {
      this.fetchData();
    }, 500, { maxWait: 2000 }),
    sortChanged: function sortChanged(column) {
      if (column.prop) {
        this.sort = (0, _defineProperty3.default)({}, column.prop, column.order == 'descending' ? -1 : 1);
      } else {
        this.sort = {};
      }
      this.fetchData();
    },
    searchChanged: function searchChanged(query) {
      this.searchQuery = query;
    },
    filterChanged: function filterChanged() {
      this.fetchData();
    }
  },
  watch: {
    schema: function schema() {
      this.reload();
    },
    searchQuery: function searchQuery() {
      this.queryChanged();
    },
    'pagination.perPage': function paginationPerPage() {
      window.localStorage['pagination.perPage'] = this.pagination.perPage;
      this.fetchData();
    },
    'pagination.currentPage': function paginationCurrentPage() {
      this.fetchData();
    },
    'i18n.local': function i18nLocal() {
      this.reload(true);
    }
  }
};

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'drop-down',
  props: {
    title: String,
    icon: String,
    slide: {
      type: String,
      default: 'down'
    },
    tag: {
      type: String,
      default: 'div'
    }
  },
  computed: {
    getSlideClass: function getSlideClass() {
      return this.slide === 'down' ? 'dropdown' : 'dropup';
    }
  },
  data: function data() {
    return {
      isOpen: false
    };
  },

  methods: {
    toggleDropDown: function toggleDropDown() {
      this.isOpen = !this.isOpen;
    },
    closeDropDown: function closeDropDown() {
      this.isOpen = false;
    }
  }
};

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(19);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _stringify = __webpack_require__(37);

var _stringify2 = _interopRequireDefault(_stringify);

var _promise = __webpack_require__(7);

var _promise2 = _interopRequireDefault(_promise);

var _asyncToGenerator2 = __webpack_require__(18);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__(22);

var _extends3 = _interopRequireDefault(_extends2);

var _keys = __webpack_require__(16);

var _keys2 = _interopRequireDefault(_keys);

var _vueJsonExcel = __webpack_require__(467);

var _vueJsonExcel2 = _interopRequireDefault(_vueJsonExcel);

var _lodash = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'export-dialog',
  components: {
    JsonExcel: _vueJsonExcel2.default
  },
  props: {
    schema: Object,
    columns: Array,
    fields: Object,
    processRow: Function,
    $rootTable: Object
  },
  data: function data() {
    return {
      processing: false,

      type: 'csv',
      selectedColumns: [],
      data: []
    };
  },

  computed: {
    selectAll: {
      get: function get() {
        return !((0, _keys2.default)(this.displayColumns).length - this.selectedColumns.length);
      },
      set: function set(v) {
        this.selectedColumns = v ? (0, _keys2.default)(this.displayColumns) : [];
      }
    },
    displayColumns: function displayColumns() {
      return this.fields ? (0, _extends3.default)({}, this.fields) : (0, _lodash.filter)(this.columns, function (x) {
        return !x.hidden;
      }).reduce(function (acc, x) {
        acc[x.prop] = x.label;
        return acc;
      }, {});
    },
    fields_: function fields_() {
      var _this = this;

      return this.selectedColumns.reduce(function (acc, x) {
        acc[_this.displayColumns[x]] = x;
        return acc;
      }, {});
    }
  },
  methods: {
    downloadData: function downloadData() {
      var _this2 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.processing = '-';
                _context2.prev = 1;
                return _context2.delegateYield(_regenerator2.default.mark(function _callee() {
                  var data, offset, total, extra, fields, response, json;
                  return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          data = [];
                          offset = 0;
                          total = 0;
                          extra = 0;
                          fields = _this2.displayColumns;

                        case 5:
                          if (false) {
                            _context.next = 25;
                            break;
                          }

                          _context.next = 8;
                          return _this2.schema.list.call(_this2.$rootTable || _this2, { skip: offset, limit: 10, status: { $exists: true } });

                        case 8:
                          response = _context.sent;

                          total = response.total;

                          if (response.data.length) {
                            _context.next = 12;
                            break;
                          }

                          return _context.abrupt('break', 25);

                        case 12:
                          if (!(typeof _this2.processRow === 'function')) {
                            _context.next = 20;
                            break;
                          }

                          _context.t0 = data;
                          _context.next = 16;
                          return _promise2.default.all(response.data.map(function (row) {
                            return _this2.processRow.call(_this2.$rootTable || _this2, row, fields).then(function (x) {
                              ++offset;
                              if (Array.isArray(x) && x.length > 1) {
                                extra += x.length - 1;
                              }
                              _this2.processing = offset + ' / ' + total + ' (' + (total + extra) + ' rows)';
                              return x;
                            });
                          }));

                        case 16:
                          _context.t1 = _context.sent;
                          data = _context.t0.concat.call(_context.t0, _context.t1);
                          _context.next = 23;
                          break;

                        case 20:
                          data = data.concat(response.data);
                          offset += response.data.length;
                          _this2.processing = offset + ' / ' + total + ' (' + (total + extra) + ' rows)';

                        case 23:
                          _context.next = 5;
                          break;

                        case 25:
                          _this2.data = data.reduce(function (acc, x) {
                            return acc.concat(x);
                          }, []);
                          _context.next = 28;
                          return true;

                        case 28:
                          if (_this2.type === 'json') {
                            json = _this2.$refs.downloadButton.getProcessedJson(_this2.data, _this2.fields_);

                            _this2.$refs.downloadButton.export((0, _stringify2.default)(json, null, '  '), _this2.$refs.downloadButton.name, "application/json");
                          } else {
                            _this2.$refs.downloadButton.generate();
                          }

                        case 29:
                        case 'end':
                          return _context.stop();
                      }
                    }
                  }, _callee, _this2);
                })(), 't0', 3);

              case 3:
                _context2.next = 9;
                break;

              case 5:
                _context2.prev = 5;
                _context2.t1 = _context2['catch'](1);

                console.error(_context2.t1);
                alert(_context2.t1.message);

              case 9:
                _this2.processing = false;

              case 10:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[1, 5]]);
      }))();
    }
  },
  mounted: function mounted() {
    this.selectedColumns = (0, _keys2.default)(this.displayColumns);

    this.$refs.downloadButton.base64ToBlob = function (data, mime) {
      return new Blob(['\uFEFF', data], { type: mime });
    };
    this.$refs.downloadButton.jsonToCSV = function (data) {
      var quote = function quote(s) {
        s = s + '';
        if (s.match(/[,"\n]/)) {
          s = '"' + s.replace(/"/g, '""') + '"';
        }
        return s;
      };
      var csvData = '';
      if (this.title != null) {
        csvData += quote(this.title) + '\r\n';
      }
      for (var key in data[0]) {
        csvData += quote(key) + ',';
      }
      csvData = csvData.slice(0, csvData.length - 1);
      csvData += '\r\n';
      data.map(function (item) {
        for (var _key in item) {
          csvData += quote(item[_key]) + ',';
        }
        csvData = csvData.slice(0, csvData.length - 1);
        csvData += '\r\n';
      });
      return csvData;
    };
  }
};

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'p-checkbox',
  model: {
    prop: 'checked'
  },
  props: {
    checked: [Array, Boolean],
    disabled: [Boolean, String],
    inline: Boolean
  },
  data: function data() {
    return {
      cbId: ''
    };
  },

  computed: {
    model: {
      get: function get() {
        return this.checked;
      },
      set: function set(check) {
        this.$emit('input', check);
      }
    },
    inlineClass: function inlineClass() {
      if (this.inline) {
        return 'checkbox-inline';
      }
    }
  },
  created: function created() {
    this.cbId = Math.random().toString(16).slice(2);
  }
};

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'p-radio',
  model: {
    prop: 'value'
  },
  props: {
    label: [String, Number],
    disabled: [Boolean, String],
    value: [String, Boolean],
    type: {
      type: String,
      default: 'neutral'
    }
  },
  data: function data() {
    return {
      cbId: ''
    };
  },

  computed: {
    model: {
      get: function get() {
        return this.value;
      },
      set: function set(value) {
        this.$emit('input', value);
      }
    }
  },
  created: function created() {
    this.cbId = Math.random().toString(16).slice(2);
  }
};

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'fg-input',
  props: {
    type: {
      type: String,
      default: 'text'
    },
    label: String,
    name: String,
    disabled: Boolean,
    placeholder: String,
    value: [String, Number]
  }
};

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'p-pagination',
  props: {
    type: {
      type: String,
      default: 'default'
    },
    pageCount: {
      type: Number,
      default: 0
    },
    perPage: {
      type: Number,
      default: 10
    },
    total: {
      type: Number,
      default: 0
    },
    value: {
      type: Number,
      default: 1
    }
  },
  computed: {
    paginationClass: function paginationClass() {
      return 'pagination-' + this.type;
    },
    totalPages: function totalPages() {
      if (this.pageCount > 0) return this.pageCount;
      if (this.total > 0) {
        return Math.ceil(this.total / this.perPage);
      }
      return 1;
    },
    pagesToDisplay: function pagesToDisplay() {
      if (this.totalPages > 0 && this.totalPages < this.defaultPagesToDisplay) {
        return this.totalPages;
      }
      return this.defaultPagesToDisplay;
    },
    minPage: function minPage() {
      if (this.value >= this.pagesToDisplay) {
        var pagesToAdd = Math.floor(this.pagesToDisplay / 2);
        var newMaxPage = pagesToAdd + this.value;
        if (newMaxPage > this.totalPages) {
          return this.totalPages - this.pagesToDisplay + 1;
        }
        return this.value - pagesToAdd;
      } else {
        return 1;
      }
    },
    maxPage: function maxPage() {
      if (this.value >= this.pagesToDisplay) {
        var pagesToAdd = Math.floor(this.pagesToDisplay / 2);
        var newMaxPage = pagesToAdd + this.value;
        if (newMaxPage < this.totalPages) {
          return newMaxPage;
        } else {
          return this.totalPages;
        }
      } else {
        return this.pagesToDisplay;
      }
    }
  },
  data: function data() {
    return {
      defaultPagesToDisplay: 5
    };
  },

  methods: {
    range: function range(min, max) {
      var arr = [];
      for (var i = min; i <= max; i++) {
        arr.push(i);
      }
      return arr;
    },
    changePage: function changePage(item) {
      this.$emit('input', item);
    },
    nextPage: function nextPage() {
      if (this.value < this.totalPages) {
        this.$emit('input', this.value + 1);
      }
    },
    prevPage: function prevPage() {
      if (this.value > 1) {
        this.$emit('input', this.value - 1);
      }
    },
    handlePageChange: function handlePageChange() {
      if (this.value >= this.pagesToDisplay) {
        var pagesToAdd = Math.floor(this.pagesToDisplay / 2);
        this.minPage = this.value - pagesToAdd;
        var newMaxPage = pagesToAdd + this.value;
        if (newMaxPage < this.total) {
          this.maxPage = newMaxPage;
        } else {
          this.maxPage = this.total;
          this.minPage = this.total - this.pagesToDisplay + 1;
        }
      } else {
        this.minPage = 1;
        this.maxPage = this.pagesToDisplay;
      }
    }
  },
  watch: {
    perPage: function perPage(value) {
      this.$emit('input', 1);
    },
    maxPage: function maxPage(value) {
      if (this.value > value) {
        this.$emit('input', value);
      }
    }
  }
};

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {};

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    moveY: {
      type: Number,
      default: 0
    }
  },
  computed: {
    arrowStyle: function arrowStyle() {
      return {
        transform: "translate3d(0px, " + this.moveY + "px, 0px)"
      };
    }
  }
};

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(19);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(18);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _defineProperty2 = __webpack_require__(12);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _collapseTransition = __webpack_require__(92);

var _collapseTransition2 = _interopRequireDefault(_collapseTransition);

var _i18n = __webpack_require__(2);

var _i18n2 = _interopRequireDefault(_i18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: (0, _defineProperty3.default)({}, _collapseTransition2.default.name, _collapseTransition2.default),
  props: {
    title: {
      type: String
    },
    type: {
      type: String,
      default: 'sidebar',
      validator: function validator(value) {
        var acceptedValues = ['sidebar', 'navbar'];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    backgroundColor: {
      type: String,
      default: 'black',
      validator: function validator(value) {
        var acceptedValues = ['white', 'brown', 'black'];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    activeColor: {
      type: String,
      default: 'success',
      validator: function validator(value) {
        var acceptedValues = ['primary', 'info', 'success', 'warning', 'danger'];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    logo: {
      type: String,
      default: '/static/img/logo.png'
    },
    sidebarLinks: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  computed: {
    sidebarClasses: function sidebarClasses() {
      if (this.type === 'sidebar') {
        return 'sidebar';
      } else {
        return 'collapse navbar-collapse off-canvas-sidebar';
      }
    },
    navClasses: function navClasses() {
      if (this.type === 'sidebar') {
        return 'nav';
      } else {
        return 'nav navbar-nav';
      }
    },
    arrowMovePx: function arrowMovePx() {
      return this.linkHeight * this.linkCountFromTop + 5 * this.menuCountFromTop;
    }
  },
  data: function data() {
    return {
      linkHeight: 52,
      linkCountFromTop: 0,
      menuCountFromTop: 0,
      windowWidth: 0,
      isWindows: false,
      hasAutoHeight: false,
      currentActiveMenu: {}
    };
  },

  methods: {
    findActiveLink: function findActiveLink() {
      var _this = this;

      if (!this.$route) return;
      this.linkCountFromTop = 0;
      this.menuCountFromTop = 0;
      this.sidebarLinks.every(function (menu) {
        var hasChildren = menu.children;
        var isActive = _this.isMenuActive(menu);
        if (!isActive) {
          _this.linkCountFromTop = hasChildren ? _this.linkCountFromTop + 1 : _this.linkCountFromTop;
          _this.menuCountFromTop = hasChildren ? _this.menuCountFromTop + 1 : _this.menuCountFromTop;
          if (hasChildren && !menu.collapsed) {
            _this.linkCountFromTop += menu.children.length;
          }
        } else {
          if (hasChildren && !menu.collapsed) {
            _this.menuCountFromTop++;
            menu.children.every(function (subMenu) {
              var isActive = subMenu.path === _this.$route.path;
              _this.linkCountFromTop++;
              return !isActive;
            });
          }
        }
        return !isActive;
      });
    },
    isMenuActive: function isMenuActive(menu) {
      var _this2 = this;

      if (!this.$route) return false;
      if (menu.path === this.$route.path) {
        this.currentActiveMenu = menu;
        return true;
      }
      if (menu.children) {
        var child = menu.children.find(function (child) {
          return child.path === _this2.$route.path;
        });
        if (child) {
          this.currentActiveMenu = menu;
          return true;
        }
      }
      return false;
    },
    elementType: function elementType(link) {
      var isParent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      if (link.isRoute === false) {
        return isParent ? 'li' : 'a';
      } else {
        return 'router-link';
      }
    },
    collapseMenu: function collapseMenu(index) {
      var link = this.sidebarLinks[index];
      link.collapsed = !link.collapsed;
      this.findActiveLink();
    },
    linkAbbreviation: function linkAbbreviation(name) {
      var matches = name.match(/\b(\w)/g);
      return matches ? matches.join('').substr(0, 2) : '';
    },
    initScrollBarAsync: function initScrollBarAsync() {
      var _this3 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        var PerfectScroll;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 592));

              case 2:
                _context.next = 4;
                return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 595));

              case 4:
                PerfectScroll = _context.sent;

                PerfectScroll.initialize(_this3.$refs.sidebarScrollArea);

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    }
  },
  mounted: function mounted() {
    this.findActiveLink();
    if (this.currentActiveMenu && this.currentActiveMenu.collapsed) {
      this.currentActiveMenu.collapsed = false;
    }
    this.initScrollBarAsync();
  },
  created: function created() {
    this.$sidebar.options.vm = this;
  },
  beforeDestroy: function beforeDestroy() {
    if (this.$sidebar.showSidebar) {
      this.$sidebar.showSidebar = false;
    }
  },

  watch: {
    $route: function $route(newRoute, oldRoute) {
      this.findActiveLink();
    }
  }
};

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(12);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _collapseTransition = __webpack_require__(92);

var _collapseTransition2 = _interopRequireDefault(_collapseTransition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: (0, _defineProperty3.default)({}, _collapseTransition2.default.name, _collapseTransition2.default),
  data: function data() {
    return {
      isClosed: true
    };
  },

  methods: {
    toggleMenu: function toggleMenu() {
      this.isClosed = !this.isClosed;
    }
  }
};

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'p-switch',
  props: {
    label: String,
    value: [Array, Boolean],
    disabled: [Boolean, String],
    onText: String,
    offText: String,
    type: {
      type: String,
      default: ''
    }
  },
  computed: {
    switchClass: function switchClass() {
      var base = 'bootstrap-switch-';
      var state = this.model ? 'on' : 'off';
      return base + state;
    },

    model: {
      get: function get() {
        return this.value;
      },
      set: function set(value) {
        this.$emit('input', value);
      }
    }
  },
  methods: {
    triggerToggle: function triggerToggle() {
      this.model = !this.model;
    }
  }
};

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = __webpack_require__(27);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'render',
  props: {
    render: Function,
    component: Object,
    data: Object,
    auto: {}
  },
  render: function render(createElement) {
    if (this.render) {
      return this.render(createElement);
    } else if (this.component) {
      return createElement(this.component, this.data);
    } else if (typeof this.auto === 'function') {
      return this.auto(createElement);
    } else if (this.auto != null && (0, _typeof3.default)(this.auto) === 'object' && (this.auto.template != null || typeof this.auto.render === 'function')) {
      return createElement(this.auto);
    } else if (this.auto != null) {
      return this._v(this.auto);
    }
    return null;
  }
};

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {};

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  local: 'en',

  role: {
    member: 'Member',
    cashier: "Cashier",
    npc: 'Non-person character',
    admin: 'Admin',
    superadmin: 'Super Admin'
  },

  type: {
    login: {
      fb: 'Facebook',
      wechat: 'WeChat',
      emailPwd: 'Email & Password'
    },
    temp_token: {
      forget_password: 'forget_password',
      verifyEmail: 'verifyEmail'
    },
    mediaProfile: {
      png: 'png',
      jpg: 'jpg'
    },
    notification_type: {
      appointment: "appointment"
    },
    notification_sub_type: {
      new_appointment: "new_appointment",
      new_urgent_appointment: "new_urgent_appointment",
      job_notice_for_caregiver: "job_notice_for_caregiver",

      no_suitable_candidates: "no_suitable_candidates",
      no_caregiver_confirm: "no_caregiver_confirm",
      cancelled_by_client: "cancelled_by_client",
      accepted_by_caregiver: "accepted_by_caregiver",
      cancelled_by_caregiver: "cancelled_by_caregiver"
    },
    transaction: {
      purchase: 'Purchase',
      penalty: 'Penalty',
      refund: 'Refund',
      extra_pay: 'Extra Payment',
      standalone: 'Standalone',
      rapid: 'Rapid Payment',
      caregiver_invoice: '${i18n.schema.caregiver} ${i18n.schema.invoice}'
    },
    coupon: {
      one_time: "One time",
      unlimited_time: "Unlimited time" },
    feedback: {
      admin_to_caregiver: 'Admin to Caregiver',
      admin_to_client: 'Admin to Client',
      client_appointment_feedback: 'Client Appointment Feedback',
      client_to_caregiver: 'Client Appointment Feedback',
      caregiver_appointment_feedback: 'Caregiver Appointment Feedback'
    }
  },

  status: {
    inactive: 'Inactive',
    active: 'Active',
    deleted: 'Deleted',
    archived: 'Archived',
    not_verified: 'Not Verified',
    verified: 'Verified',

    success: 'Success',
    failed: 'Failed',

    enabled: 'Enabled',
    disabled: 'Disabled',

    waiting_admin_approve: 'Waiting admin approve',
    matching_helper: 'Matching Helper',
    waiting_helper_confirm: "Waiting helper confirm",
    waiting_admin_confirm: 'Waiting admin confirm',
    confirmed: 'Confirmed',
    in_progress: 'In progress',
    waiting_review: 'Waiting review',
    waiting_client_feedback: 'Waiting client feedback',
    waiting_helper_feedback: 'Waiting helper feedback',
    completed: 'Completed',
    incomplete: 'Incomplete',
    cancelled_by_sender: 'Cancelled by sender',

    pending: "Pending",
    accepted: "Accepted",
    rejected: "Rejected",
    cancelled: "Cancelled",
    approved: 'Approved',

    arrived: 'Arrived',
    left: 'Left',
    reported: 'Reported Task',
    feedbacked: 'Feedback Submitted',
    send_invoice: 'Invoice sent',
    invoice_sent: 'Invoice sent',
    complete: 'Completed',
    absent: 'Absent',
    late: 'Late'
  },
  gender: {
    m: 'Male',
    f: 'Female'
  },

  alert: {
    html: {
      cannot_fetch_item_$err: '<span>Cannot fetch item: ${err}</span>',
      cannot_fetch_list_$err: '<span>Cannot fetch list: ${err}</span>',
      $err: '<span>${err}</span>',
      record_updated_successfully: '<span>Record updated successfully</span>',
      record_saved_successfully: '<span>Record saved successfully</span>',
      file_uploaded_successfully: '<span>File uploaded successfully</span>',
      no_subprofile: 'Missing service user',
      no_subprofile_desc: 'The member does not have any service user. Please create one first.',
      confirm_force_assign_job_to_this_member: 'Are you sure to assign this member?',
      confirm_force_assign_job_to_this_member_ignore_accepted: 'Do you till want to force assign this member?<br/>Someone has already accepted.',
      time_clash_$appointments: 'Cooldown time clash detected for this caregiver:<br/><ul>${appointments.map(function(x){return "<li>" + x + "</li>"})}</ul><br/>Still assign?',
      not_available_days_$days: 'Caregiver is not available at the time:<br/><ul>${days.map(function(x){return "<li>" + x + "</li>"})}</ul><br/>Still assign?',
      confirm_delete_$str: 'Confirm delete ${str}?',
      confirm_action_$action: 'Confirm ${action}?',
      update_linked_subprofile: '\nThis will update the ${i18n.schema.subprofile} of:<br/>\n<ul>\n    <li>the current ${i18n.schema.appointment}</li>\n    <li>${i18n.schema.subprofile} for future created ${i18n.schema.appointments}</li>\n    <li>${i18n.schema.subprofile} for future created ${i18n.schema.orders}</li>\n</ul><br/>\nConfirm?',
      update_subprofile: 'This will update the ${i18n.schema.subprofile} of the current ${i18n.schema.appointment}<br/>Confirm?',
      confirm_complete_invoice: 'Confirm marking invoice completed?',
      warn_modify_status: '<span style="color: red">Changing status manually may affect normal system workflow, not recommended.</span>'
    },
    empty_response: 'Empty response',
    invalid_response: 'Invalid response from server',
    please_choose_an_item_by_clicking_a_row: 'Please click on a row to choose an item.',
    force_assign_job_add_only: 'Do you want to assign the caregiver now or only add to pending list?\n\n[OK]: Assign, [Cancel]: Add only.'
  },
  html: {
    nil: '<small style="opacity: .5;"><i>&lt;nil&gt;</i></small>',
    loading: '<i>${i18n.loading}</i>',
    not_found: '<i>Not Found</i>',
    empty: '<i>&lt;empty&gt;</i>'
  },
  loading: 'Loading...',
  updated_at_$time: 'Updated at ${time}',
  application_title: 'OK CARE Admin Panel',
  nil: '<nil>',
  label_compulsory: '(compulsory)',
  label_pick_a_month: 'Pick a month',
  label_pick_a_profession: 'Pick a Profession',
  create_schema_$name: 'Create New ${name}',
  update_schema_$name: 'Update ${name}',
  schema_$name_details: '${name} Details',
  admin: 'Admin',
  ecommerce: 'E-Commerce',
  pagination_footer: 'Showing ${from} to ${to} of ${total} entries',
  search_placeholder: 'Search...',
  search_records_placeholder: 'Search records',
  disk_usage: 'Disk Usage',
  ram_usage: 'RAM Usage',
  cpu_usage: 'CPU Usage',
  revenue: 'Revenue',
  revenue_$income_$refund: 'income: $${income}, refund: $${refund}',
  cancelled_by_caregiver: '${i18n.schema.appointments} cancelled by ${i18n.schema.caregiver}',
  complaint: 'Complaint',
  complaints: 'Complaints',
  not_interviewed: 'Not interviewed',
  appointment_requests_$total_$urgent: '${total} ${urgent ? "(" + urgent + " urgent)" : ""}',
  pending_invoices: 'Pending Invoices',
  no_name: 'No Name',
  menu: {
    overview: 'Overview',
    members: 'Memberships',
    appointments: 'Booking Management',
    ecommerce: 'Order Management',
    admin: 'Administration',
    feedbacks: 'Rating Management',
    notifications: 'Notification',
    systemconfigs: 'System Configuration',
    reports: 'Reporting'
  },
  schema: {
    member: 'Membership',
    members: 'Memberships',
    admin: 'Administrator',
    admins: 'Administrators',
    caregiver: 'Caregiver',
    caregivers: 'Caregivers',
    client: 'Client',
    clients: 'Clients',
    subprofile: 'Service User',
    subprofiles: 'Service Users',
    linked_subprofiles: 'Linked Service Users for future use',
    group: 'Profession',
    groups: 'Professions',
    group_application: 'Profession Application',
    group_applications: 'Profession Applications',
    group_apply: 'Apply Profession',
    appointment: 'Booking',
    appointments: 'Bookings',
    appointment_request: 'Booking Request',
    appointment_requests: 'Booking Requests',
    order: 'Order',
    orders: 'Orders',
    transaction: 'Transaction',
    transactions: 'Transactions',
    invoice: 'Invoice',
    invoices: 'Invoices',
    standalone_transaction: 'Standalone Transaction',
    rapid_payment: 'Rapid Payment',
    refund_transaction: 'Refund',
    payment: 'Payment',
    payments: 'Payments',
    product: 'Product',
    products: 'Products',
    service: 'Service',
    services: 'Services',
    coupon: 'Coupon',
    coupons: 'Coupons',
    feedback: 'Feedback',
    feedbacks_admin: 'Feedbacks (Admin)',
    feedbacks_admin_caregiver: '${i18n.type.feedback.admin_to_caregiver}',
    feedbacks_admin_client: '${i18n.type.feedback.admin_to_client}',
    feedbacks_caregiver: 'Feedbacks (Care Giver)',
    feedbacks_client: 'Feedbacks (Client)',
    feedback_admin: 'Feedback (Admin)',
    feedback_caregiver: 'Feedback (Care Giver)',
    feedback_client: 'Feedback (Client)',
    notification: 'Notification',
    notifications: 'Notifications',
    systemnotification: 'System Notification',
    systemnotifications: 'System Notifications',
    adminsendout: 'Admin Send-out',
    adminsendouts: 'Admin Send-outs',
    email: 'Email',
    emails: 'Emails',
    systemconfig: 'System Config',
    systemconfigs: 'System Configs',
    enquiry: 'Enquiry',
    enquiries: 'Enquiries',
    enquiry_questionnaire: 'Questionnaire',
    enquiry_questionnaires: 'Questionnaires',
    log: 'Log',
    logs: 'Logs',
    content: 'Content',
    contents: 'Content Management',
    'content-joinus-input_form': 'Join Us (input form)',
    'content-area-content': 'Area Content',
    'content-purchase-latest_booking': 'Purchase (latest booking)',
    'content-purchase-new_order': 'Purchase (new order)',
    'content-joinus-banner_top': 'Join Us (banner top)',
    'content-our_services_page-whyus_features': 'Our Services (why us - features section)',
    'content-our_services_page-overlabel': 'Our Services (over-label)',
    'content-our_services_page-banner_bottom': 'Our Services (banner bottom)',
    'content-our_services_page-download_top': 'Our Services (download top)',
    'content-our_services_page-whyus_middle': 'Our Services (why us - middle section)',
    'content-our_services_page-our_services_details': 'Our Services (details)',
    'content-content-faq': 'Faq',
    'content-aboutus-tri': 'About Us (tri)',
    'content-aboutus-bridge': 'About Us (bridge)',
    'content-aboutus-middle': 'About Us (middle)',
    'content-aboutus-plain_text': 'About Us (plain text)',
    'content-recruitment': 'Recruitment',
    post: 'Post',
    posts: 'Posts'
  },
  fields: {
    display_name_$first_$last: '${first} ${last}',
    years_old_$yrs: '${yrs} years old',
    array_item_$i: '# ${i}',
    cat: {
      default: 'misc.',
      general: 'General',
      client: '${i18n.schema.client}',
      caregiver: '${i18n.schema.caregiver}',
      subprofile: '${i18n.schema.subprofile}'
    },
    currency: {
      cash_hkd: 'HKD',
      cash_rmb: 'RMB',
      cash_usd: 'USD'
    },
    medical_histories: {
      disease: {
        heart_disease: 'Heart Disease',
        cancer: 'Cancer',
        hypertension: 'Hypertension',
        stroke: 'Stroke',
        diabetes: 'Diabetes',
        genetic_disease: 'Genetic Disease'
      },
      currentStatus: {
        stomach_throat: 'Stomach Throat',
        urinary_throat: 'Urinary Throat',
        bed_sores: 'Bed Sores',
        need_an_injection: 'Need an injection',
        wounds_after_surgery: 'Wounds after surgery'
      }
    },
    content_types: {
      appointment: '${i18n.schema.appointment}',
      membership: '${i18n.schema.member}',
      ecommerce: 'E-Commerce',
      system: 'System'
    },
    service_areas: {
      hki: 'Hong Kong Island',
      kl: 'Kowloon',
      nt: 'New Territories',
      isl: 'Islands'
    },
    roles: {
      member: 'Member',
      admin: 'Admin',
      superadmin: 'Super Admin'
    },
    init_login_types: {
      emailPwd: '${i18n.fields.email}',
      sms: '${i18n.fields.phone}'
    },
    id: 'ID',
    member_id: '${i18n.schema.member} ${i18n.fields.id}',
    subprofile_id: '${i18n.schema.subprofile} ${i18n.fields.id}',
    subprofile: '${i18n.schema.subprofile}',
    subProfile: '${i18n.schema.subprofile}',
    subprofiles: '${i18n.schema.subprofiles}',
    subProfiles: '${i18n.schema.subprofiles}',
    group_id: '${i18n.schema.group} ${i18n.fields.id}',
    group: '${i18n.schema.group}',
    groups: 'Qualified tasks',
    service_id: '${i18n.schema.service} ${i18n.fields.id}',
    appointment_id: '${i18n.schema.appointment} ${i18n.fields.id}',
    appointment: '${i18n.schema.appointment}',
    appointments: '${i18n.schema.appointments}',
    order_id: '${i18n.schema.order} ${i18n.fields.id}',
    order: '${i18n.schema.order}',
    orders: '${i18n.schema.orders}',
    feedback_id: '${i18n.schema.feedback} ${i18n.fields.id}',
    content_id: '${i18n.schema.content} ${i18n.fields.id}',
    coupon_id: '${i18n.schema.coupon} ${i18n.fields.id}',
    coupon_code: '${i18n.schema.coupon} Code (Case sensitive)',
    notification_id: '${i18n.schema.notification} ${i18n.fields.id}',
    transaction_id: '${i18n.schema.transaction} ${i18n.fields.id}',
    transaction: '${i18n.schema.transaction}',
    transactions: '${i18n.schema.transactions}',
    product_id: '${i18n.schema.product} ${i18n.fields.id}',
    product: '${i18n.schema.product}',
    products: '${i18n.schema.products}',
    payment_id: '${i18n.schema.payment} ${i18n.fields.id}',
    payment: '${i18n.schema.payment}',
    payments: '${i18n.schema.payments}',
    email: 'Email',
    phone: 'Mobile no.',
    phone_placeholder: 'Please include country code, i.e.: 852xxxxxxxx',
    pwd: 'Password',
    role: 'Role',
    timeslot: 'Time slot',
    feature: 'Feature',
    created_at: 'Created at',
    updated_at: 'Updated at',
    expired_at: 'Expired at',
    status: 'Status',
    self_status: 'Status',
    tags: 'Tags',
    type: 'Type',
    basicInfo_fulfilled: 'Basic info fulfilled',
    email_fulfilled: 'Email fulfilled',
    init_login_type: 'Initial login type',
    details: 'Details',
    verification: 'Verification',
    activation_code: 'Activation code',
    apply_group: 'Apply ${i18n.schema.group}',
    finished_interview: 'Finished interview',
    add_subprofile: '${i18n.action.add} ${i18n.schema.subprofile}',
    my_subprofiles: 'My ${i18n.schema.subprofiles}',
    my_appointments: 'My ${i18n.schema.appointments}',
    my_jobs: 'My Jobs',
    my_orders: 'My ${i18n.schema.orders}',
    subprofiles_count: '# of ${i18n.schema.subprofiles}',
    pending_group: '${i18n.schema.group}',
    pending_status: 'Status',
    remark: 'Remark',
    order_remarks: '${i18n.schema.order} ${i18n.fields.remark}',
    score: 'Score',
    scores: 'Scores',
    question: 'Question',
    avg_score: 'Avg. Score',
    action: ' Action',
    sender: 'Sender',
    receiver: 'Receiver',
    recipient: 'Recipient',
    refs_appointment: 'Reference ${i18n.schema.appointment}',
    profile: 'Profile',
    relationship: 'Relationship',
    service_location: 'Service Location',
    user_experience: 'User Experience',
    emergency_contact: 'Emergency Contact',
    user_condition: 'User Condition',
    medical_history: 'Medical History',
    stat: 'Statistics',
    view: 'Views',
    click: 'Clicks',
    creator: 'Creator',
    created_by: '${i18n.fields.creator}',
    first_name: 'First Name',
    last_name: 'Last Name',
    other_name: 'Other Names',
    gender: 'Gender',
    hkid: 'HKID',
    mobile: 'Mobile no.',
    home_tel: 'Home no.',
    age: 'Age',
    birthday: 'Date of Birth',
    height: 'Height (m)',
    weight: 'Weight (kg)',
    ratio: 'Ratio',
    name: 'Name',
    room: 'Room',
    flat: 'Flat',
    floor: 'Floor',
    block: 'Block',
    building: 'Building',
    street: 'Street',
    area: 'Area',
    district: 'District',
    detail: '${i18n.fields.details}',
    required_groups: 'Required ${i18n.schema.groups}',
    product_ids: '${i18n.schema.products}',
    value_options: 'Value Options',
    quota: 'Quota',
    quota_per_user: 'Quota per user',
    currency_type: 'Currency type',
    currency_amount: 'Currency amount',
    used_by: 'Usage history',
    used_at: 'Used at',
    member: '${i18n.schema.member}',
    read: 'Read',
    content_type: 'Content type',
    content: 'Content',
    title: 'Title',
    code: 'Code',
    sub_type: 'Sub type',
    admin: 'Is Admin?',
    expiry_date: '${i18n.fields.expired_at}',
    from: 'From',
    to: 'To',
    tickets: 'Tickets',
    total_tickets: 'Total ${i18n.fields.tickets}',
    available_tickets: 'Available ${i18n.fields.tickets}',
    progress_status: 'Progress Status',
    service_date: 'Service Date',
    language: 'Language',
    notification: 'Notification',
    sms: 'SMS',
    app_config: 'User Preference',
    address: 'Address',
    custom: 'Special Item',
    customs: 'Special Items',
    custom_id: '${i18n.fields.id}',
    custom_ids: '${i18n.fields.customs}',
    required_custom_types: 'Compulsory Items',
    timeslots: 'Service Timeslots',
    owners: 'Owners',
    value: 'Value',
    description: 'Description',
    price_options: 'Price Options',
    inventory: 'Inventory',
    inventory_unlimited: 'Unlimited Inventory',
    privacy: 'Permission Level',
    days_to_expiry: 'Days to expiry',
    reason: 'Reason',
    photo: 'Photo',
    transaction_code: 'Payment Code',
    ref: 'References',
    total_amount: 'Total Amount',
    refund_amount: 'Refund Amount (should be negative)',
    expected_start_date: 'Expected start date',
    quantity: 'Quantity',
    order_remark: 'Remarks',
    log_write_requests: 'Log requests with write operations',
    caregiver_report: '${i18n.schema.caregiver} Report',
    potential_recipients: 'Potential ${i18n.schema.caregivers}',
    potential_recipient_status: '${i18n.schema.caregiver} ${i18n.fields.status}',
    potential_recipients_count: '# of ${i18n.schema.caregiver}',
    show_cancelled_recipients: 'Show cancelled ${i18n.schema.caregivers}',
    transaction_progress: 'Transaction Progress',
    list_order: 'List Order',
    notes: 'Notes',
    working_history: 'Working History',
    working_experience: 'Working Experience',
    certificates: 'Certificates',
    marriage_status: 'Marriage Status',
    bank_account: 'Bank Account',
    bank_type: 'Bank',
    referral: 'Referral',
    signed_contract: 'Has signed contract',
    working_visa: 'Has issued working Visa',
    company: 'Company',
    startDate: 'Start',
    endDate: 'End',
    fulltime: 'Full-time',
    issuer: 'Issuer',
    promotion: 'Receive Promotion',
    is_promotion: 'Is Promotional?',
    profile_pic: 'Profile Pic',
    unit_amount: 'Unit Amount',
    location_fee: 'Location Fee',
    records: 'Records',
    reset_password: 'Reset password',
    new_password: 'New password',
    confirm_password: 'Confirm password',
    payment_gateway_err: '3rd party payment gateway error',
    editable: 'Editable',
    years_of_experience: 'Years of Experience',
    receivers: 'Receivers',
    ticket_required: 'Ticket Required',
    invoice_completed: 'Invoice Paid'
  },
  action: {
    ok: 'OK',
    yes: 'Yes',
    no: 'No',
    cancel: 'Cancel',
    save: 'Save',
    create: 'Create',
    duplicate: 'Duplicate',
    add: 'Add',
    back: 'Back',
    update: 'Update',
    upload: 'Upload',
    upload_replace: 'Upload and Replace',
    reload: 'Refresh',
    undo: 'Undo',
    download: 'Download',
    assign_job_to_this_member: 'Assign job to this ${i18n.schema.caregiver}',
    force_assign_job_to_this_member: 'Force assign job to this ${i18n.schema.caregiver}',
    force_assign_job: 'Manually assign ${i18n.schema.caregiver}',
    create_$obj: 'Create ${obj}',
    add_new_$obj: 'Add New ${obj}',
    export_data: 'Export Data',
    export_$obj: 'Export ${obj}',
    complete_appointment: 'Complete ${i18n.schema.appointment}',
    show_inactive: 'Show inactive',
    send_feedback_to_caregiver: 'Feedback to ${i18n.schema.caregiver}',
    send_feedback_to_client: 'Feedback to ${i18n.schema.client}',
    approve: 'Approve',
    reject: 'Reject',
    login: 'Login',
    logout: 'Logout',
    read: 'Mark as Read',
    unread: 'Mark as Unread',
    delete: 'Delete',
    clear_tokens: 'Clear Login Sessions',
    apply: 'Apply',
    click_to_$action: 'Click to ${action}',
    finished_interview: '${i18n.fields.finished_interview}',
    distribute_job: 'Re-distribute Job',
    choose_$obj: 'Choose ${obj} ...',
    reformat_code: 'Reformat',
    view_invoice: 'View ${i18n.schema.invoice}',
    complete_invoice: 'Complete ${i18n.schema.invoice}',
    import_members: 'Import ${i18n.schema.members}',
    update_stat: 'Update Statistics'
  }
};

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  local: 'zh-hk',

  role: {
    member: '會員',
    cashier: "收銀",
    npc: '系統賬號',
    admin: '管理員',
    superadmin: '超級管理員'
  },

  type: {
    login: {
      fb: 'fb',
      wechat: 'wechat',
      emailPwd: 'emailPwd'
    },
    temp_token: {
      forget_password: 'forget_password',
      verifyEmail: 'verifyEmail'
    },
    mediaProfile: {
      png: 'png',
      jpg: 'jpg'
    },
    notification_type: {
      appointment: "appointment"
    },
    notification_sub_type: {
      new_appointment: "new_appointment",
      new_urgent_appointment: "new_urgent_appointment",
      job_notice_for_caregiver: "job_notice_for_caregiver",

      no_suitable_candidates: "no_suitable_candidates",
      no_caregiver_confirm: "no_caregiver_confirm",
      cancelled_by_client: "cancelled_by_client",
      accepted_by_caregiver: "accepted_by_caregiver",
      cancelled_by_caregiver: "cancelled_by_caregiver"
    },
    transaction: {
      purchase: '購買',
      penalty: '罰款',
      refund: '退款',
      extra_pay: '附加費',
      standalone: '獨立交易',
      rapid: '快速付款',
      caregiver_invoice: '${i18n.schema.caregiver}${i18n.schema.invoice}'
    },
    coupon: {
      one_time: "一次",
      unlimited_time: "無限" },
    feedback: {
      admin_to_caregiver: '管理員評價護理員',
      admin_to_client: '管理員評價客戶',
      client_appointment_feedback: '客戶評價',
      client_to_caregiver: '客戶評價',
      caregiver_appointment_feedback: '護理員評價'
    }
  },

  status: {
    inactive: '停用',
    active: '啟用',
    deleted: '已删除',
    archived: '已封存',
    not_verified: '未驗證',
    verified: '已驗證',

    success: '成功',
    failed: '失敗',

    enabled: '啟用',
    disabled: '停用',

    waiting_admin_approve: '等待管理員批准',
    matching_helper: '配對護理員中',
    waiting_helper_confirm: "等待護理員確認",
    waiting_admin_confirm: '等待管理員確認',
    confirmed: '已確認',
    in_progress: '進行中',
    waiting_review: '等待評價',
    waiting_client_feedback: '等待客戶評價',
    waiting_helper_feedback: '等待護理員評價',
    completed: '完成',
    incomplete: '未完成',
    cancelled_by_sender: '發出者已取消',

    pending: "待處理",
    accepted: "接受",
    rejected: "拒絕",
    cancelled: "取消",
    approved: '已批准',

    arrived: '已到達',
    left: '已離開',
    reported: '已回報工作',
    feedbacked: '已提交反饋',
    send_invoice: '已發出收據',
    invoice_sent: '已發出收據',
    complete: '完成',
    absent: '缺席',
    late: '遲到'
  },
  gender: {
    m: '男',
    f: '女'
  },

  alert: {
    html: {
      cannot_fetch_item_$err: '<span>無法取得資料：${err}</span>',
      cannot_fetch_list_$err: '<span>無法取得列表：${err}</span>',
      $err: '<span>${err}</span>',
      record_updated_successfully: '<span>已成功更新</span>',
      record_saved_successfully: '<span>已儲存</span>',
      file_uploaded_successfully: '<span>已成功上載</span>',
      no_subprofile: '沒有服務對象',
      no_subprofile_desc: '該會員沒有登記任何服務對象，清先建立一個。',
      confirm_force_assign_job_to_this_member: '確定要指定工作給這個會員？',
      confirm_force_assign_job_to_this_member_ignore_accepted: '已經有別的會員接受了這個預約，仍然要强制指定？',
      time_clash_$appointments: '檢測到該會員有其他預約的緩衝時間上發生衝突：<br/><ul>${appointments.map(function(x){return "<li>" + x + "</li>"})}</ul><br/>仍然要指定？',
      not_available_days_$days: '護理員在該時段沒有空：<br/><ul>${days.map(function(x){return "<li>" + x + "</li>"})}</ul><br/>仍然要指定？',
      confirm_delete_$str: '確認刪除${str}？',
      confirm_action_$action: '確認${action}？',
      update_linked_subprofile: '\n\u6B64\u52D5\u4F5C\u6703\u66F4\u65B0\uFF1A<br/>\n<ul>\n    <li>\u6B64\u6B21${i18n.schema.appointment}\u7684${i18n.schema.subprofile}</li>\n    <li>\u4EE5\u5F8C\u5EFA\u7ACB\u7684${i18n.schema.appointment}\u7684${i18n.schema.subprofile}</li>\n    <li>\u4EE5\u5F8C\u5EFA\u7ACB\u7684${i18n.schema.orders}\u7684${i18n.schema.subprofile}</li>\n</ul><br/>\n\u78BA\u5B9A\u7E7C\u7E8C\uFF1F',
      update_subprofile: '此動作會更新此次${i18n.schema.appointment}的${i18n.schema.subprofile}<br/>確定繼續？',
      confirm_complete_invoice: '確認完成${i18n.schema.invoice}？',
      warn_modify_status: '<span style="color: red">手動更改狀態可能影響正常系統流程，不建議使用。</span>'
    },
    empty_response: '無資料',
    invalid_response: '伺服器傳回無效的回應',
    please_choose_an_item_by_clicking_a_row: '請點擊一行以選擇一個項目。',
    force_assign_job_add_only: '要立即指定給該會員或是只加入候選名單？\n\n[確定]: 指定, [取消]: 加入候選名單'
  },
  html: {
    nil: '<small style="opacity: .5;"><i>&lt;無&gt;</i></small>',
    loading: '<i>${i18n.loading}</i>',
    not_found: '<i>找不到項目</i>',
    empty: '<i>&lt;無資料&gt;</i>'
  },
  loading: '載入中...',
  updated_at_$time: '於${time}更新',
  application_title: 'OkCare 管理平台',
  nil: '<無>',
  label_compulsory: '(强制性)',
  label_pick_a_month: '選擇月份',
  label_pick_a_profession: '選擇專業',
  create_schema_$name: '建立${name}',
  update_schema_$name: '更新${name}',
  schema_$name_details: '${name}詳細',
  admin: '管理員',

  pagination_footer: '顯示 ${total} 項中的第 ${from} 至 ${to} 項',
  search_placeholder: '搜尋...',
  search_records_placeholder: '搜尋項目',
  disk_usage: '儲存空間',
  ram_usage: '記憶體用量',
  cpu_usage: 'CPU 用量',
  revenue: '收入',
  revenue_$income_$refund: '收入：$${income}, 退款：$${refund}',
  cancelled_by_caregiver: '${i18n.schema.caregiver}已取消${i18n.schema.appointments}',
  complaint: '投訴',
  complaints: '投訴',
  not_interviewed: '未面試',
  appointment_requests_$total_$urgent: '${total} ${urgent ? "(" + urgent + " 緊急)" : ""}',
  pending_invoices: '待處理${i18n.schema.invoices}',
  no_name: '沒有姓名',
  menu: {
    overview: '概覽',
    members: '會員',
    appointments: '預約管理',
    ecommerce: '訂單管理',
    admin: '管理員',
    feedbacks: '反饋管理',
    notifications: '通知',
    systemconfigs: '系統設定',
    reports: '報表'
  },
  schema: {
    member: '會員',
    members: '會員',
    admin: '管理員',
    admins: '管理員',
    caregiver: '護理員',
    caregivers: '護理員',
    client: '客戶',
    clients: '客戶',
    subprofile: '服務對象',
    subprofiles: '服務對象',
    linked_subprofiles: '連結的服務對象供日後使用',
    group: '專業',
    groups: '專業',
    group_application: '專業資格申請',
    group_applications: '專業資格申請',
    group_apply: '申請專業資格',
    appointment: '預約',
    appointments: '預約',
    appointment_request: '${i18n.schema.appointment}申請',
    appointment_requests: '${i18n.schema.appointment}申請',
    order: '訂單',
    orders: '訂單',
    transaction: '交易',
    transactions: '交易',
    invoice: '收據',
    invoices: '收據',
    standalone_transaction: '獨立交易',
    rapid_payment: '快速付款',
    refund_transaction: '退款',
    payment: '付款',
    payments: '付款',
    product: '產品',
    products: '產品',
    service: '服務',
    services: '服務',
    coupon: '優惠券',
    coupons: '優惠券',
    feedback: '反饋',
    feedbacks_admin: '反饋 (管理員)',

    feedbacks_caregiver: '反饋 (夥伴)',
    feedbacks_client: '反饋 (客戶)',
    feedback_admin: '反饋 (管理員)',
    feedback_caregiver: '反饋 (夥伴)',
    feedback_client: '反饋 (客戶)',
    notification: '通知',
    notifications: '通知',
    systemnotification: '系統通告',
    systemnotifications: '系統通告',
    adminsendout: '管理員發出通知',
    adminsendouts: '管理員發出通知',
    email: '電郵',
    emails: '電郵',
    systemconfig: '系統設定',
    systemconfigs: '系統設定',
    enquiry: '查詢',
    enquiries: '查詢',
    enquiry_questionnaire: '問卷',
    enquiry_questionnaires: '問卷',
    log: '系統記錄',
    logs: '系統記錄',
    content: '内容',
    contents: '内容管理',

    post: '帖文',
    posts: '帖文'
  },
  fields: {
    display_name_$first_$last: '${last} ${first}',
    years_old_$yrs: '${yrs} 歲',
    array_item_$i: '第 ${i} 項',
    cat: {
      default: '其他',
      general: '一般'
    },
    currency: {
      cash_hkd: '港幣',
      cash_rmb: '人民幣',
      cash_usd: '美金'
    },
    medical_histories: {
      disease: {
        heart_disease: 'Heart Disease',
        cancer: 'Cancer',
        hypertension: 'Hypertension',
        stroke: 'Stroke',
        diabetes: 'Diabetes',
        genetic_disease: 'Genetic Disease'
      },
      currentStatus: {
        stomach_throat: 'Stomach Throat',
        urinary_throat: 'Urinary Throat',
        bed_sores: 'Bed Sores',
        need_an_injection: 'Need an injection',
        wounds_after_surgery: 'Wounds after surgery'
      }
    },
    content_types: {
      appointment: '${i18n.schema.appointment}',
      membership: '${i18n.schema.member}',
      ecommerce: 'E-Commerce',
      system: '系統'
    },
    service_areas: {
      hki: '香港島',
      kl: '九龍',
      nt: '新界',
      isl: '離島'
    },
    roles: {
      member: '會員',
      admin: '管理員',
      superadmin: '超級管理員'
    },
    init_login_types: {
      emailPwd: '${i18n.fields.email}',
      sms: '${i18n.fields.phone}'
    },
    id: 'ID',
    member_id: '${i18n.schema.member}${i18n.fields.id}',
    subprofile_id: '${i18n.schema.subprofile}${i18n.fields.id}',

    group_id: '${i18n.schema.group}${i18n.fields.id}',

    groups: '${i18n.schema.groups}',
    service_id: '${i18n.schema.service}${i18n.fields.id}',
    appointment_id: '${i18n.schema.appointment}${i18n.fields.id}',

    order_id: '${i18n.schema.order}${i18n.fields.id}',

    feedback_id: '${i18n.schema.feedback}${i18n.fields.id}',
    content_id: '${i18n.schema.content}${i18n.fields.id}',
    coupon_id: '${i18n.schema.coupon}${i18n.fields.id}',
    coupon_code: '${i18n.schema.coupon}編號 (區分大小寫)',
    notification_id: '${i18n.schema.notification}${i18n.fields.id}',
    transaction_id: '${i18n.schema.transaction}${i18n.fields.id}',

    product_id: '${i18n.schema.product}${i18n.fields.id}',

    payment_id: '${i18n.schema.payment}${i18n.fields.id}',

    email: '電郵',
    phone: '電話',
    phone_placeholder: '請輸入國際編號，i.e.：852xxxxxxxx',
    pwd: '密碼',
    role: '角色',
    timeslot: '時段',
    feature: '附加項目',
    created_at: '建立日期',
    updated_at: '更新日期',
    expired_at: '過期',
    status: '狀態',
    self_status: '狀態',
    tags: '標簽',
    type: '類別',

    init_login_type: '初始登錄類型',
    details: '詳細資料',
    verification: '驗證',
    activation_code: '激活碼',
    apply_group: '申請專業資格',
    finished_interview: '已完成面試',
    add_subprofile: '${i18n.action.add}${i18n.schema.subprofiles}檔案',
    my_subprofiles: '我的${i18n.schema.subprofiles}',
    my_appointments: '我的${i18n.schema.appointments}',
    my_jobs: '我的工作',
    my_orders: '我的${i18n.schema.orders}',
    subprofiles_count: '# ${i18n.schema.subprofiles}',

    pending_status: '狀態',
    remark: '備注',
    order_remarks: '${i18n.schema.order}${i18n.fields.remark}',
    score: '分數',
    scores: '評分',
    question: '問題',
    avg_score: '平均分數',
    action: '動作',
    sender: '發出',
    receiver: '接收',
    recipient: '收件人',
    refs_appointment: '${i18n.schema.appointment}參照',
    profile: '檔案',
    relationship: '關係',
    service_location: '服務地點',
    user_experience: '工作經驗',
    emergency_contact: '緊急聯絡人',
    user_condition: '健康狀況',
    medical_history: '醫療記錄',
    stat: '統計',
    view: '瀏覽',
    click: '點擊',
    creator: '建立者',

    first_name: '名',
    last_name: '姓',
    other_name: '其他名稱',
    gender: '性別',

    mobile: '手機號',
    home_tel: '住宅電話',
    age: '年齡',
    birthday: '生日',
    height: '身高',
    weight: '體重',
    ratio: '比例',
    name: '名稱',
    room: '室',
    flat: '單位',
    floor: '層',
    block: '座',
    building: '大廈',
    street: '街',
    area: '範圍',
    district: '地區',

    required_groups: '所需${i18n.schema.groups}',

    value_options: '價錢選項',
    quota: '配額',
    quota_per_user: '每個用戶的配額',
    currency_type: '貨幣',
    currency_amount: '金額',
    used_by: '使用記錄',
    used_at: '時間',

    read: '已讀',
    content_type: '類型',
    content: '内容',
    title: '標題',
    code: '代碼',
    sub_type: '子類型',
    admin: '管理員？',

    from: '發出',
    to: '接收',
    tickets: '服務券',
    total_tickets: '${i18n.fields.tickets}總數',
    available_tickets: '可用${i18n.fields.tickets}',
    progress_status: '進度',
    service_date: '服務日期',
    language: '語言',
    notification: '通知',
    sms: '短信',
    app_config: '偏好設定',
    address: '地址',
    custom: '詳細項目',
    customs: '詳細項目',

    required_custom_types: '必要的${i18n.fields.custom}',
    timeslots: '服務時間',
    owners: '擁有者',
    value: '值',
    description: '描述',
    price_options: '價格選項',
    inventory: '存貨',
    inventory_unlimited: '無限存貨',
    privacy: '系統存取等級',
    days_to_expiry: '保留期限 (日)',
    reason: '原因',
    photo: '圖片',
    transaction_code: '付款碼',
    ref: '參照',
    total_amount: '總金額',
    refund_amount: '退款金額 (應為負數)',
    expected_start_date: '預計開始日期',
    quantity: '數量',
    order_remark: '備註',
    log_write_requests: '記錄有寫入動作的要求',
    caregiver_report: '${i18n.schema.caregiver}報告',
    potential_recipients: '候選${i18n.schema.caregivers}',
    potential_recipient_status: '${i18n.schema.caregiver}${i18n.fields.status}',
    potential_recipients_count: '# ${i18n.schema.caregiver}',
    show_cancelled_recipients: '顯示取消的${i18n.schema.caregivers}',
    transaction_progress: '${i18n.schema.transaction}進度',
    list_order: '排列次序',
    notes: '備注',
    working_history: '工作簡歷',
    working_experience: '工作經驗',
    certificates: '證書',
    marriage_status: '婚姻狀況',
    bank_account: '銀行戶口',
    bank_type: '銀行',
    referral: '從何得知',
    signed_contract: '已簽工作守則',
    working_visa: '已發工作證',
    company: '公司',
    startDate: '開始',
    endDate: '完結',
    fulltime: '全職',
    issuer: '簽發者',
    promotion: '接收宣傳資訊',
    is_promotion: '是否為宣傳資訊？',
    profile_pic: '個人頭像',
    unit_amount: '單價',
    location_fee: '交通费',
    records: '記錄',
    reset_password: '重設密碼',
    new_password: '新密碼',
    confirm_password: '確認密碼',
    payment_gateway_err: '第三方支付網關錯誤碼',
    editable: '可編輯',
    years_of_experience: '年資',
    receivers: '接收者',
    ticket_required: '使用服務券',
    invoice_completed: '已付帳單'
  },
  action: {
    ok: '確定',
    yes: '是',
    no: '否',
    cancel: '取消',
    save: '儲存',
    create: '建立',
    duplicate: '複製',
    add: '新增',
    back: '返回',
    update: '更新',
    upload: '上載',
    upload_replace: '上載並取代',
    reload: '重新整理',
    undo: '復原修改',
    download: '下載',
    assign_job_to_this_member: '指定工作給此${i18n.schema.caregiver}',
    force_assign_job_to_this_member: '強制指定工作給此${i18n.schema.caregiver}',
    force_assign_job: '手動指定${i18n.schema.caregiver}',
    create_$obj: '建立${obj}',
    add_new_$obj: '新增${obj}',
    export_data: '匯出資料',
    export_$obj: '匯出${obj}',
    complete_appointment: '完成${i18n.schema.appointment}',
    show_inactive: '顯示已停用項目',
    send_feedback_to_caregiver: '反饋給${i18n.schema.caregiver}',
    send_feedback_to_client: '反饋給${i18n.schema.client}',
    approve: '批准',
    reject: '拒絕',
    login: '登入',
    logout: '登出',
    read: '已讀',
    unread: '未讀',
    delete: '刪除',
    clear_tokens: '清除登入階段',
    apply: '申請',
    click_to_$action: '按此${action}',

    distribute_job: '重新分配工作',
    choose_$obj: '選擇${obj} ...',
    reformat_code: '格式化',
    view_invoice: '檢視${i18n.schema.invoice}',
    complete_invoice: '完成${i18n.schema.invoice}',
    import_members: '匯入${i18n.schema.members}',
    update_stat: '更新統計資料'
  }
};

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _stringify = __webpack_require__(37);

var _stringify2 = _interopRequireDefault(_stringify);

var _vue = __webpack_require__(6);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(276);

var _vuex2 = _interopRequireDefault(_vuex);

var _vueRouter = __webpack_require__(275);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _vueResource = __webpack_require__(274);

var _vueResource2 = _interopRequireDefault(_vueResource);

var _vueNotifyjs = __webpack_require__(273);

var _vueNotifyjs2 = _interopRequireDefault(_vueNotifyjs);

var _veeValidate = __webpack_require__(57);

var _veeValidate2 = _interopRequireDefault(_veeValidate);

var _vueDeepset = __webpack_require__(271);

var VueDeepSet = _interopRequireWildcard(_vueDeepset);

var _en = __webpack_require__(267);

var _en2 = _interopRequireDefault(_en);

var _locale = __webpack_require__(38);

var _locale2 = _interopRequireDefault(_locale);

var _App = __webpack_require__(272);

var _App2 = _interopRequireDefault(_App);

var _bus = __webpack_require__(261);

var _bus2 = _interopRequireDefault(_bus);

var _debug = __webpack_require__(5);

var _debug2 = _interopRequireDefault(_debug);

var _gloablComponents = __webpack_require__(263);

var _gloablComponents2 = _interopRequireDefault(_gloablComponents);

var _globalDirectives = __webpack_require__(264);

var _globalDirectives2 = _interopRequireDefault(_globalDirectives);

var _SidebarPlugin = __webpack_require__(262);

var _SidebarPlugin2 = _interopRequireDefault(_SidebarPlugin);

var _routes = __webpack_require__(265);

var _routes2 = _interopRequireDefault(_routes);

__webpack_require__(270);

__webpack_require__(269);

__webpack_require__(268);

var _i18n = __webpack_require__(2);

var _i18n2 = _interopRequireDefault(_i18n);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _lodash = __webpack_require__(1);

__webpack_require__(74);

var _sidebarLinks = __webpack_require__(266);

var _sidebarLinks2 = _interopRequireDefault(_sidebarLinks);

var _auth = __webpack_require__(260);

var _auth2 = _interopRequireDefault(_auth);

var _utils = __webpack_require__(15);

var _appointment = __webpack_require__(26);

var Appointment = _interopRequireWildcard(_appointment);

var _notification = __webpack_require__(100);

var Notification = _interopRequireWildcard(_notification);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_i18n2.default);
_vue2.default.use(_vueResource2.default);
_vue2.default.use(_vuex2.default);
_vue2.default.use(_vueRouter2.default);
_vue2.default.use(_globalDirectives2.default);
_vue2.default.use(_gloablComponents2.default);
_vue2.default.use(_vueNotifyjs2.default);
_vue2.default.use(_SidebarPlugin2.default, { sidebarLinks: _sidebarLinks2.default });
_vue2.default.use(_veeValidate2.default, { fieldsBagName: '_fields' });
_vue2.default.use(VueDeepSet);
_vue2.default.use(_bus2.default);
_vue2.default.use(_auth2.default);
_locale2.default.use(_en2.default);

_vue2.default.http.options.root = (0, _utils.apiHost)() + 'api';

_vue2.default.http.interceptors.push(function (req, next) {
  if (req.method === 'POST') {
    next(_utils.parseResponse);
  } else {
    next();
  }
});

var router = new _vueRouter2.default({
  mode: 'history',
  routes: _routes2.default,
  linkActiveClass: 'active'
});

router.beforeEach(function (to, from, next) {
  if (to.matched.some(function (x) {
    return x.meta.auth;
  })) {
    if (!(0, _lodash.get)(store, 'state.auth.access_token')) {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      });
      return;
    }
  }
  next();
});

var store = new _vuex2.default.Store({
  state: {
    local: 'en',
    notifications: [{
      title: '${i18n.schema.appointments} (waiting admin approve)',
      count: 0,
      link: '/admin/appointments'
    }, {
      title: '${i18n.schema.appointments} (matching helper)',
      count: 0,
      link: '/admin/appointments'
    }, {
      title: '${i18n.schema.notifications}',
      count: 0,
      link: '/admin/notifications'
    }],
    auth: null
  },
  mutations: {
    auth: function auth(state, v) {
      if (v != null) {
        window.localStorage.auth = (0, _stringify2.default)(v);
        window.localStorage.device_uuid = v.device_uuid;
      } else {
        window.localStorage.removeItem('auth');
      }
      state.auth = v;
      v = v || {};
      _vue2.default.http.headers.common['device-uuid'] = v.device_uuid;
      _vue2.default.http.headers.common['access-token'] = v.access_token;
      _vue2.default.http.headers.common['device'] = 'Admin Panel on ' + (0, _lodash.get)(navigator, 'platform', 'unknown');
    }
  },
  actions: {
    refreshNotifications: function refreshNotifications(store) {
      if (store.state.auth && store.state.auth.access_token) {
        _vue2.default.http.get('getAdminNotificationStats').then(function (response) {
          var data = response.body.data;
          store.state.notifications[0].count = data.waiting_admin_approve;
          store.state.notifications[1].count = data.matching_helper;
          store.state.notifications[2].count = data.notifications;
        });
      }
    }
  }
});

try {
  store.commit('auth', window.localStorage.auth ? JSON.parse(window.localStorage.auth) : null);

  _vue2.default.http.post('', { 'endpoint': 'getMyProfile' }).then(function (res) {
    if (['admin', 'superadmin'].indexOf((0, _lodash.get)(res, 'body.data.role')) < 0) {
      throw new Error();
    }
  }).catch(function (err) {
    store.commit('auth', null);
  });
} catch (e) {}

setInterval(function () {
  store.dispatch('refreshNotifications');
}, 300000);
store.dispatch('refreshNotifications');

Object.defineProperty(_i18n2.default, 'local', {
  get: function get() {
    return store.state.local;
  },
  set: function set(v) {
    if (!this.lang[v]) {
      v = this.fallbackLocal;
    }
    store.state.local = v;
    _moment2.default.locale(this.s('local'));
    document.cookie = 'local=' + v + '; path=/; expires=' + (0, _moment2.default)().add(1, 'month').toDate().toUTCString();
    document.title = this.fr('application_title');
  },

  enumerable: true,
  configurable: true
});

_i18n2.default.local = (0, _utils.getCookie)('local');

var $vm = new _vue2.default({
  el: '#app',
  render: function render(h) {
    return h(_App2.default);
  },
  router: router,
  store: store,
  bus: new _vue2.default(),
  created: function created() {
    this.$sidebar.options.vm = this;
  },
  mounted: function mounted() {
    this.$sidebar.reload();
  },

  watch: {
    $auth: function $auth(v) {
      if (this.$route.meta.auth) {
        if (!(0, _lodash.get)(v, 'access_token')) {
          this.$router.push('/login');
        } else {
          this.$sidebar.reload();
        }
      }
    }
  }
});

window.pageLoadTime = (0, _moment2.default)();
if (_debug2.default.DEBUG) {
  setInterval(function () {
    if (confirm('The web page has not be refreshed for ' + _moment2.default.duration((0, _moment2.default)() - window.pageLoadTime).humanize() + ', there may be newly built versions.\nDo you want to refresh?')) {
      window.location.reload(true);
    }
  }, 2 * 60 * 60 * 1000);
}

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.title = exports.columns = exports.view = exports.read = exports.list = undefined;

var _utils = __webpack_require__(3);

var utils = _interopRequireWildcard(_utils);

var _appointment = __webpack_require__(26);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var list = exports.list = utils.listFn('', function (payload, schema, columns) {
  payload.endpoint = payload.caregiver ? 'getMyAppointmentsAsCaregiver' : 'getMyAppointmentsAsClient';
  delete payload.member_id;
  delete payload.caregiver;
  return payload;
}, function (payload, schema, columns) {
  return {
    headers: { actas: payload.member_id }
  };
});
exports.read = _appointment.read;
exports.view = _appointment.view;
exports.columns = _appointment.columns;
exports.title = _appointment.title;

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(19);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(18);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__(22);

var _extends3 = _interopRequireDefault(_extends2);

var _messageBox = __webpack_require__(103);

var _messageBox2 = _interopRequireDefault(_messageBox);

var _base = __webpack_require__(9);

var _base2 = _interopRequireDefault(_base);

var _messageBox3 = __webpack_require__(102);

var _messageBox4 = _interopRequireDefault(_messageBox3);

var _promise = __webpack_require__(7);

var _promise2 = _interopRequireDefault(_promise);

var _taggedTemplateLiteral2 = __webpack_require__(30);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['', ': ', ''], ['', ': ', '']);

exports.default = function (model) {
  return {
    appointment_id: { type: 'id', required: true },
    created_at: { type: 'datetime', readonly: true },
    status: { type: 'select', items: ['status.active', 'status.inactive'], default: 'active' },

    type: { type: 'string', list: false },

    'details.order.product.details.title': {
      type: 'i18n',
      label: 'schema.product',
      hidden: true
    },

    progress_status: {
      type: 'select', default: 'matching_helper',
      items: ['status.waiting_admin_approve', 'status.waiting_admin_confirm', 'status.matching_helper', 'status.waiting_helper_confirm', 'status.confirmed', 'status.cancelled', 'status.cancelled_by_sender', 'status.in_progress', 'status.incomplete', 'status.complete'],
      display: function display(model, index, fieldSpec, schema, columns) {
        var value = _utils.displayField.call(this, model, index, fieldSpec, schema, columns);
        if (['matching_helper', 'incomplete'].indexOf((0, _lodash.get)(model, 'progress_status')) >= 0) {
          value = { template: '<span class="label label-danger" style="font-size: small">' + value + '</span>' };
        } else if (['complete'].indexOf((0, _lodash.get)(model, 'progress_status')) >= 0) {
          value = { template: '<span class="label label-success" style="font-size: small">' + value + '</span>' };
        }
        return value;
      }
    },
    invoice_completed: {
      type: 'boolean'
    },
    warn_modify_status: {
      type: 'label',
      label: '',
      html: true,
      list: false,
      get: function get() {
        return _index2.default.fr('alert.html.warn_modify_status');
      }
    },
    progress_history: {
      readonly: true,
      type: 'array',
      itemType: {
        type: 'schema', schema: (0, _lodash.merge)((0, _utils.inlineSchema)({
          action: { type: 'label' },
          new_status: {
            type: 'select',
            items: ['status.waiting_admin_approve', 'status.waiting_admin_confirm', 'status.matching_helper', 'status.waiting_helper_confirm', 'status.confirmed', 'status.cancelled', 'status.cancelled_by_sender', 'status.in_progress', 'status.incomplete', 'status.complete']
          },
          updated_at: { type: 'datetime', default: function _default() {
              return (0, _moment2.default)();
            } },
          updated_by: { type: 'schema', external: true, schema: Member }
        }), {
          title: function title(model) {
            return _index2.default.nn(_templateObject, _index2.default.s('status.' + model.new_status), model.action);
          }
        })
      }
    },

    sender: {
      type: 'schema', schema: (0, _lodash.merge)({}, Member, {
        title: function title(model) {
          var name = Member.title.call(this, model);
          var phone = (0, _lodash.get)(model, 'verification.phone.value');
          return name + (phone ? ' (' + (0, _utils2.formatPhone)(phone) + ')' : '');
        }
      }), readonly: true, list: true
    },
    subprofile: {
      type: 'schema', showActions: true, label: 'fields.subprofile', schema: (0, _lodash.merge)({}, Subprofile, {
        title: function title(model) {
          var name = Subprofile.title.call(this, model);
          var phone = (0, _lodash.get)(model, 'details.profile.mobile');
          return name + (phone ? ' (' + (0, _utils2.formatPhone)(phone) + ')' : '');
        },
        formActions: function formActions(model, schema, readonly) {
          var self = this;
          var temp = [];
          if (!readonly) {
            temp.push({
              label: _index2.default.fr('update_schema_$name', { name: '${i18n.schema.subprofile}' }),
              class: 'btn-success',
              validation: true,
              action: function action(model, schema, columns) {
                var _this = this;

                return (0, _sweetalert2.default)({
                  html: _index2.default.fr('alert.html.update_subprofile'),
                  showCancelButton: true,
                  confirmButtonText: _index2.default.fr('action.yes'),
                  cancelButtonText: _index2.default.fr('action.cancel'),
                  confirmButtonClass: 'btn btn-success btn-fill',
                  cancelButtonClass: 'btn btn-fill',
                  buttonsStyling: false
                }).then(function () {
                  return (0, _utils.updateFn)('updateAppointmentSubprofile', null, ['status', 'type', 'tags', 'details'], function (payload) {
                    payload.appointment_id = self.rootModel.appointment_id;
                    payload.update_linked_subprofile = false;
                    return payload;
                  }).call(_this, model, schema, columns);
                }, function () {
                  return false;
                });
              }
            });
            temp.push({
              label: _index2.default.fr('update_schema_$name', { name: '${i18n.schema.linked_subprofiles}' }),
              class: 'btn-success',
              validation: true,
              action: function action(model, schema, columns) {
                var _this2 = this;

                return (0, _sweetalert2.default)({
                  html: _index2.default.fr('alert.html.update_linked_subprofile'),
                  showCancelButton: true,
                  confirmButtonText: _index2.default.fr('action.yes'),
                  cancelButtonText: _index2.default.fr('action.cancel'),
                  confirmButtonClass: 'btn btn-success btn-fill',
                  cancelButtonClass: 'btn btn-fill',
                  buttonsStyling: false
                }).then(function () {
                  return (0, _utils.updateFn)('updateAppointmentSubprofile', null, ['status', 'type', 'tags', 'details'], function (payload) {
                    payload.appointment_id = self.rootModel.appointment_id;
                    payload.update_linked_subprofile = true;
                    return payload;
                  }).call(_this2, model, schema, columns);
                }, function () {
                  return false;
                });
              }
            });
          }
          temp.push({
            label: _index2.default.fr('create_schema_$name', { name: '${i18n.schema.order}' }),
            class: 'btn-info',
            validation: false,
            action: function action(model, schema) {
              this.$router.push('/admin/orders/create?member_id=' + (0, _lodash.get)(model, 'creator.member_id') + '&subprofile_id=' + (0, _lodash.get)(model, 'subprofile_id'));
              return _promise2.default.resolve();
            }
          });
          return temp;
        }
      })
    },

    potential_recipient_status: {
      type: 'select',
      readonly: true,
      hidden: true,
      items: ['status.pending', 'status.accepted', 'status.confirmed', 'status.rejected', 'status.arrived', 'status.cancelled', 'status.absent', 'status.late', 'status.left', 'status.reported', 'status.feedbacked', 'status.invoice_sent', 'status.complete'],
      get: function get(model) {
        return (0, _lodash.get)((0, _lodash.find)((0, _lodash.get)(model, 'potential_recipients'), function (x) {
          return ['accepted', 'confirmed', 'arrived', 'absent', 'late', 'left', 'reported', 'feedbacked', 'invoice_sent', 'complete'].indexOf(x.status) >= 0;
        }), 'status');
      }
    },
    potential_recipients_count: {
      type: 'number',
      hidden: true,
      get: function get(model) {
        return (0, _lodash.get)(model, 'potential_recipients', []).length;
      }
    },
    show_cancelled_recipients: { type: 'checkbox', list: false },
    potential_recipients: {
      type: 'array', itemType: {
        type: 'schema',
        class: function _class(model) {
          return {
            'bg-disabled': ['cancelled', 'rejected'].indexOf(model.status) >= 0,
            'bg-success': ['cancelled', 'rejected', 'pending'].indexOf(model.status) < 0
          };
        },
        showActions: true,
        schema: (0, _lodash.merge)((0, _utils.inlineSchema)({
          created_at: { type: 'datetime', readonly: true },
          updated_at: { type: 'datetime', readonly: true },
          recipient: {
            type: 'schema', readonly: true,
            schema: (0, _lodash.merge)({}, Member, {
              columns: (0, _utils.columnsFn)({
                member_id: { type: 'id' },
                'details.profile.first_name': { type: 'string' },
                'details.profile.last_name': { type: 'string' },
                'details.profile.gender': { type: 'select', items: ['gender.m', 'gender.f'] },
                'details.profile.profile_pic': { type: 'img' },
                'verification.email.value': {
                  type: 'string',
                  label: 'fields.email',
                  list: 1
                },
                'verification.phone.value': {
                  type: 'phone',
                  label: 'fields.phone',
                  list: 2
                }
              })
            })
          },
          status: {
            type: 'select',

            items: ['status.pending', 'status.accepted', 'status.confirmed', 'status.rejected', 'status.arrived', 'status.cancelled', 'status.absent', 'status.late', 'status.left', 'status.reported', 'status.feedbacked', 'status.invoice_sent', 'status.complete']
          },
          warn_modify_status: {
            type: 'label',
            label: '',
            html: true,
            get: function get() {
              return _index2.default.fr('alert.html.warn_modify_status');
            }
          },
          status_history: {
            type: 'array',
            readonly: true,
            itemType: {
              type: 'schema', schema: (0, _lodash.merge)((0, _utils.inlineSchema)({
                action: { type: 'label' },
                new_status: { type: 'label' },
                updated_at: { type: 'datetime' },
                updated_by: { type: 'schema', external: true, schema: Member }
              }), {
                title: function title(model) {
                  return _index2.default.fr('status.' + model.new_status);
                }
              })
            }
          }
        }), {
          title: function title(model) {
            return Member.title.call(this, model.recipient) + (' (' + _index2.default.s('status.' + model.status, '') + ')');
          },
          formActions: function formActions(model, schema, readonly) {
            var status = (0, _lodash.get)(model, 'status');
            var appointment_progress = (0, _lodash.get)(this, 'rootModel.progress_status');
            if (status == 'accepted') {
              return [{
                label: _index2.default.fr('action.assign_job_to_this_member'),
                action: function action(model, spec, readonly) {
                  var _this3 = this;

                  var payload = {
                    endpoint: 'confirmJobApplicationByAdmin',
                    appointment_id: this.rootModel.appointment_id,
                    member_id: model.recipient.member_id
                  };

                  var p = this.$http.post('', payload);
                  p = _utils.formActions.postprocess.notify(true).call(this, p);
                  p = p.catch(function (response) {
                    if (['soft_time_clash', 'not_available_days_conflict'].indexOf((0, _lodash.get)(response, 'err.err_code')) >= 0) {

                      return (0, _sweetalert2.default)({
                        html: response.err.err_code == 'soft_time_clash' ? _index2.default.fr('alert.html.time_clash_$appointments', {
                          appointments: (0, _lodash.map)(response.err_details, function (x) {
                            return '\n<a href="/admin/appointments/' + x.appointment_id + '" target="_blank">\n  ' + x.appointment_id + ' (' + (0, _moment2.default)(x.details.service_begin).format('YYYY/MM/DD HH:mm') + ')\n</a>';
                          })
                        }) : _index2.default.fr('alert.html.not_available_days_$days', {
                          days: (0, _lodash.map)(response.err_details, function (x) {
                            return (0, _moment2.default)(x.startTime).format('YYYY/MM/DD');
                          })
                        }),
                        type: 'warning',
                        showCancelButton: true,
                        confirmButtonText: _index2.default.fr('action.yes'),
                        cancelButtonText: _index2.default.fr('action.cancel'),
                        confirmButtonClass: 'btn btn-danger btn-fill',
                        cancelButtonClass: 'btn btn-fill',
                        buttonsStyling: false
                      }).then(function () {

                        payload.force = true;
                        var p1 = _this3.$http.post('', payload);
                        p1 = _utils.formActions.postprocess.notify(true).call(_this3, p1);
                        return p1;
                      }, function (dismiss) {
                        return false;
                      });
                    } else {
                      return _promise2.default.reject(response.err);
                    }
                  });
                  return p;
                }
              }];
            } else if (['pending', 'accepted', 'rejected', 'cancelled'].indexOf(status) >= 0 && ['in_progress', 'complete', 'incomplete'].indexOf(appointment_progress) < 0) {
                return [{
                  label: _index2.default.fr('action.force_assign_job_to_this_member'),
                  class: 'btn-danger',
                  action: function action(model, spec, readonly) {
                    var _this4 = this;

                    var r = (0, _lodash.find)((0, _lodash.get)(this, 'rootModel.potential_recipients', []), function (x) {
                      return ['accepted', 'confirmed'].indexOf(x.status) >= 0;
                    });

                    return (0, _sweetalert2.default)({
                      html: _index2.default.fr(r ? 'alert.html.confirm_force_assign_job_to_this_member_ignore_accepted' : 'alert.html.confirm_force_assign_job_to_this_member'),
                      type: 'warning',
                      showCancelButton: true,
                      confirmButtonText: _index2.default.fr('action.yes'),
                      cancelButtonText: _index2.default.fr('action.cancel'),
                      confirmButtonClass: 'btn btn-danger btn-fill',
                      cancelButtonClass: 'btn btn-fill',
                      buttonsStyling: false
                    }).then(function () {

                      var payload = {
                        endpoint: 'confirmJobApplicationByAdmin',
                        appointment_id: _this4.rootModel.appointment_id,
                        member_id: model.recipient.member_id
                      };

                      var p = _this4.$http.post('', payload);
                      p = _utils.formActions.postprocess.notify(true).call(_this4, p);
                      p = p.catch(function (response) {
                        if (['soft_time_clash', 'not_available_days_conflict'].indexOf((0, _lodash.get)(response, 'err.err_code')) >= 0) {

                          return (0, _sweetalert2.default)({
                            html: response.err.err_code == 'soft_time_clash' ? _index2.default.fr('alert.html.time_clash_$appointments', {
                              appointments: (0, _lodash.map)(response.err_details, function (x) {
                                return '\n<a href="/admin/appointments/' + x.appointment_id + '" target="_blank">\n  ' + x.appointment_id + ' (' + (0, _moment2.default)(x.details.service_begin).format('YYYY/MM/DD HH:mm') + ')\n</a>';
                              })
                            }) : _index2.default.fr('alert.html.not_available_days_$days', {
                              days: (0, _lodash.map)(response.err_details, function (x) {
                                return (0, _moment2.default)(x.startTime).format('YYYY/MM/DD');
                              })
                            }),
                            type: 'warning',
                            showCancelButton: true,
                            confirmButtonText: _index2.default.fr('action.yes'),
                            cancelButtonText: _index2.default.fr('action.cancel'),
                            confirmButtonClass: 'btn btn-danger btn-fill',
                            cancelButtonClass: 'btn btn-fill',
                            buttonsStyling: false
                          }).then(function () {
                            payload.force = true;
                            var p1 = _this4.$http.post('', payload);
                            p1 = _utils.formActions.postprocess.notify(true).call(_this4, p1);
                            return p1;
                          }, function (dismiss) {
                            return false;
                          });
                        } else {
                          return _promise2.default.reject(err);
                        }
                      });
                      return p;
                    }, function (dismiss) {
                      return false;
                    });
                  }
                }];
              }
            return [];
          }
        })
      },
      get: function get(model) {
        return (0, _lodash.get)(model, 'show_cancelled_recipients') ? (0, _lodash.get)(model, 'potential_recipients', []) : (0, _lodash.filter)((0, _lodash.get)(model, 'potential_recipients', []), function (x) {
          return x.status !== 'cancelled';
        });
      }
    },
    force_assign_caregiver: {
      type: 'button',
      label: 'action.force_assign_job',
      hidden: model && ['in_progress', 'complete', 'incomplete'].indexOf(model.progress_status) >= 0,
      actions: [{
        label: ['action.choose_$obj', { obj: '${i18n.schema.caregiver}' }],
        action: function action(model, spec) {
          var _this5 = this;

          var self = this;
          var TheMember = null;
          var addOnly = false;
          return (0, _messageBox4.default)({
            title: _index2.default.fr('action.choose_$obj', { obj: '${i18n.schema.caregiver}' }),
            type: null,
            showCancelButton: true,
            closeOnPressEscape: true,
            closeOnClickModal: false,
            message: self.$createElement(_SchemaBaseTable2.default, {
              key: +new Date(),
              props: {
                schema: (0, _extends3.default)({}, Caregiver, {
                  view: function view(row) {
                    TheMember = row;
                  }
                }),
                listActions: false,
                embedded: true,
                selectable: true,
                perPage: 10
              }
            }),
            beforeClose: function beforeClose(action, instance, done) {
              if (action === 'confirm') {
                if (!TheMember) {
                  alert(_index2.default.fr('alert.please_choose_an_item_by_clicking_a_row'));
                } else {
                  addOnly = !confirm(_index2.default.fr('alert.force_assign_job_add_only'));
                }
              }
              done();
            }
          }).then((0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
            var r, ok, payload, p;
            return _regenerator2.default.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    r = (0, _lodash.find)((0, _lodash.get)(self, 'rootModel.potential_recipients', []), function (x) {
                      return ['accepted', 'confirmed'].indexOf(x.status) >= 0;
                    });

                    if (!addOnly) {
                      _context.next = 5;
                      break;
                    }

                    _context.t0 = true;
                    _context.next = 8;
                    break;

                  case 5:
                    _context.next = 7;
                    return (0, _sweetalert2.default)({
                      html: _index2.default.fr(r ? 'alert.html.confirm_force_assign_job_to_this_member_ignore_accepted' : 'alert.html.confirm_force_assign_job_to_this_member'),
                      type: 'warning',
                      showCancelButton: true,
                      confirmButtonText: _index2.default.fr('action.yes'),
                      cancelButtonText: _index2.default.fr('action.cancel'),
                      confirmButtonClass: 'btn btn-danger btn-fill',
                      cancelButtonClass: 'btn btn-fill',
                      buttonsStyling: false
                    }).then(function () {
                      return true;
                    }, function () {
                      return false;
                    });

                  case 7:
                    _context.t0 = _context.sent;

                  case 8:
                    ok = _context.t0;

                    if (ok) {
                      _context.next = 11;
                      break;
                    }

                    return _context.abrupt('return');

                  case 11:
                    payload = {
                      endpoint: 'confirmJobApplicationByAdmin',
                      appointment_id: self.rootModel.appointment_id,
                      member_id: TheMember.member_id,
                      status: addOnly ? 'pending' : 'confirmed'
                    };
                    p = self.$http.post('', payload);

                    p = _utils.formActions.postprocess.notify(true).call(self, p);
                    p = p.catch(function (response) {
                      if (['soft_time_clash', 'not_available_days_conflict'].indexOf((0, _lodash.get)(response, 'err.err_code')) >= 0) {

                        return (0, _sweetalert2.default)({
                          html: response.err.err_code == 'soft_time_clash' ? _index2.default.fr('alert.html.time_clash_$appointments', {
                            appointments: (0, _lodash.map)(response.err_details, function (x) {
                              return '\n<a href="/admin/appointments/' + x.appointment_id + '" target="_blank">\n  ' + x.appointment_id + ' (' + (0, _moment2.default)(x.details.service_begin).format('YYYY/MM/DD HH:mm') + ')\n</a>';
                            })
                          }) : _index2.default.fr('alert.html.not_available_days_$days', {
                            days: (0, _lodash.map)(response.err_details, function (x) {
                              return (0, _moment2.default)(x.startTime).format('YYYY/MM/DD');
                            })
                          }),
                          type: 'warning',
                          showCancelButton: true,
                          confirmButtonText: _index2.default.fr('action.yes'),
                          cancelButtonText: _index2.default.fr('action.cancel'),
                          confirmButtonClass: 'btn btn-danger btn-fill',
                          cancelButtonClass: 'btn btn-fill',
                          buttonsStyling: false
                        }).then(function () {

                          payload.force = true;
                          var p1 = self.$http.post('', payload);
                          p1 = _utils.formActions.postprocess.notify(true).call(self, p1);
                          return p1;
                        }, function (dismiss) {
                          return false;
                        });
                      } else {
                        return _promise2.default.reject(response.err);
                      }
                    });
                    return _context.abrupt('return', p);

                  case 16:
                  case 'end':
                    return _context.stop();
                }
              }
            }, _callee, _this5);
          })), function () {});
        }
      }]
    },
    required_groups: {
      type: 'array', readonly: true,
      itemType: {
        type: 'schema', schema: (0, _lodash.merge)((0, _utils.inlineSchema)({
          group: { type: 'schema', required: true, schema: Group, external: true },
          required_self_status: { type: 'select', items: ['status.pending', 'status.approved', 'status.admin'] }
        }), {
          title: function title(model) {
            return Group.title.call(this, (0, _lodash.get)(model, 'group'), Group);
          }
        })
      }
    },

    'details.service_date': { type: 'datetime', hidden: true },
    details: {
      type: 'schema', schema: (0, _lodash.merge)((0, _utils.inlineSchema)({
        order: { type: 'schema', schema: Order, external: true, required: true },
        service_date: {
          type: 'datetime',
          readonly: model && ['complete', 'incomplete'].indexOf(model.progress_status) >= 0
        },
        timeslot: { type: String, readonly: true },
        service_begin: { type: 'datetime', readonly: true },
        service_end: { type: 'datetime', readonly: true },
        service_cooldown: { type: 'datetime', readonly: true },
        ratio: { label: 'fields.ticket_required', type: 'label', default: 1, readonly: true },
        'caregiver_report.content': {
          label: 'fields.caregiver_report',
          type: 'array', readonly: true,
          itemType: {
            type: 'schema',
            schema: (0, _utils.inlineSchema)({
              time: { type: 'datetime' },
              note: { type: 'string' }
            })
          }
        },
        'order.service_location': { type: 'schema', readonly: true, schema: ServiceLocation },
        'order.emergency_contact': { type: 'schema', readonly: true, schema: EmergencyContact },
        feedbacks: { type: 'array', itemType: { type: 'schema', schema: FeedbackCaregiver, external: true } },
        invoices: { type: 'array', itemType: { type: 'schema', schema: Transaction, external: true } },
        'order.remarks': { type: 'text', readonly: true, label: 'fields.order_remarks' },
        remarks: { type: 'text' }
      }), {
        title: function title(model) {
          var addr = (0, _lodash.get)(model, 'order.service_location');
          if (addr) {
            return ServiceLocation.title.call(this, addr);
          }
          return '';
        }
      })
    }
  };
};

var _lodash = __webpack_require__(1);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _utils = __webpack_require__(3);

var _index = __webpack_require__(2);

var _index2 = _interopRequireDefault(_index);

var _membership = __webpack_require__(14);

var Member = _interopRequireWildcard(_membership);

var _caregiver = __webpack_require__(108);

var Caregiver = _interopRequireWildcard(_caregiver);

var _order = __webpack_require__(39);

var Order = _interopRequireWildcard(_order);

var _group = __webpack_require__(31);

var Group = _interopRequireWildcard(_group);

var _feedbackCaregiver = __webpack_require__(109);

var FeedbackCaregiver = _interopRequireWildcard(_feedbackCaregiver);

var _transaction = __webpack_require__(40);

var Transaction = _interopRequireWildcard(_transaction);

var _subprofile = __webpack_require__(32);

var Subprofile = _interopRequireWildcard(_subprofile);

var _service_location = __webpack_require__(45);

var ServiceLocation = _interopRequireWildcard(_service_location);

var _emergency_contact = __webpack_require__(59);

var EmergencyContact = _interopRequireWildcard(_emergency_contact);

var _sweetalert = __webpack_require__(54);

var _sweetalert2 = _interopRequireDefault(_sweetalert);

var _debug = __webpack_require__(5);

var _debug2 = _interopRequireDefault(_debug);

var _SchemaBaseTable = __webpack_require__(75);

var _SchemaBaseTable2 = _interopRequireDefault(_SchemaBaseTable);

var _utils2 = __webpack_require__(15);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  return {
    group_id: { type: 'id' },
    created_at: { type: 'datetime', readonly: true },
    status: { type: 'select', items: ['status.active', 'status.inactive'] },
    type: { type: 'string' },
    tags: { type: 'tags' },
    'details.code': { type: 'label', hidden: true },
    details: {
      type: 'schema',
      expand: true,
      schema: (0, _utils.inlineSchema)({
        code: { type: 'string' },
        name: { type: 'i18n', itemType: { type: 'string' } },
        description: { type: 'i18n', itemType: { type: 'text' } },
        professional: { type: 'i18n', itemType: { type: 'string' } },
        qualification: { type: 'i18n', itemType: { type: 'string' } },
        target_group: { type: 'i18n', itemType: { type: 'string' } },
        service_location: { type: 'i18n', itemType: { type: 'string' } },
        service_area_short: { type: 'i18n', itemType: { type: 'string' } },
        recommended_hourly_rate: {
          type: 'schema',
          expand: true,
          schema: (0, _utils.inlineSchema)({
            hkd: { type: 'number' },
            rmb: { type: 'number' }
          })
        }
      })
    },
    members: {
      type: 'table', schema: MemberInGroup, label: 'schema.caregivers',
      initialFilter: function initialFilter(value, model) {
        return { group_id: model.group_id };
      }
    }
  };
};

var _utils = __webpack_require__(3);

var _membershipInGroup = __webpack_require__(332);

var MemberInGroup = _interopRequireWildcard(_membershipInGroup);

var _debug = __webpack_require__(5);

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.list = exports.title = exports.columns = exports.view = exports.read = undefined;

var _membership = __webpack_require__(14);

Object.defineProperty(exports, 'read', {
  enumerable: true,
  get: function get() {
    return _membership.read;
  }
});
Object.defineProperty(exports, 'view', {
  enumerable: true,
  get: function get() {
    return _membership.view;
  }
});
Object.defineProperty(exports, 'columns', {
  enumerable: true,
  get: function get() {
    return _membership.columns;
  }
});
Object.defineProperty(exports, 'title', {
  enumerable: true,
  get: function get() {
    return _membership.title;
  }
});

var _utils = __webpack_require__(3);

var utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var list = exports.list = utils.listFn('getMembersByGroupId');

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.title = exports.columns = exports.view = exports.read = exports.list = undefined;

var _utils = __webpack_require__(3);

var utils = _interopRequireWildcard(_utils);

var _order = __webpack_require__(39);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var list = exports.list = utils.listFn('getMyOrders', function (payload, schema, columns) {
  delete payload.member_id;
  return payload;
}, function (payload, schema, columns) {
  return {
    headers: { actas: payload.member_id }
  };
});
exports.read = _order.read;
exports.view = _order.view;
exports.columns = _order.columns;
exports.title = _order.title;

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(7);

var _promise2 = _interopRequireDefault(_promise);

exports.default = function () {
  return {
    order_id: { type: 'id' },
    status: { type: 'select', items: ['status.active', 'status.inactive'], default: 'active' },
    created_by: { type: 'schema', schema: Member, list: true, readonly: true },
    created_at: { type: 'datetime', readonly: true },
    updated_at: { type: 'datetime', readonly: true },

    tags: { type: 'tags' },

    required_groups: {
      type: 'array',
      readonly: true,
      itemType: {
        type: 'schema', schema: (0, _lodash.merge)((0, _utils.inlineSchema)({
          group: { type: 'schema', required: true, schema: Group },
          required_self_status: { type: 'select', items: ['status.pending', 'status.approved', 'status.admin'] }
        }), {
          title: function title(model) {
            return Group.title.call(this, model.group, Group);
          }
        })
      }
    },
    product: { type: 'schema', schema: Product, readonly: true, list: true },


    total_tickets: { type: 'number' },
    available_tickets: { type: 'number' },
    unit_amount: { type: 'number', readonly: true },
    location_fee: { type: 'number', readonly: true },

    custom_ids: {
      type: 'array', itemType: {
        type: 'select',
        items: function items(value, model, spec, search) {
          return _promise2.default.resolve(this.rootModel ? (0, _lodash.map)((0, _lodash.filter)(this.rootModel.product.customs, function (x) {
            return x.type === 'timeslot';
          }), function (x) {
            var parts = x.custom_id.replace(/\.[a-z0-9\-]{36}$/i, '');
            parts = parts.split('-');
            var start = (0, _moment2.default)(parts[1], 'HHmm');
            return {
              value: x.custom_id,
              label: _moment2.default.duration(parseInt(parts[0]), 'm').humanize() + ', ' + start.format('HH:mm') + '~' + start.add(parseInt(parts[0]), 'm').format('HH:mm') + ', cool down ' + _moment2.default.duration(parseInt(parts[2]), 'm').humanize()
            };
          }) : []);
        }
      }
    },
    subProfile: { type: 'schema', schema: Subprofile, readonly: true },

    details: {
      type: 'schema', schema: (0, _utils.inlineSchema)({
        remark: { type: 'text' }
      })
    },

    service_location: { type: 'schema', schema: ServiceLocation },

    emergency_contact: { type: 'schema', schema: EmergencyContact },

    transactions: {
      type: 'array',
      itemType: { type: 'schema', schema: Transaction, readonly: true }
    },

    appointments: {
      type: 'array',
      itemType: {
        type: 'schema', schema: (0, _lodash.merge)({}, Appointment, {
          title: function title(model) {
            var name = (0, _lodash.get)(model, 'subprofile');
            name = name ? Subprofile.title.call(this, name, Subprofile) : null;
            name = name || _index2.default.s('schema.appointment');
            var time = (0, _moment2.default)((0, _lodash.get)(model, 'details.service_begin'));
            if (time.isValid()) time = ' (' + time.format('DD/MM/YYYY HH:mm') + ')';else time = '';
            return name + time;
          }
        }), external: true
      }
    },

    service_date: {
      type: 'array', hidden: true, list: true,
      itemType: { type: 'date' },
      get: function get(model) {
        return (0, _lodash.get)(model, 'appointments', []).map(function (x) {
          return (0, _moment2.default)((0, _lodash.get)(x, 'details.service_date'));
        }).filter(function (x) {
          return x.isValid();
        });
      },
      display: function display(model, index, fieldSpec) {
        var value = _utils.getField.call(this, model, fieldSpec);
        return { template: '<div>' + value.map(function (x) {
            return x.format('DD/MM/YYYY');
          }).join('<br>') + '</div>' };
      }
    },

    expiry_date: { type: 'datetime' }
  };
};

var _lodash = __webpack_require__(1);

var _utils = __webpack_require__(3);

var _index = __webpack_require__(2);

var _index2 = _interopRequireDefault(_index);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _subprofile = __webpack_require__(32);

var Subprofile = _interopRequireWildcard(_subprofile);

var _appointment = __webpack_require__(26);

var Appointment = _interopRequireWildcard(_appointment);

var _membership = __webpack_require__(14);

var Member = _interopRequireWildcard(_membership);

var _group = __webpack_require__(31);

var Group = _interopRequireWildcard(_group);

var _product = __webpack_require__(58);

var Product = _interopRequireWildcard(_product);

var _transaction = __webpack_require__(40);

var Transaction = _interopRequireWildcard(_transaction);

var _profile = __webpack_require__(44);

var Profile = _interopRequireWildcard(_profile);

var _service_location = __webpack_require__(45);

var ServiceLocation = _interopRequireWildcard(_service_location);

var _emergency_contact = __webpack_require__(59);

var EmergencyContact = _interopRequireWildcard(_emergency_contact);

var _user_experience = __webpack_require__(105);

var UserExperience = _interopRequireWildcard(_user_experience);

var _medical_history = __webpack_require__(104);

var MedicalHistory = _interopRequireWildcard(_medical_history);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  return {
    payment_id: { type: 'id', required: true },
    created_at: { type: 'datetime', readonly: true },
    status: { type: 'select', items: ['status.active', 'status.inactive'], default: 'active' },

    payment_status: {
      type: 'select',
      items: ['status.pending', 'status.success', 'status.failed'],
      default: 'pending'
    },
    tags: [],

    member: {
      type: 'schema',
      schema: Member,
      external: true,
      required: true,
      list: true,
      display: function display(model, index, fieldSpec, schema, columns) {
        return Member.title.call(this, model.member, Member);
      }
    },
    gateway_type: { type: 'select', items: ['payment.stripe', 'payment.paypal'], required: true },
    err_codes: {
      label: 'fields.payment_gateway_err',
      type: 'array', readonly: true,
      itemType: {
        type: 'schema', schema: (0, _utils.inlineSchema)({
          created_at: { type: 'datetime', readonly: true },
          err_code: {}
        })
      }
    },

    payment_refId: { type: String },
    gateway_backup_data: [{
      created_at: { type: 'datetime', readonly: true },
      data: {}
    }],
    gateway_responded_at: 'datetime',
    details: {},

    currency_type: {
      type: 'select',
      items: ['fields.currency.cash_hkd', 'fields.currency.cash_usd'],
      required: true
    },
    currency_amount: { type: 'number', required: true },

    transactions: {
      type: 'array',
      itemType: { type: 'schema', schema: Transaction, readonly: true }
    },

    refund_at: { type: 'datetime', list: false }
  };
};

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _utils = __webpack_require__(3);

var _index = __webpack_require__(2);

var _index2 = _interopRequireDefault(_index);

var _membership = __webpack_require__(14);

var Member = _interopRequireWildcard(_membership);

var _transaction = __webpack_require__(40);

var Transaction = _interopRequireWildcard(_transaction);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  return {
    subprofile_id: { type: 'id', readonly: true, cat: 'fields.cat.general' },
    created_at: { type: 'datetime', readonly: true, cat: 'fields.cat.general' },
    tags: { type: 'tags', unique: true },
    status: { type: 'select', items: ['status.active', 'status.inactive'] },
    type: { type: 'string' },
    creator: { type: 'schema', schema: Member, external: true, readonly: true, cat: 'fields.cat.general', list: 1 },
    'details.profile': {
      type: 'schema',
      schema: Profile,
      expand: true,
      cat: 'fields.cat.general'
    },
    'details.relationship': {
      type: 'string',
      cat: 'fields.cat.general'
    },
    'details.medical_history': {
      type: 'schema',
      cat: 'fields.cat.general',
      schema: MedicalHistory
    },
    'details.remark': { type: 'string', cat: 'fields.cat.general' }
  };
};

var _lodash = __webpack_require__(1);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _utils = __webpack_require__(3);

var _i18n = __webpack_require__(2);

var _i18n2 = _interopRequireDefault(_i18n);

var _membership = __webpack_require__(14);

var Member = _interopRequireWildcard(_membership);

var _profile = __webpack_require__(44);

var Profile = _interopRequireWildcard(_profile);

var _service_location = __webpack_require__(45);

var ServiceLocation = _interopRequireWildcard(_service_location);

var _emergency_contact = __webpack_require__(59);

var EmergencyContact = _interopRequireWildcard(_emergency_contact);

var _user_experience = __webpack_require__(105);

var UserExperience = _interopRequireWildcard(_user_experience);

var _medical_history = __webpack_require__(104);

var MedicalHistory = _interopRequireWildcard(_medical_history);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 440 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 441 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 442 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 443 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 444 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 445 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 446 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 447 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 448 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 449 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 450 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 451 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 452 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 453 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 454 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 455 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 456 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 457 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 458 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 459 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 460 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 461 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 143,
	"./af.js": 143,
	"./ar": 150,
	"./ar-dz": 144,
	"./ar-dz.js": 144,
	"./ar-kw": 145,
	"./ar-kw.js": 145,
	"./ar-ly": 146,
	"./ar-ly.js": 146,
	"./ar-ma": 147,
	"./ar-ma.js": 147,
	"./ar-sa": 148,
	"./ar-sa.js": 148,
	"./ar-tn": 149,
	"./ar-tn.js": 149,
	"./ar.js": 150,
	"./az": 151,
	"./az.js": 151,
	"./be": 152,
	"./be.js": 152,
	"./bg": 153,
	"./bg.js": 153,
	"./bn": 154,
	"./bn.js": 154,
	"./bo": 155,
	"./bo.js": 155,
	"./br": 156,
	"./br.js": 156,
	"./bs": 157,
	"./bs.js": 157,
	"./ca": 158,
	"./ca.js": 158,
	"./cs": 159,
	"./cs.js": 159,
	"./cv": 160,
	"./cv.js": 160,
	"./cy": 161,
	"./cy.js": 161,
	"./da": 162,
	"./da.js": 162,
	"./de": 165,
	"./de-at": 163,
	"./de-at.js": 163,
	"./de-ch": 164,
	"./de-ch.js": 164,
	"./de.js": 165,
	"./dv": 166,
	"./dv.js": 166,
	"./el": 167,
	"./el.js": 167,
	"./en-au": 168,
	"./en-au.js": 168,
	"./en-ca": 169,
	"./en-ca.js": 169,
	"./en-gb": 170,
	"./en-gb.js": 170,
	"./en-ie": 171,
	"./en-ie.js": 171,
	"./en-nz": 172,
	"./en-nz.js": 172,
	"./eo": 173,
	"./eo.js": 173,
	"./es": 175,
	"./es-do": 174,
	"./es-do.js": 174,
	"./es.js": 175,
	"./et": 176,
	"./et.js": 176,
	"./eu": 177,
	"./eu.js": 177,
	"./fa": 178,
	"./fa.js": 178,
	"./fi": 179,
	"./fi.js": 179,
	"./fo": 180,
	"./fo.js": 180,
	"./fr": 183,
	"./fr-ca": 181,
	"./fr-ca.js": 181,
	"./fr-ch": 182,
	"./fr-ch.js": 182,
	"./fr.js": 183,
	"./fy": 184,
	"./fy.js": 184,
	"./gd": 185,
	"./gd.js": 185,
	"./gl": 186,
	"./gl.js": 186,
	"./gom-latn": 187,
	"./gom-latn.js": 187,
	"./he": 188,
	"./he.js": 188,
	"./hi": 189,
	"./hi.js": 189,
	"./hr": 190,
	"./hr.js": 190,
	"./hu": 191,
	"./hu.js": 191,
	"./hy-am": 192,
	"./hy-am.js": 192,
	"./id": 193,
	"./id.js": 193,
	"./is": 194,
	"./is.js": 194,
	"./it": 195,
	"./it.js": 195,
	"./ja": 196,
	"./ja.js": 196,
	"./jv": 197,
	"./jv.js": 197,
	"./ka": 198,
	"./ka.js": 198,
	"./kk": 199,
	"./kk.js": 199,
	"./km": 200,
	"./km.js": 200,
	"./kn": 201,
	"./kn.js": 201,
	"./ko": 202,
	"./ko.js": 202,
	"./ky": 203,
	"./ky.js": 203,
	"./lb": 204,
	"./lb.js": 204,
	"./lo": 205,
	"./lo.js": 205,
	"./lt": 206,
	"./lt.js": 206,
	"./lv": 207,
	"./lv.js": 207,
	"./me": 208,
	"./me.js": 208,
	"./mi": 209,
	"./mi.js": 209,
	"./mk": 210,
	"./mk.js": 210,
	"./ml": 211,
	"./ml.js": 211,
	"./mr": 212,
	"./mr.js": 212,
	"./ms": 214,
	"./ms-my": 213,
	"./ms-my.js": 213,
	"./ms.js": 214,
	"./my": 215,
	"./my.js": 215,
	"./nb": 216,
	"./nb.js": 216,
	"./ne": 217,
	"./ne.js": 217,
	"./nl": 219,
	"./nl-be": 218,
	"./nl-be.js": 218,
	"./nl.js": 219,
	"./nn": 220,
	"./nn.js": 220,
	"./pa-in": 221,
	"./pa-in.js": 221,
	"./pl": 222,
	"./pl.js": 222,
	"./pt": 224,
	"./pt-br": 223,
	"./pt-br.js": 223,
	"./pt.js": 224,
	"./ro": 225,
	"./ro.js": 225,
	"./ru": 226,
	"./ru.js": 226,
	"./sd": 227,
	"./sd.js": 227,
	"./se": 228,
	"./se.js": 228,
	"./si": 229,
	"./si.js": 229,
	"./sk": 230,
	"./sk.js": 230,
	"./sl": 231,
	"./sl.js": 231,
	"./sq": 232,
	"./sq.js": 232,
	"./sr": 234,
	"./sr-cyrl": 233,
	"./sr-cyrl.js": 233,
	"./sr.js": 234,
	"./ss": 235,
	"./ss.js": 235,
	"./sv": 236,
	"./sv.js": 236,
	"./sw": 237,
	"./sw.js": 237,
	"./ta": 238,
	"./ta.js": 238,
	"./te": 239,
	"./te.js": 239,
	"./tet": 240,
	"./tet.js": 240,
	"./th": 241,
	"./th.js": 241,
	"./tl-ph": 242,
	"./tl-ph.js": 242,
	"./tlh": 243,
	"./tlh.js": 243,
	"./tr": 244,
	"./tr.js": 244,
	"./tzl": 245,
	"./tzl.js": 245,
	"./tzm": 247,
	"./tzm-latn": 246,
	"./tzm-latn.js": 246,
	"./tzm.js": 247,
	"./uk": 248,
	"./uk.js": 248,
	"./ur": 249,
	"./ur.js": 249,
	"./uz": 251,
	"./uz-latn": 250,
	"./uz-latn.js": 250,
	"./uz.js": 251,
	"./vi": 252,
	"./vi.js": 252,
	"./x-pseudo": 253,
	"./x-pseudo.js": 253,
	"./yo": 254,
	"./yo.js": 254,
	"./zh-cn": 255,
	"./zh-cn.js": 255,
	"./zh-hk": 74,
	"./zh-hk.js": 74,
	"./zh-tw": 256,
	"./zh-tw.js": 256
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 462;

/***/ }),
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(286),
  /* template */
  __webpack_require__(506),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(460)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(288),
  /* template */
  __webpack_require__(536),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(448)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(289),
  /* template */
  __webpack_require__(512),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(452)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(290),
  /* template */
  __webpack_require__(517),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(459)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(291),
  /* template */
  __webpack_require__(535),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(292),
  /* template */
  __webpack_require__(527),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(461)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(293),
  /* template */
  __webpack_require__(538),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(294),
  /* template */
  __webpack_require__(528),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(295),
  /* template */
  __webpack_require__(515),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(453)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(296),
  /* template */
  __webpack_require__(518),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(297),
  /* template */
  __webpack_require__(503),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(298),
  /* template */
  __webpack_require__(508),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(299),
  /* template */
  __webpack_require__(525),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(456)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(300),
  /* template */
  __webpack_require__(532),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(301),
  /* template */
  __webpack_require__(526),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(302),
  /* template */
  __webpack_require__(534),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(303),
  /* template */
  __webpack_require__(507),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(304),
  /* template */
  __webpack_require__(521),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(305),
  /* template */
  __webpack_require__(520),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(306),
  /* template */
  __webpack_require__(522),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(307),
  /* template */
  __webpack_require__(502),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(308),
  /* template */
  __webpack_require__(531),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(309),
  /* template */
  __webpack_require__(519),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(310),
  /* template */
  __webpack_require__(530),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(313),
  /* template */
  __webpack_require__(511),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(314),
  /* template */
  __webpack_require__(510),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(316),
  /* template */
  __webpack_require__(505),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(445)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(317),
  /* template */
  __webpack_require__(501),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(318),
  /* template */
  __webpack_require__(529),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(447)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(319),
  /* template */
  __webpack_require__(509),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(449)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(320),
  /* template */
  __webpack_require__(513),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(446)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(321),
  /* template */
  __webpack_require__(504),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(451)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(322),
  /* template */
  __webpack_require__(516),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(455)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(323),
  /* template */
  __webpack_require__(524),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 501 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [(_vm.label) ? _c('label', [_vm._v("\n    " + _vm._s(_vm.label) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('input', _vm._b({
    staticClass: "form-control border-input",
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        _vm.$emit('input', $event.target.value)
      }
    }
  }, 'input', _vm.$props, false))])
},staticRenderFns: []}

/***/ }),
/* 502 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm._readonly) ? _c('p', {
    staticClass: "form-control-static"
  }, [_vm._v("\n  " + _vm._s(_vm.get(_vm.find(_vm._options, {
    value: _vm.value
  }), 'label', '')) + "\n")]) : (typeof _vm.spec.items === 'function') ? _c('el-select', {
    staticClass: "select-primary",
    style: (_vm.selectStyle),
    attrs: {
      "name": _vm._name,
      "filterable": !!_vm.spec.search,
      "placeholder": _vm.spec.placeholder,
      "readonly": _vm._readonly,
      "multiple": !!_vm.spec.multi,
      "remote": true,
      "remote-method": _vm.reload,
      "loading": _vm.loading,
      "value-key": _vm.spec.valueKey
    },
    on: {
      "input": _vm.onchange
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, _vm._l((_vm._options), function(option) {
    return _c('el-option', {
      staticClass: "select-primary",
      attrs: {
        "value": option.value,
        "label": option.label
      }
    })
  })) : _c('el-select', {
    staticClass: "select-primary",
    style: (_vm.selectStyle),
    attrs: {
      "name": _vm._name,
      "filterable": !!_vm.spec.search,
      "placeholder": _vm.spec.placeholder,
      "readonly": _vm._readonly,
      "multiple": !!_vm.spec.multi,
      "value-key": _vm.spec.valueKey
    },
    on: {
      "input": _vm.onchange
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, _vm._l((_vm._options), function(option) {
    return _c('el-option', {
      staticClass: "select-primary",
      attrs: {
        "value": option.value,
        "label": option.label
      }
    })
  }))
},staticRenderFns: []}

/***/ }),
/* 503 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('editor', {
    staticClass: "form-control",
    attrs: {
      "name": _vm._name,
      "init": _vm.options
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })
},staticRenderFns: []}

/***/ }),
/* 504 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.sidebarClasses,
    attrs: {
      "data-background-color": _vm.backgroundColor,
      "data-active-color": _vm.activeColor
    }
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('a', {
    staticClass: "simple-text logo-mini",
    attrs: {
      "href": "/"
    }
  }, [_c('div', {
    staticClass: "logo-img"
  }, [_c('img', {
    attrs: {
      "src": _vm.logo,
      "alt": ""
    }
  })])]), _vm._v(" "), _c('a', {
    staticClass: "simple-text logo-normal",
    attrs: {
      "href": "/"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.title) + "\n    ")])]), _vm._v(" "), _c('div', {
    ref: "sidebarScrollArea",
    staticClass: "sidebar-wrapper"
  }, [_vm._t("default"), _vm._v(" "), _c('ul', {
    class: _vm.navClasses
  }, _vm._l((_vm.sidebarLinks), function(link, index) {
    return _c('li', {
      class: {
        active: _vm.isMenuActive(link) || link.active
      }
    }, [(link.children) ? _c('a', {
      attrs: {
        "data-toggle": "collapse",
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          _vm.collapseMenu(index)
        }
      }
    }, [_c('i', {
      class: link.icon
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(link.name) + "\n            "), _c('b', {
      staticClass: "caret"
    })])]) : _vm._e(), _vm._v(" "), (link.children) ? _c('div', {
      attrs: {
        "aria-expanded": "true"
      }
    }, [_c('el-collapse-transition', [_c('ul', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!link.collapsed),
        expression: "!link.collapsed"
      }],
      staticClass: "nav"
    }, _vm._l((link.children), function(subLink, subLinkIndex) {
      return _c(_vm.elementType(subLink), {
        key: subLink.path,
        ref: subLink.name,
        refInFor: true,
        tag: "component",
        class: {
          active: subLink.active
        },
        attrs: {
          "to": subLink.path,
          "tag": "li"
        }
      }, [_c('a', {
        attrs: {
          "href": _vm.elementType(subLink) === 'li' ? subLink.path : '#',
          "target": subLink.target
        }
      }, [_c('span', {
        staticClass: "sidebar-mini"
      }, [_vm._v("\n                       \n                    ")]), _vm._v(" "), _c('span', {
        staticClass: "sidebar-normal"
      }, [(subLink.label) ? _c('span', {
        staticClass: "pull-right label label-success"
      }, [_vm._v(_vm._s(subLink.label))]) : _vm._e(), _vm._v("\n                    " + _vm._s(subLink.name) + "\n                  ")])])])
    }))])], 1) : _c(_vm.elementType(link, false), {
      tag: "component",
      class: {
        active: link.active
      },
      attrs: {
        "to": link.path,
        "target": link.target,
        "href": link.path
      }
    }, [_c('i', {
      class: link.icon
    }), _vm._v(" "), _c('p', [(link.label) ? _c('span', {
      staticClass: "pull-right label label-success"
    }, [_vm._v(_vm._s(link.label))]) : _vm._e(), _vm._v("\n            " + _vm._s(link.name) + "\n          ")])])], 1)
  }))], 2)])
},staticRenderFns: []}

/***/ }),
/* 505 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "n-radio radio",
    class: ("radio-" + _vm.type)
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model),
      expression: "model"
    }],
    attrs: {
      "id": _vm.cbId,
      "type": "radio",
      "disabled": _vm.disabled
    },
    domProps: {
      "checked": _vm.model === true,
      "value": _vm.label,
      "checked": _vm._q(_vm.model, _vm.label)
    },
    on: {
      "__c": function($event) {
        _vm.model = _vm.label
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": _vm.cbId
    }
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 506 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": _vm.idName
    },
    on: {
      "click": _vm.generate
    }
  }, [_vm._t("default", [_vm._v("\n\t\tDownload " + _vm._s(_vm.name) + "\n\t")])], 2)
},staticRenderFns: []}

/***/ }),
/* 507 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.spec.html) ? _c('p', {
    staticClass: "form-control-static",
    domProps: {
      "innerHTML": _vm._s(_vm.value)
    }
  }) : _c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.value))])
},staticRenderFns: []}

/***/ }),
/* 508 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.localKeys), function(local) {
    return _c('div', [(!_vm.spec.present) ? _c('div', {
      staticClass: "text-muted"
    }, [_vm._v(_vm._s(local))]) : _vm._e(), _vm._v(" "), _c(_vm._spec(local).component, {
      key: _vm._spec(local).prop,
      ref: "field",
      refInFor: true,
      tag: "component",
      attrs: {
        "name": _vm._spec(local).prop,
        "spec": _vm._spec(local),
        "model": _vm.model,
        "$parentForm": _vm.$parentForm,
        "rootModel": _vm.rootModel,
        "$rootForm": _vm.$rootForm,
        "readonly": _vm._readonly
      }
    })], 1)
  }))
},staticRenderFns: []}

/***/ }),
/* 509 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav nav-mobile-menu"
  }, [_vm._m(0), _vm._v(" "), _c('drop-down', {
    attrs: {
      "tag": "li",
      "title": "5 Notificaitons",
      "icon": "ti-bell"
    }
  }, [_c('a', {
    staticClass: "dropdown-toggle btn-rotate",
    attrs: {
      "href": "javascript:void(0)",
      "data-toggle": "dropdown"
    },
    slot: "title"
  }, [_c('i', {
    staticClass: "ti-bell"
  }), _vm._v(" "), _c('span', {
    staticClass: "notification"
  }, [_vm._v("5")]), _vm._v(" "), _c('p', {
    staticClass: "hidden-md hidden-lg"
  }, [_vm._v("\n        Notifications\n        "), _c('b', {
    staticClass: "caret"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_vm._v("Notification 1")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_vm._v("Notification 2")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_vm._v("Notification 3")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_vm._v("Notification 4")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_vm._v("Another notification")])])]), _vm._v(" "), _vm._m(1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    staticClass: "dropdown-toggle btn-magnify",
    attrs: {
      "href": "javascript:void(0)",
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    staticClass: "ti-panel"
  }), _vm._v(" "), _c('p', [_vm._v("Stats")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    staticClass: "btn-rotate",
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_c('i', {
    staticClass: "ti-settings"
  }), _vm._v(" "), _c('p', {
    staticClass: "hidden-md hidden-lg"
  }, [_vm._v("\n        Settings\n      ")])])])
}]}

/***/ }),
/* 510 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Format")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('el-select', {
    staticClass: "select-primary",
    model: {
      value: (_vm.type),
      callback: function($$v) {
        _vm.type = $$v
      },
      expression: "type"
    }
  }, [_c('el-option', {
    staticClass: "select-primary",
    attrs: {
      "value": "csv",
      "label": "CSV"
    }
  }), _vm._v(" "), _c('el-option', {
    staticClass: "select-primary",
    attrs: {
      "value": "xls",
      "label": "Excel"
    }
  }), _vm._v(" "), _c('el-option', {
    staticClass: "select-primary",
    attrs: {
      "value": "json",
      "label": "JSON"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('div', {
    staticClass: "col-md-1"
  }, [_c('p-checkbox', {
    staticClass: "form-control-static",
    model: {
      value: (_vm.selectAll),
      callback: function($$v) {
        _vm.selectAll = $$v
      },
      expression: "selectAll"
    }
  })], 1), _vm._v(" "), _c('label', {
    staticClass: "col-md-11 control-label",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Select All")])]), _vm._v(" "), _vm._l((_vm.displayColumns), function(name, key) {
    return _c('div', {
      key: key,
      staticClass: "form-group",
      staticStyle: {
        "margin-bottom": "0"
      }
    }, [_c('div', {
      staticClass: "col-md-12"
    }, [_c('div', {
      staticClass: "checkbox form-control-static"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedColumns),
        expression: "selectedColumns"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": key,
        "checked": Array.isArray(_vm.selectedColumns) ? _vm._i(_vm.selectedColumns, key) > -1 : (_vm.selectedColumns)
      },
      on: {
        "__c": function($event) {
          var $$a = _vm.selectedColumns,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = key,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectedColumns = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.selectedColumns = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectedColumns = $$c
          }
        }
      }
    }), _vm._v(" "), _c('label', [_vm._v(_vm._s(name))])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.processing),
      expression: "processing"
    }]
  }, [_c('i', {
    staticClass: "ti-reload ti-spin",
    staticStyle: {
      "font-size": "large"
    }
  }), _vm._v("\n    " + _vm._s(_vm.processing) + "\n    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "disabled": _vm.processing
    },
    on: {
      "click": _vm.downloadData
    }
  }, [_vm._v("\n      " + _vm._s(_vm.i18n.fr('action.download')) + "\n    ")]), _vm._v(" "), _c('json-excel', {
    ref: "downloadButton",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "data": _vm.data,
      "fields": _vm.fields_,
      "type": _vm.type,
      "name": 'export.' + _vm.type,
      "disabled": _vm.processing
    }
  })], 1)], 2)
},staticRenderFns: []}

/***/ }),
/* 511 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c(_vm.tag, {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: (_vm.closeDropDown),
      expression: "closeDropDown"
    }],
    tag: "div",
    class: [_vm.getSlideClass, {
      open: _vm.isOpen
    }],
    on: {
      "click": _vm.toggleDropDown
    }
  }, [_vm._t("title", [_c('a', {
    staticClass: "dropdown-toggle btn-rotate",
    attrs: {
      "data-toggle": "dropdown",
      "href": "javascript:void(0)"
    }
  }, [_c('i', {
    class: _vm.icon
  }), _vm._v(" "), _c('p', {
    staticClass: "notification"
  }, [_vm._v(_vm._s(_vm.title) + "\n        "), _c('b', {
    staticClass: "caret"
  })])])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_vm._t("default")], 2)], 2)
},staticRenderFns: []}

/***/ }),
/* 512 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('nav', {
    staticClass: "pull-left"
  }, [_c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "http://www.creative-tim.com"
    }
  }, [_vm._v("\n            Creative Tim\n          ")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://blog.creative-tim.com"
    }
  }, [_vm._v("\n            Blog\n          ")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://www.creative-tim.com/license"
    }
  }, [_vm._v("\n            Licenses\n          ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "copyright pull-right"
  }, [_vm._v("\n      © Coded with\n      "), _c('i', {
    staticClass: "fa fa-heart heart"
  }), _vm._v(" by\n      "), _c('a', {
    attrs: {
      "href": "https://github.com/cristijora",
      "target": "_blank"
    }
  }, [_vm._v("Cristi Jora")]), _vm._v(".\n      Designed by "), _c('a', {
    attrs: {
      "href": "https://www.creative-tim.com/?ref=pdf-vuejs",
      "target": "_blank"
    }
  }, [_vm._v("Creative Tim")]), _vm._v(".\n    ")])])])
}]}

/***/ }),
/* 513 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "moving-arrow",
    style: (_vm.arrowStyle)
  })
},staticRenderFns: []}

/***/ }),
/* 514 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "container",
    staticClass: "row",
    attrs: {
      "tabindex": "1"
    }
  }, [_c('div', {
    class: _vm.embedded ? '' : 'col-md-12 card'
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading || !_vm.schema_),
      expression: "loading || !schema_"
    }],
    attrs: {
      "element-loading-text": _vm.i18n.fr('loading')
    }
  }, [(_vm.schema_) ? _c('div', {
    class: _vm.embedded ? '' : 'card-content row'
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('el-select', {
    staticClass: "select-default",
    attrs: {
      "placeholder": "Per page"
    },
    model: {
      value: (_vm.pagination.perPage),
      callback: function($$v) {
        _vm.pagination.perPage = $$v
      },
      expression: "pagination.perPage"
    }
  }, _vm._l((_vm.pagination.perPageOptions), function(item) {
    return _c('el-option', {
      key: item,
      staticClass: "select-default",
      attrs: {
        "label": item,
        "value": item
      }
    })
  })), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button",
      "title": _vm.i18n.fr('action.reload')
    },
    on: {
      "click": _vm.fetchData
    }
  }, [_c('i', {
    staticClass: "ti-reload",
    class: {
      'ti-spin': _vm.loading
    }
  }), _vm._v("\n            " + _vm._s(_vm.i18n.fr('action.reload')) + "\n          ")]), _vm._v(" "), (_vm.listActions !== false) ? [(typeof _vm.schema_.create === 'function') ? _c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.handleCreate
    }
  }, [_vm._v("\n              " + _vm._s(_vm.i18n.fr('create_schema_$name', {
    name: _vm.schema_.title.call(this, null, _vm.schema_)
  })) + "\n            ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.listActions_), function(btn) {
    return _c('button', {
      staticClass: "btn",
      on: {
        "click": function($event) {
          _vm.handleAction(btn)
        }
      }
    }, [_vm._v("\n              " + _vm._s(_vm.i18n.fr(btn.label)) + "\n            ")])
  })] : _vm._e(), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "text-align": "center",
      "font-size": "1.5em"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.i18n.f('html.loading'))
    }
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 clearfix"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_vm._l((_vm.tableFilters), function(i) {
    return [(typeof i === 'function') ? _c('render', {
      attrs: {
        "render": i
      }
    }) : (i.component) ? _c('render', {
      attrs: {
        "component": i.component,
        "data": i.data
      }
    }) : _vm._e()]
  }), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    ref: "search",
    staticClass: "form-control input-sm",
    attrs: {
      "type": "search",
      "placeholder": _vm.i18n.fr('search_records_placeholder'),
      "aria-controls": "datatables"
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  })])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [(!_vm.hideTable) ? _c('el-table', {
    ref: "table",
    staticClass: "table table-striped table-no-bordered table-hover",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": "",
      "highlight-current-row": _vm.selectable,
      "row-style": _vm.rowStyle,
      "row-class-name": _vm.rowClassName
    },
    on: {
      "row-click": _vm.handleView,
      "sort-change": _vm.sortChanged,
      "filter-change": _vm.filterChanged,
      "selection-change": function (e) { return _vm.$emit('selection-change', e); }
    }
  }, [_c('el-table-column', {
    attrs: {
      "resizable": true
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          attrs: {
            "title": _vm.rowId(scope)
          }
        }, [_vm._v(_vm._s(_vm.rowTitle(scope)))])]
      }
    }])
  }), _vm._v(" "), _vm._l((_vm.displayColumns), function(column) {
    return [(typeof column.display === 'function') ? _c('el-table-column', {
      attrs: {
        "prop": column.prop,
        "column-key": column.prop,
        "label": column.label,
        "resizable": true,
        "filters": _vm.columnFilters[column.prop],
        "filter-method": _vm.columnFilterFn(column),
        "sortable": column.sortable !== false
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('render', {
            attrs: {
              "auto": _vm.renderField(column, scope)
            }
          })]
        }
      }])
    }) : _c('el-table-column', {
      attrs: {
        "prop": column.prop,
        "column-key": column.prop,
        "label": column.label,
        "resizable": true,
        "filters": _vm.columnFilters[column.prop],
        "filter-method": _vm.columnFilterFn(column),
        "sortable": column.sortable !== false
      }
    })]
  })], 2) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 pagination-info"
  }, [_c('p', {
    staticClass: "category"
  }, [_vm._v(_vm._s(_vm.i18n.f('pagination_footer', {
    from: _vm.from + 1,
    to: _vm.to,
    total: _vm.pagination.total
  })))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 clearfix"
  }, [_c('p-pagination', {
    ref: "pagination",
    staticClass: "pull-right",
    attrs: {
      "per-page": _vm.pagination.perPage,
      "total": _vm.pagination.total
    },
    model: {
      value: (_vm.pagination.currentPage),
      callback: function($$v) {
        _vm.pagination.currentPage = $$v
      },
      expression: "pagination.currentPage"
    }
  })], 1)]) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),
/* 515 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.spec.t === 'time') ? _c('el-time-picker', {
    attrs: {
      "name": _vm._name,
      "placeholder": _vm.spec.placeholder,
      "readonly": _vm._readonly,
      "disabled": _vm._readonly
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }) : _c('el-date-picker', {
    attrs: {
      "name": _vm._name,
      "type": _vm.spec.t,
      "placeholder": _vm.spec.placeholder,
      "picker-options": {
        disabledDate: _vm.spec.disabledDate
      },
      "readonly": _vm._readonly,
      "disabled": _vm._readonly
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })
},staticRenderFns: []}

/***/ }),
/* 516 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('a', {
    attrs: {
      "data-toggle": "collapse",
      "href": "javascript:void(0)"
    },
    on: {
      "click": _vm.toggleMenu
    }
  }, [_vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', [_c('el-collapse-transition', [_c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isClosed),
      expression: "!isClosed"
    }],
    staticClass: "nav"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_c('span', {
    staticClass: "sidebar-mini"
  }, [_vm._v("Mp")]), _vm._v(" "), _c('span', {
    staticClass: "sidebar-normal"
  }, [_vm._v("My Profile")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_c('span', {
    staticClass: "sidebar-mini"
  }, [_vm._v("Ep")]), _vm._v(" "), _c('span', {
    staticClass: "sidebar-normal"
  }, [_vm._v("Edit Profile")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_c('span', {
    staticClass: "sidebar-mini"
  }, [_vm._v("S")]), _vm._v(" "), _c('span', {
    staticClass: "sidebar-normal"
  }, [_vm._v("Settings")])])])])])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "photo"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/faces/face-2.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_vm._v("\n           Chet Faker\n           "), _c('b', {
    staticClass: "caret"
  })])
}]}

/***/ }),
/* 517 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('side-bar', {
    attrs: {
      "type": "sidebar",
      "sidebar-links": _vm.$sidebar.sidebarLinks,
      "title": _vm.i18n.fr('application_title')
    }
  }, [_c('form', {
    staticClass: "navbar-form navbar-left navbar-search-form navbar-search-form-mobile",
    attrs: {
      "role": "search"
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-search"
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": "Search..."
    }
  })])]), _vm._v(" "), _c('mobile-menu')], 1), _vm._v(" "), _c('div', {
    staticClass: "main-panel"
  }, [_c('top-navbar'), _vm._v(" "), _c('dashboard-content', {
    nativeOn: {
      "click": function($event) {
        _vm.toggleSidebar($event)
      }
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 518 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-control-static"
  }, [(!_vm._readonly) ? _c('p', [_c('el-button', {
    staticClass: "btn",
    staticStyle: {
      "float": "left",
      "margin-right": "10px"
    },
    on: {
      "click": _vm.add
    }
  }, [_vm._v("\n      " + _vm._s(_vm.i18n.fr(_vm.spec.multi ? 'action.upload' : 'action.upload_replace')) + "\n    ")]), _vm._v(" "), _c('input', {
    ref: "file",
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "type": "file",
      "multiple": _vm.spec.multi,
      "accept": _vm.spec.accept
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.value_), function(id, i) {
    return _c('p', [(!_vm._readonly) ? _c('el-button', {
      staticClass: "btn btn-icon btn-danger",
      on: {
        "click": function($event) {
          _vm.del(i)
        }
      }
    }, [_c('i', {
      staticClass: "ti-close"
    })]) : _vm._e(), _vm._v(" "), _c('a', {
      attrs: {
        "href": _vm.mediaUrl(id),
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(_vm.displayName(id)))])], 1)
  }), _vm._v(" "), (_vm._readonly && _vm.value_.length == 0) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.i18n.fr('html.empty'))
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 519 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._l((_vm.value), function(tag, idx) {
    return _c('el-tag', {
      key: idx,
      attrs: {
        "type": "primary",
        "closable": !_vm._readonly,
        "close-transition": false
      },
      on: {
        "close": function($event) {
          _vm.handleClose(idx)
        }
      }
    }, [_vm._v("\n    " + _vm._s(tag) + "\n  ")])
  }), _vm._v(" "), (!_vm._readonly) ? _c('el-input', {
    staticClass: "input-new-tag",
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.spec.placeholder
    },
    on: {
      "blur": _vm.handleInputConfirm
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.handleInputConfirm($event)
      }
    },
    model: {
      value: (_vm.inputValue),
      callback: function($$v) {
        _vm.inputValue = $$v
      },
      expression: "inputValue"
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 520 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.spec.items), function(item) {
    return _c('p-radio', {
      attrs: {
        "label": typeof item === 'object' ? item.value : item,
        "disabled": _vm._readonly
      },
      model: {
        value: (_vm.value),
        callback: function($$v) {
          _vm.value = $$v
        },
        expression: "value"
      }
    }, [_vm._v(_vm._s(_vm.i18n.fr(typeof item === 'object' ? item.label : item)) + "\n  ")])
  }))
},staticRenderFns: []}

/***/ }),
/* 521 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-control-static"
  }, [_c('router-link', {
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "to": _vm.to
    }
  }, [_vm._v(_vm._s(_vm.link.label))])], 1)
},staticRenderFns: []}

/***/ }),
/* 522 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.spec.external && (_vm.value && _vm.spec.link)) ? _c('router-link', {
    staticClass: "form-control-static",
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "to": _vm.link
    }
  }, [_vm._v(_vm._s(_vm.schemaTitle) + "\n")]) : (_vm.spec.external && (_vm.value && typeof _vm.spec.schema.view === 'function')) ? _c('a', {
    staticClass: "form-control-static",
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": _vm.view
    }
  }, [_vm._v(_vm._s(_vm.schemaTitle) + "\n")]) : (_vm.spec.external) ? _c('p', {
    staticClass: "form-control-static",
    domProps: {
      "innerHTML": _vm._s(_vm.i18n.fr('html.nil'))
    }
  }) : (_vm._readonly && !_vm.value) ? _c('p', {
    staticClass: "form-control-static",
    domProps: {
      "innerHTML": _vm._s(_vm.i18n.fr('html.nil'))
    }
  }) : _c('el-collapse', {
    attrs: {
      "value": _vm.spec.expand ? 'a' : null
    }
  }, [_c('el-collapse-item', {
    staticClass: "sub-schema",
    class: _vm.panelClass,
    attrs: {
      "name": "a"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v(_vm._s(_vm.schemaTitle) + "\n      "), (_vm.value && _vm.spec.link) ? _c('router-link', {
    staticStyle: {
      "display": "block",
      "float": "right",
      "padding": "0 15px"
    },
    attrs: {
      "to": _vm.link
    }
  }, [_c('i', {
    staticClass: "ti-new-window"
  })]) : (_vm.value && typeof _vm.spec.schema.view === 'function') ? _c('a', {
    staticStyle: {
      "display": "block",
      "float": "right",
      "padding": "0 15px"
    },
    attrs: {
      "target": "_blank",
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.view($event)
      }
    }
  }, [_c('i', {
    staticClass: "ti-new-window"
  })]) : _vm._e()], 1), _vm._v(" "), _c('schema-form', {
    ref: "form",
    attrs: {
      "schema": _vm.spec.schema,
      "model": _vm.value,
      "$parentForm": this,
      "rootModel": _vm.rootModel,
      "$rootForm": _vm.$rootForm,
      "readonly": _vm._readonly,
      "showActions": _vm.spec.showActions,
      "embedded": true
    }
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 523 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'nav-open': _vm.$sidebar.showSidebar
    }
  }, [_c('notifications', {
    attrs: {
      "transition-name": "notification-list",
      "transition-mode": "out-in"
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 524 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bootstrap-switch bootstrap-switch-wrapper bootstrap-switch-animate",
    class: _vm.switchClass
  }, [_c('div', {
    staticClass: "bootstrap-switch-container",
    on: {
      "click": function($event) {
        _vm.triggerToggle()
      }
    }
  }, [_c('span', {
    staticClass: "bootstrap-switch-handle-on ",
    class: ("bootstrap-switch-" + _vm.type)
  }, [_vm._t("on", [_vm._v("\n          " + _vm._s(_vm.onText) + "\n      ")])], 2), _vm._v(" "), _c('span', {
    staticClass: "bootstrap-switch-label"
  }), _vm._v(" "), _c('span', {
    staticClass: "bootstrap-switch-handle-off bootstrap-switch-default"
  }, [_vm._t("off", [_vm._v("\n          " + _vm._s(_vm.offText) + "\n      ")])], 2)])])
},staticRenderFns: []}

/***/ }),
/* 525 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.value))])
},staticRenderFns: []}

/***/ }),
/* 526 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-input', {
    attrs: {
      "type": _vm.spec.inputType,
      "name": _vm._name,
      "min": _vm.spec.min,
      "max": _vm.spec.max,
      "maxlength": _vm.spec.maxlength,
      "placeholder": _vm.spec.placeholder,
      "readonly": _vm._readonly
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })
},staticRenderFns: []}

/***/ }),
/* 527 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-control-static"
  }, [(_vm.value && _vm.value.length === 0) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.i18n.fr('html.empty'))
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm._specs), function(_spec, i) {
    return _c('div', {
      staticStyle: {
        "margin-bottom": ".5em"
      }
    }, [(!_vm._readonly && _vm.spec.delete) ? _c('button', {
      staticClass: "btn btn-icon btn-danger",
      staticStyle: {
        "float": "left"
      },
      attrs: {
        "disabled": typeof _vm.spec.min === 'number' && _vm.value.length <= _vm.spec.min,
        "type": "button",
        "title": _vm.i18n.fr('action.delete')
      },
      on: {
        "click": function($event) {
          _vm.del(_spec.idx)
        }
      }
    }, [_c('i', {
      staticClass: "ti-minus"
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      style: ({
        'margin-left': _vm.spec.delete ? '44px' : 0
      })
    }, [(!_vm.spec.present) ? _c('div', [_vm._v(_vm._s(_vm.i18n.fr('fields.array_item_$i', {
      i: i + 1
    })))]) : _vm._e(), _vm._v(" "), _c(_vm.spec.itemType.component, {
      key: _spec.spec.prop,
      ref: "fields",
      refInFor: true,
      tag: "component",
      staticStyle: {
        "padding-top": "0"
      },
      attrs: {
        "name": _spec.spec.prop,
        "spec": _spec.spec,
        "model": _vm.value,
        "$parentForm": this,
        "rootModel": _vm.rootModel,
        "$rootForm": _vm.$rootForm,
        "readonly": _vm._readonly
      }
    }), _vm._v(" "), _c('small', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.validator.errors.has(String(_spec.idx))),
        expression: "validator.errors.has(String(_spec.idx))"
      }],
      staticClass: "text-danger"
    }, [_vm._v("\n        " + _vm._s(_vm.validator.errors.first(String(_spec.idx))) + "\n      ")])], 1)])
  }), _vm._v(" "), (!_vm._readonly && _vm.spec.add && !(typeof _vm.spec.max === 'number' && _vm.value.length >= _vm.spec.max)) ? _c('button', {
    staticClass: "btn btn-icon btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.add
    }
  }, [_c('i', {
    staticClass: "ti-plus"
  }), _vm._v("\n    " + _vm._s(_vm.i18n.fr('action.add')) + "\n  ")]) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 528 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p-checkbox', {
    attrs: {
      "name": _vm._name,
      "disabled": _vm._readonly
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })
},staticRenderFns: []}

/***/ }),
/* 529 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "pagination",
    class: _vm.paginationClass
  }, [_c('li', {
    staticClass: "page-item",
    class: {
      disabled: _vm.value === 1
    },
    on: {
      "click": _vm.prevPage
    }
  }, [_vm._m(0)]), _vm._v(" "), _vm._l((_vm.range(_vm.minPage, _vm.maxPage)), function(item) {
    return _c('li', {
      staticClass: "page-item",
      class: {
        active: _vm.value === item
      }
    }, [_c('a', {
      staticClass: "page-link",
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          _vm.changePage(item)
        }
      }
    }, [_vm._v(_vm._s(item))])])
  }), _vm._v(" "), _c('li', {
    staticClass: "page-pre",
    class: {
      disabled: _vm.value === _vm.totalPages
    }
  }, [_c('a', {
    staticClass: "page-link",
    attrs: {
      "href": "javascript:void(0)",
      "aria-label": "Next"
    },
    on: {
      "click": _vm.nextPage
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-link",
    attrs: {
      "href": "javascript:void(0)",
      "aria-label": "Previous"
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-left",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}

/***/ }),
/* 530 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value),
      expression: "value"
    }],
    staticClass: "form-control",
    attrs: {
      "name": _vm._name,
      "placeholder": _vm.spec.placeholder,
      "readonly": _vm._readonly
    },
    domProps: {
      "value": (_vm.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.value = $event.target.value
      }
    }
  })
},staticRenderFns: []}

/***/ }),
/* 531 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-collapse', [_c('el-collapse-item', {
    staticClass: "sub-schema",
    attrs: {
      "title": _vm.title
    }
  }, [_c('schema-table', {
    ref: "table",
    attrs: {
      "schema": _vm.spec.schema,
      "initialFilter": _vm.filter,
      "embedded": true
    },
    on: {
      "dataChanged": _vm.dataChanged
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 532 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-control-static"
  }, [(!_vm._readonly) ? _c('p', [_c('el-button', {
    staticClass: "btn",
    staticStyle: {
      "float": "left",
      "margin-right": "10px"
    },
    on: {
      "click": _vm.add
    }
  }, [_vm._v("\n      " + _vm._s(_vm.i18n.fr(_vm.spec.multi ? 'action.upload' : 'action.upload_replace')) + "\n    ")]), _vm._v(" "), _c('input', {
    ref: "file",
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "type": "file",
      "multiple": _vm.spec.multi,
      "accept": _vm.spec.accept || 'image/*'
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.value_), function(id, i) {
    return _c('p', [(!_vm._readonly) ? _c('el-button', {
      staticClass: "btn btn-icon btn-danger",
      on: {
        "click": function($event) {
          _vm.del(i)
        }
      }
    }, [_c('i', {
      staticClass: "ti-close"
    })]) : _vm._e(), _vm._v(" "), _c('a', {
      attrs: {
        "href": _vm.mediaUrl(id, 'original'),
        "target": "_blank"
      }
    }, [_c('img', {
      staticStyle: {
        "max-height": "200px"
      },
      attrs: {
        "src": _vm.mediaUrl(id),
        "alt": _vm.filename(id),
        "title": _vm.displayName(id)
      }
    }), _vm._v(" \n    ")])], 1)
  }), _vm._v(" "), (_vm._readonly && _vm.value_.length == 0) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.i18n.fr('html.empty'))
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 533 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      card: !_vm.embedded
    },
    style: (_vm.$rootForm ? {} : {
      'min-width': '40vw'
    })
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [(_vm.heading || !_vm.embedded) ? _c('div', {
    class: {
      'card-header': !_vm.embedded, clearfix: true
    }
  }, [(!_vm.embedded) ? _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button",
      "title": _vm.i18n.fr('action.undo'),
      "disabled": _vm.processing
    },
    on: {
      "click": _vm.undo
    }
  }, [_c('i', {
    staticClass: "ti-back-right"
  }), _vm._v("\n          " + _vm._s(_vm.i18n.fr('action.undo')) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button",
      "title": _vm.i18n.fr('action.reload'),
      "disabled": _vm.processing
    },
    on: {
      "click": _vm.reload
    }
  }, [_c('i', {
    staticClass: "ti-reload",
    class: {
      'ti-spin': _vm.loading
    }
  }), _vm._v("\n          " + _vm._s(_vm.i18n.fr('action.reload')) + "\n        ")])]) : _vm._e(), _vm._v(" "), (_vm.heading) ? _c('h4', {
    staticClass: "card-title"
  }, [_vm._v(_vm._s(_vm.heading))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    class: {
      'card-content': !_vm.embedded
    },
    attrs: {
      "element-loading-text": _vm.i18n.fr('loading')
    }
  }, [(_vm.currentModel) ? [(_vm.categorizedColumns.length == 1) ? _vm._l((_vm.displayColumns), function(col) {
    return _c('div', {
      key: col.prop,
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "col-md-2 control-label"
    }, [_vm._v(_vm._s(col.label))]), _vm._v(" "), _c('div', {
      staticClass: "col-md-10"
    }, [_c(col.component, {
      ref: "fields",
      refInFor: true,
      tag: "component",
      attrs: {
        "name": col.prop,
        "spec": col,
        "model": _vm.currentModel,
        "$parentForm": _vm.$parentForm || _vm.self,
        "$rootForm": _vm.$rootForm || _vm.self,
        "rootModel": _vm.rootModel || _vm.currentModel,
        "readonly": _vm.readonly || col.readonly
      }
    }), _vm._v(" "), (_vm.validator.errors.has(col.prop)) ? _c('p', {
      staticClass: "text-danger"
    }, [_vm._v("\n                " + _vm._s(_vm.validator.errors.first(col.prop)) + "\n              ")]) : _vm._e()], 1)])
  }) : (_vm.categorizedColumns.length > 1) ? _c('vue-tabs', {
    ref: "tabs",
    on: {
      "tab-change": _vm.tabChanged
    }
  }, _vm._l((_vm.categorizedColumns), function(x) {
    return _c('v-tab', {
      attrs: {
        "title": x.title,
        "id": x.key
      }
    }, _vm._l((x.columns), function(col) {
      return _c('div', {
        key: col.prop,
        staticClass: "form-group"
      }, [_c('label', {
        staticClass: "col-md-2 control-label"
      }, [_vm._v(_vm._s(col.label))]), _vm._v(" "), _c('div', {
        staticClass: "col-md-10 control-content"
      }, [_c(col.component, {
        ref: "fields",
        refInFor: true,
        tag: "component",
        attrs: {
          "name": col.prop,
          "spec": col,
          "model": _vm.currentModel,
          "$parentForm": _vm.$parentForm || _vm.self,
          "$rootForm": _vm.$rootForm || _vm.self,
          "rootModel": _vm.rootModel || _vm.currentModel,
          "readonly": _vm.readonly || col.readonly
        }
      }), _vm._v(" "), (_vm.validator.errors.has(col.prop)) ? _c('p', {
        staticClass: "text-danger"
      }, [_vm._v("\n                  " + _vm._s(_vm.validator.errors.first(col.prop)) + "\n                ")]) : _vm._e()], 1)])
    }))
  })) : _vm._e()] : _c('h3', {
    staticStyle: {
      "text-align": "center"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.i18n.fr('html.not_found'))
    }
  })], 2), _vm._v(" "), (!_vm.loading && _vm.currentModel && _vm.showActions && _vm.formActions) ? _c('div', {
    staticClass: "text-right",
    class: {
      'card-footer': !_vm.embedded
    }
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.processing),
      expression: "processing"
    }],
    staticClass: "ti-reload ti-spin",
    staticStyle: {
      "font-size": "large"
    }
  }), _vm._v(" "), _vm._l((_vm.formActions), function(act, i) {
    return [_c('button', {
      staticClass: "btn btn-fill btn-wd",
      class: act.class,
      attrs: {
        "type": "button",
        "disabled": _vm.processing
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.handleAction(act, String(i))
        }
      }
    }, [_c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.processing === String(i)),
        expression: "processing === String(i)"
      }],
      staticClass: "ti-reload ti-spin"
    }), _vm._v("\n          " + _vm._s(act.label) + "\n        ")]), _vm._v(" \n      ")]
  })], 2) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 534 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    ref: "editor",
    staticClass: "form-control",
    staticStyle: {
      "height": "300px"
    },
    attrs: {
      "readonly": _vm._readonly
    }
  }), _vm._v(" "), _c('div', [(!_vm._readonly) ? _c('button', {
    staticClass: "btn btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.reformat
    }
  }, [_vm._v("\n      " + _vm._s(_vm.i18n.fr('action.reformat_code')) + "\n    ")]) : _vm._e()]), _vm._v(" "), (_vm.err) ? _c('div', {
    staticClass: "text-danger"
  }, [_c('i', {
    staticClass: "ti ti-alert"
  }), _vm._v(_vm._s(_vm.err.message))]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 535 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navbar navbar-default"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "navbar-minimize"
  }, [_c('button', {
    staticClass: "btn btn-fill btn-icon",
    on: {
      "click": _vm.minimizeSidebar
    }
  }, [_c('i', {
    class: _vm.$sidebar.isMinimized ? 'ti-menu-alt' : 'ti-more-alt'
  })])]), _vm._v(" "), _c('div', {
    staticClass: "navbar-header"
  }, [_c('button', {
    staticClass: "navbar-toggle",
    class: {
      toggled: _vm.$sidebar.showSidebar
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toggleSidebar
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('span', {
    staticClass: "icon-bar bar1"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar bar2"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar bar3"
  })]), _vm._v(" "), _c('a', {
    staticClass: "navbar-brand"
  }, [_vm._v(_vm._s(_vm.routeName))])]), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse"
  }, [_c('form', {
    staticClass: "navbar-form navbar-left navbar-search-form",
    attrs: {
      "role": "search"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.doSearch($event)
      }
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": _vm.i18n.fr('search_placeholder')
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [_c('li', [_c('a', [_vm._v("Build: "), _c('strong', [_vm._v(_vm._s(_vm.version.version))]), _vm._v(" "), _c('small', [_vm._v("(" + _vm._s(_vm.version.time) + ")")]), _vm._v(" "), (_vm.debug) ? _c('small', {
    staticClass: "label label-danger"
  }, [_vm._v("dev")]) : _vm._e()])]), _vm._v(" "), _c('drop-down', {
    attrs: {
      "tag": "li"
    }
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "data-toggle": "dropdown",
      "href": "javascript:void(0)"
    },
    slot: "title"
  }, [_c('i', {
    staticClass: "ti-bell"
  }), _vm._v(" "), (_vm.sumBy(_vm.$store.state.notifications, 'count')) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("\n              " + _vm._s(_vm.sumBy(_vm.$store.state.notifications, 'count')) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "notification"
  }, [_c('b', {
    staticClass: "caret"
  })])]), _vm._v(" "), _vm._l((_vm.$store.state.notifications), function(n) {
    return _c('li', [_c('router-link', {
      staticStyle: {
        "padding-right": "50px"
      },
      attrs: {
        "to": n.link
      }
    }, [(n.count) ? _c('span', {
      staticClass: "label label-success",
      staticStyle: {
        "position": "absolute",
        "right": "10px"
      }
    }, [_vm._v(_vm._s(n.count))]) : _vm._e(), _vm._v("\n              " + _vm._s(_vm.i18n.fr(n.title)) + "\n            ")])], 1)
  })], 2), _vm._v(" "), _c('drop-down', {
    attrs: {
      "tag": "li",
      "title": "Language",
      "icon": "ti-world"
    }
  }, _vm._l((_vm.i18n.lang), function(x, l) {
    return _c('li', [_c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          _vm.changeLocal(l)
        }
      }
    }, [_vm._v(_vm._s(l.toUpperCase()))])])
  }))], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])
}]}

/***/ }),
/* 536 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 537 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "checkbox",
    class: _vm.inlineClass
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model),
      expression: "model"
    }],
    attrs: {
      "id": _vm.cbId,
      "type": "checkbox",
      "disabled": _vm.disabled
    },
    domProps: {
      "checked": _vm.model === true,
      "checked": Array.isArray(_vm.model) ? _vm._i(_vm.model, null) > -1 : (_vm.model)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.model,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": _vm.cbId
    }
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 538 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-control-static"
  }, _vm._l((_vm._actions), function(b, idx) {
    return _c('el-button', {
      staticClass: "btn",
      class: b.class,
      on: {
        "click": function($event) {
          _vm.click(b, idx)
        }
      }
    }, [_vm._v("\n    " + _vm._s(_vm.isArray(b.label) ? _vm.i18n.fr.apply(_vm.i18n, b.label) : _vm.i18n.fr(b.label)) + "\n    "), (_vm.processing === idx) ? _c('i', {
      staticClass: "ti-reload ti-spin"
    }) : _vm._e()])
  }))
},staticRenderFns: []}

/***/ }),
/* 539 */,
/* 540 */,
/* 541 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 542 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[328]);


// WEBPACK FOOTER //
// static/js/app.f80ba13a0aae4f10dfbf.js